import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/web.timers.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16;

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { handle, ORDER_TYPES, formatDate, formatAMPM, PlatformType, GeoFenceNotificationRegionState, toInteger, getEnvProps, WEB_LOCATION_SEARCH_TAB_NAMES, CurbsideCheckinSource, getDateInSuperScriptForm, WEB_LOCATION_SEARCH_THREE_TAB_NAMES } from "@dp/common";
import DPServices, { UserTypes } from "@dp/services";
import { action, computed, makeObservable, observable, reaction, runInAction } from "mobx";
import moment from "moment";
import Base from "./Base";
import { TimeModel, UnavailableItemsModel } from "./models";
import CartModel from "./models/CartModel";
import BreadSticksModel from "./models/BreadSticksModel";
import MenuDetailModel from "./models/MenuDetailModel";
import MenuItemDetail from "./models/MenuItemDetail";
import MenuListModel from "./models/MenuListModel";
import OrderHistoryModel from "./models/OrderHistoryModel";
import OrderSettingsModel, { ORDER_TYPE } from "./models/OrderSettingsModel";
import SearchModel from "./models/SearchModel";
import { fetchDistances } from "../utils/common";
import orderBy from "lodash/orderBy";
import i18next from "i18next";
import Errors, { ERROR_STRINGS } from "./Errors";
export var FETCH_TIME_TYPE;

(function (FETCH_TIME_TYPE) {
  FETCH_TIME_TYPE["PICKUP_FLOW"] = "pickup-flow";
  FETCH_TIME_TYPE["NEW_LOCATION"] = "new-location";
  FETCH_TIME_TYPE["USER_ACTION"] = "user-action";
  FETCH_TIME_TYPE["DINE_IN_FLOW"] = "dine-in-flow";
  FETCH_TIME_TYPE["PICKUP_SWITCH"] = "delivery-or-dipo-to-pickup";
})(FETCH_TIME_TYPE || (FETCH_TIME_TYPE = {}));

var MenuList = (_class = /*#__PURE__*/function (_Base) {
  _inherits(MenuList, _Base);

  var _super = _createSuper(MenuList); // @observable
  // private _cartItemCount: number = null;
  // @observable
  // private _isLocationConfirmed: boolean = null;


  function MenuList(rootStore) {
    var _this;

    var fromConfirmation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var fromRestDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var fromLocationSearch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    _classCallCheck(this, MenuList);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "menuListModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "orderHistoryModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "orderSettingsModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "timeModel", null);

    _defineProperty(_assertThisInitialized(_this), "menuDetailModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "breadSticksModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "cartModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "menuEditModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "menuQuickAddModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "searchModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "fromConfirmation", void 0);

    _defineProperty(_assertThisInitialized(_this), "fromRestDetails", void 0);

    _defineProperty(_assertThisInitialized(_this), "fromLocationSearch", void 0);

    _defineProperty(_assertThisInitialized(_this), "unavailableItemsModel", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "menu", _descriptor, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "appAttributes", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_currentConceptCode", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "loading", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_locationData", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isReorderAddToCart", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isReorderAddAllToCart", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_menuList", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_showHeaderHamburgerMenu", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isCartShown", _descriptor10, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_restaurantDetail", void 0);

    _defineProperty(_assertThisInitialized(_this), "_recommendation", void 0);

    _defineProperty(_assertThisInitialized(_this), "_unavailableItems", void 0);

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "_showGeoFenceAlert", _descriptor11, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_locationTimeExplicitlySelected", _descriptor12, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_restaurantSearchResults", _descriptor13, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_userProfileCallsInProgress", false);

    _initializerDefineProperty(_assertThisInitialized(_this), "_showSearchThisArea", _descriptor14, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_unAvailableMessage", null);

    _defineProperty(_assertThisInitialized(_this), "_productAvailableStartDate", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "_byPassGeofenceOrderStatus", _descriptor15, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_userUniqueId", _descriptor16, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "processRestaurantCurrentDayOPHours", function (restaurantDetails) {
      var currentDay = restaurantDetails.currentDay;
      var daysOfWeeks = restaurantDetails.daysOfWeeks;

      if (daysOfWeeks) {
        var currentDayIdx = daysOfWeeks.reduce(function (res, dayOfWeek, idx) {
          if (dayOfWeek.toUpperCase() === currentDay.toUpperCase()) {
            res = idx + 1; // array idx + 1
          }

          return res;
        }, -1);
        restaurantDetails.currentDaySeq = currentDayIdx;
      }

      var weeklyHours = restaurantDetails.weeklyHours;

      if (weeklyHours) {
        var operatingHours = weeklyHours.filter(function (weeklyHour) {
          return weeklyHour.hourCode === "OP";
        });

        if (restaurantDetails.currentDaySeq) {
          var currentDayOPHours = operatingHours.filter(function (operatingHour) {
            return operatingHour.dayOfWeek === restaurantDetails.currentDaySeq;
          });

          if (currentDayOPHours && currentDayOPHours.length > 0) {
            var _currentDayOPHours$0$, _currentDayOPHours$0$2;

            restaurantDetails.currentDayHours = {
              startTime: (_currentDayOPHours$0$ = currentDayOPHours[0].startTime) === null || _currentDayOPHours$0$ === void 0 ? void 0 : _currentDayOPHours$0$.replace(/[AP]/, " $&"),
              endTime: (_currentDayOPHours$0$2 = currentDayOPHours[0].endTime) === null || _currentDayOPHours$0$2 === void 0 ? void 0 : _currentDayOPHours$0$2.replace(/[AP]/, " $&")
            };
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validateSessionRequestedPickupTime", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sessionDetails) {
        var _sessionDetails$succe, _sessionDetails$succe2, _sessionDetails$succe3, _this$menuListModel, sessionContext, resturantId, orderType, isTogo, _sessionDetails$succe4, _sessionDetails$succe5, _sessionDetails$succe6, _sessionDetails$succe7, isInvalidTime, _this$timeModel, _this$timeModel$avail, startTimeInMs, startTimeInMsDate, _this$appMessages;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                sessionContext = sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$succe = sessionDetails.successResponse) === null || _sessionDetails$succe === void 0 ? void 0 : _sessionDetails$succe.sessionContext;
                resturantId = sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$succe2 = sessionDetails.successResponse) === null || _sessionDetails$succe2 === void 0 ? void 0 : (_sessionDetails$succe3 = _sessionDetails$succe2.restaurantDetails) === null || _sessionDetails$succe3 === void 0 ? void 0 : _sessionDetails$succe3.restaurantId;
                orderType = ((_this$menuListModel = _this.menuListModel) === null || _this$menuListModel === void 0 ? void 0 : _this$menuListModel.orderType) || (sessionContext === null || sessionContext === void 0 ? void 0 : sessionContext.orderTypeValue);
                isTogo = orderType === ORDER_TYPES.TOGO_PICKUP || orderType === ORDER_TYPES.CATERING_PICKUP;

                if (!(sessionContext !== null && sessionContext !== void 0 && sessionContext.orderId)) {
                  _context.next = 22;
                  break;
                } // QUETY what to use requestedPickupTime / actualPickupDateTime from session


                console.log("*** actualPicktime ".concat(sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$succe4 = sessionDetails.successResponse) === null || _sessionDetails$succe4 === void 0 ? void 0 : (_sessionDetails$succe5 = _sessionDetails$succe4.actualPickupTime) === null || _sessionDetails$succe5 === void 0 ? void 0 : _sessionDetails$succe5.time));
                isInvalidTime = moment(sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$succe6 = sessionDetails.successResponse) === null || _sessionDetails$succe6 === void 0 ? void 0 : (_sessionDetails$succe7 = _sessionDetails$succe6.actualPickupTime) === null || _sessionDetails$succe7 === void 0 ? void 0 : _sessionDetails$succe7.time).isSameOrBefore(moment().valueOf()) && (orderType === ORDER_TYPE.CATERING_PICKUP || orderType === ORDER_TYPE.TOGO_PICKUP);
                console.log("*** isInvalidTime ".concat(isInvalidTime));

                if (!(isInvalidTime && resturantId && isTogo && sessionContext !== null && sessionContext !== void 0 && sessionContext.itemCount)) {
                  _context.next = 20;
                  break;
                }

                console.log("*** inside block ".concat(isInvalidTime));
                _context.next = 13;
                return _this.fetchTimes(false, null, null, null, resturantId);

              case 13:
                startTimeInMs = (_this$timeModel = _this.timeModel) === null || _this$timeModel === void 0 ? void 0 : (_this$timeModel$avail = _this$timeModel.availableSlots[0]) === null || _this$timeModel$avail === void 0 ? void 0 : _this$timeModel$avail.startTimeInMs;
                console.log("*** startTimeInMs ".concat(startTimeInMs));

                if (!startTimeInMs) {
                  _context.next = 20;
                  break;
                }

                startTimeInMsDate = moment(startTimeInMs).toDate();
                console.log("*** startTimeInMsDate ".concat(startTimeInMsDate));
                _context.next = 20;
                return _this.setOrderPickupTime(startTimeInMsDate);

              case 20:
                _context.next = 22;
                return _this._loadCart();

              case 22:
                _context.next = 27;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](0);
                (_this$appMessages = _this.appMessages) === null || _this$appMessages === void 0 ? void 0 : _this$appMessages.showError("Error", "Error Loading Cart Items");

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 24]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "showSwitchToGoPopupForJW", function (restaurantName, callback) {
      var _assertThisInitialize, _assertThisInitialize2;

      (_assertThisInitialize = _assertThisInitialized(_this)) === null || _assertThisInitialize === void 0 ? void 0 : (_assertThisInitialize2 = _assertThisInitialize.appMessages) === null || _assertThisInitialize2 === void 0 ? void 0 : _assertThisInitialize2.showError(i18next.t("error.title.switch_location_to_togo_for_jw", {
        defaultValue: "Switch Order Type?"
      }), i18next.t("error.subtitle.oa_not_available_for_jw_location", {
        defaultValue: "Order Ahead is not available in the '".concat(restaurantName, "' Location. Joining waitlist will switch your order to a To Go order. Would you like to continue?"),
        interpolation: {
          prefix: "${",
          suffix: "}"
        },
        0: restaurantName
      }), null, {
        okBtnText: i18next.t("error.cta.ok.switch_location_to_togo_for_jw", {
          defaultValue: "YES, CONTINUE"
        }),
        cancelBtnText: i18next.t("error.cta.cancel.switch_location_to_togo_for_jw", {
          defaultValue: "CANCEL"
        }),
        okBtnOnClick: function () {
          var _okBtnOnClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _this.clearCart();

                  case 2:
                    if (callback) {
                      callback();
                    }

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function okBtnOnClick() {
            return _okBtnOnClick.apply(this, arguments);
          }

          return okBtnOnClick;
        }()
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showSwitchToGoPopupForVM", function (restaurantDetails, handleNavigation) {
      var _assertThisInitialize3, _assertThisInitialize4;

      (_assertThisInitialize3 = _assertThisInitialized(_this)) === null || _assertThisInitialize3 === void 0 ? void 0 : (_assertThisInitialize4 = _assertThisInitialize3.appMessages) === null || _assertThisInitialize4 === void 0 ? void 0 : _assertThisInitialize4.showError(i18next.t("error.title.switch_location_to_togo_for_vm", {
        defaultValue: "Switch Order Type?"
      }), i18next.t("error.subtitle.oa_not_available_for_vm_location", {
        defaultValue: "Order Ahead is not available in the '".concat(restaurantDetails.restaurantName, "' Location. View Menu will switch your order to a To Go order. Would you like to continue?"),
        interpolation: {
          prefix: "${",
          suffix: "}"
        },
        0: restaurantDetails.restaurantName
      }), null, {
        okBtnText: i18next.t("error.cta.ok.switch_location_to_togo_for_vm", {
          defaultValue: "YES, CONTINUE"
        }),
        cancelBtnText: i18next.t("error.cta.cancel.switch_location_to_togo_for_vm", {
          defaultValue: "CANCEL"
        }),
        okBtnOnClick: function () {
          var _okBtnOnClick2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            var restaurantId, restaurantNum, viewMenuOnly, isAsapSelected;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    restaurantId = restaurantDetails.restaurantId, restaurantNum = restaurantDetails.restaurantNum, viewMenuOnly = restaurantDetails.viewMenuOnly, isAsapSelected = restaurantDetails.isAsapSelected;
                    _context3.next = 3;
                    return _this.clearCart();

                  case 3:
                    _this.selectRestaurant(restaurantId, restaurantNum, viewMenuOnly, isAsapSelected).then(function (isUpdated) {
                      if (isUpdated) {
                        handleNavigation();
                      }
                    })["catch"](function () {
                      var _this$rootStore, _this$rootStore$appMe; // when we get NPE


                      (_this$rootStore = _this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$appMe = _this$rootStore.appMessages) === null || _this$rootStore$appMe === void 0 ? void 0 : _this$rootStore$appMe.showError(i18next.t("restaurant_update_failure_heading", {
                        defaultValue: "Something Went Wrong"
                      }), i18next.t("restaurant_update_failure_message", {
                        defaultValue: "Unable to change your location"
                      }));
                    });

                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          function okBtnOnClick() {
            return _okBtnOnClick2.apply(this, arguments);
          }

          return okBtnOnClick;
        }()
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showSwitchToGoPopup", function (restaurantDetails, handleNavigation) {
      _this.appMessages.showError(i18next.t("error.title.switch_location_to_togo", {
        defaultValue: "Switch to order ToGo"
      }), i18next.t("error.subtitle.switch_location_to_togo", {
        defaultValue: "would you like to switch your order?"
      }), null, {
        okBtnText: i18next.t("error.cta.ok.start_togo", {
          defaultValue: "YES START A TOGO ORDER"
        }),
        okBtnOnClick: function () {
          var _okBtnOnClick3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
            var restaurantId, restaurantNum, viewMenuOnly, isAsapSelected;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    restaurantId = restaurantDetails.restaurantId, restaurantNum = restaurantDetails.restaurantNum, viewMenuOnly = restaurantDetails.viewMenuOnly, isAsapSelected = restaurantDetails.isAsapSelected;
                    _context4.next = 3;
                    return _this.clearCart();

                  case 3:
                    _this.selectRestaurant(restaurantId, restaurantNum, viewMenuOnly, isAsapSelected).then(function (isUpdated) {
                      if (isUpdated) {
                        handleNavigation();
                      }
                    })["catch"](function () {
                      var _this$rootStore2, _this$rootStore2$appM; // when we get NPE


                      (_this$rootStore2 = _this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$appM = _this$rootStore2.appMessages) === null || _this$rootStore2$appM === void 0 ? void 0 : _this$rootStore2$appM.showError(i18next.t("restaurant_update_failure_heading", {
                        defaultValue: "Something Went Wrong"
                      }), i18next.t("restaurant_update_failure_message", {
                        defaultValue: "Unable to change your location"
                      }));
                    });

                  case 4:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          function okBtnOnClick() {
            return _okBtnOnClick3.apply(this, arguments);
          }

          return okBtnOnClick;
        }(),
        cancelBtnOnClick: function cancelBtnOnClick() {},
        cancelBtnText: i18next.t("error.cta.cancel.keep_order_ahead", {
          defaultValue: "KEEP ORDER AHEAD"
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectRestaurant", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(restaurantId, restaurantNum, viewMenuOnly, isAsapSelected) {
        var setPickupTime,
            fromHeader,
            needToChangePickupTime,
            prevResturantId,
            prevCategories,
            _this$orderSettingsMo,
            _this$rootStore4,
            _this$rootStore4$user,
            _this$orderSettingsMo3,
            _this$orderSettingsMo2,
            _this$rootStore3,
            isPlatformApp,
            isFlowDipo,
            dineInStore,
            _dineInStore$dineInOr,
            _this$timeModel2,
            _this$cartModel,
            _this$_restaurantDeta,
            _this$timeModel3,
            _e$response,
            _this$rootStore5,
            _this$rootStore5$appM,
            _args5 = arguments;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                setPickupTime = _args5.length > 4 && _args5[4] !== undefined ? _args5[4] : false;
                fromHeader = _args5.length > 5 ? _args5[5] : undefined;
                needToChangePickupTime = _args5.length > 6 ? _args5[6] : undefined; //this will cause reactions

                prevResturantId = _this.restaurantId;
                prevCategories = _this.menuListModel.categories;
                _context5.prev = 5;
                (_this$orderSettingsMo = _this.orderSettingsModel) === null || _this$orderSettingsMo === void 0 ? void 0 : _this$orderSettingsMo.setResturantSelectedForChangeId(restaurantId);

                if (!(restaurantId !== prevResturantId)) {
                  _context5.next = 21;
                  break;
                }

                _this.menuListModel.setCategories([]); //TODO: if DIPO then show overlay


                isPlatformApp = _this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP;
                isFlowDipo = ((_this$orderSettingsMo2 = _this.orderSettingsModel) === null || _this$orderSettingsMo2 === void 0 ? void 0 : _this$orderSettingsMo2.orderType) === ORDER_TYPE.ORDER_AHEAD;
                dineInStore = (_this$rootStore3 = _this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : _this$rootStore3.dineInOrder;

                if (!(isFlowDipo && isPlatformApp && dineInStore)) {
                  _context5.next = 16;
                  break;
                }

                dineInStore === null || dineInStore === void 0 ? void 0 : (_dineInStore$dineInOr = dineInStore.dineInOrderModel) === null || _dineInStore$dineInOr === void 0 ? void 0 : _dineInStore$dineInOr.setSwitchFromDineInMessageVisibility(true);
                _context5.next = 21;
                break;

              case 16:
                _context5.next = 18;
                return DPServices.Restaurant.updateLocation(restaurantId, restaurantNum, viewMenuOnly, prevResturantId ? isAsapSelected === undefined || isAsapSelected === null ? (_this$timeModel2 = _this.timeModel) === null || _this$timeModel2 === void 0 ? void 0 : _this$timeModel2.isAsapSelected : false : false, (_this$cartModel = _this.cartModel) !== null && _this$cartModel !== void 0 && _this$cartModel.noOfCartItems ? true : false);

              case 18:
                _this.analyticsModel.dispatchLocationChangedEvent(restaurantId, (_this$_restaurantDeta = _this._restaurantDetail) === null || _this$_restaurantDeta === void 0 ? void 0 : _this$_restaurantDeta.restaurantNum.toString(), prevResturantId, (_this$timeModel3 = _this.timeModel) === null || _this$timeModel3 === void 0 ? void 0 : _this$timeModel3.isAsapSelected);

                _context5.next = 21;
                return _this.storeReset();

              case 21:
                _context5.next = 23;
                return (_this$rootStore4 = _this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$user = _this$rootStore4.user) === null || _this$rootStore4$user === void 0 ? void 0 : _this$rootStore4$user.updateSession();

              case 23:
                _this.orderSettingsModel.showRestaurantSearchModal = false;
                (_this$orderSettingsMo3 = _this.orderSettingsModel) === null || _this$orderSettingsMo3 === void 0 ? void 0 : _this$orderSettingsMo3.setResturantSelectedForChangeId(null);

                if (!setPickupTime) {
                  _context5.next = 28;
                  break;
                }

                _context5.next = 28;
                return _this.setOrderPickupTime();

              case 28:
                _context5.next = 36;
                break;

              case 30:
                _context5.prev = 30;
                _context5.t0 = _context5["catch"](5);

                if (_this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
                  _this.orderSettingsModel.showRestaurantSearchModal = false;
                }

                _this.menuListModel.setCategories(prevCategories); // in the case where we don't get NPE from the API


                if (_context5.t0 !== null && _context5.t0 !== void 0 && _context5.t0.errorResponse || _context5.t0 !== null && _context5.t0 !== void 0 && (_e$response = _context5.t0.response) !== null && _e$response !== void 0 && _e$response.data || _this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) _this.handleOrderError(_context5.t0);else {
                  // when we get NPE
                  (_this$rootStore5 = _this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$appM = _this$rootStore5.appMessages) === null || _this$rootStore5$appM === void 0 ? void 0 : _this$rootStore5$appM.showError(i18next.t("restaurant_update_failure_heading", {
                    defaultValue: "Something Went Wrong"
                  }), i18next.t("restaurant_update_failure_message", {
                    defaultValue: "Unable to change your location"
                  }));
                }
                return _context5.abrupt("return", false);

              case 36:
                _context5.next = 38;
                return _this.saveToMyLocations(restaurantId);

              case 38:
                return _context5.abrupt("return", true);

              case 39:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[5, 30]]);
      }));

      return function (_x2, _x3, _x4, _x5) {
        return _ref2.apply(this, arguments);
      };
    }());

    _this.rootStore = rootStore;
    _this.appMessages = rootStore.appMessages;
    _this.fromConfirmation = fromConfirmation;
    _this.fromRestDetails = fromRestDetails;
    _this.fromLocationSearch = fromLocationSearch;
    _this.menuListModel = new MenuListModel(_this.rootStore.platformUtil);
    _this.orderHistoryModel = new OrderHistoryModel(_this.rootStore.platformUtil);
    _this.orderSettingsModel = new OrderSettingsModel(_this.rootStore.platformUtil);
    _this.timeModel = new TimeModel(_this.rootStore.platformUtil);
    _this.breadSticksModel = new BreadSticksModel();
    _this.menuDetailModel = new MenuDetailModel(_this.rootStore.platformUtil, false);
    _this.menuQuickAddModel = new MenuDetailModel(_this.rootStore.platformUtil, false);
    _this.cartModel = new CartModel(_this.rootStore.platformUtil);
    _this.menuEditModel = new MenuDetailModel(_this.rootStore.platformUtil, true);
    _this.searchModel = new SearchModel(_this.rootStore.platformUtil, _this.rootStore.user.analyticsModel);
    _this.unavailableItemsModel = new UnavailableItemsModel(_this.rootStore.platformUtil);
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MenuList, [{
    key: "marketingCloudVisitorId",
    value: function marketingCloudVisitorId() {
      return this.rootStore.marketingCloudVisitorId();
    }
  }, {
    key: "setLocationData",
    value: function setLocationData(data) {
      var _this2 = this;

      if (data) {
        runInAction(function () {
          _this2._locationData = data;
        });
        this.analyticsModel.dispatchSetLocationDataEvent(this._locationData.coords.latitude, this._locationData.coords.longitude);
      }
    }
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "refresh",
    value: function refresh() {
      return Promise.resolve();
    }
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this3 = this;

      reaction(function () {
        return {
          currentUserLocation: _this3.rootStore.user.currentUserLocation
        };
      }, /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(data) {
          var _this3$orderSettingsM;

          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!(data.currentUserLocation && !_this3.restaurantId && !((_this3$orderSettingsM = _this3.orderSettingsModel) !== null && _this3$orderSettingsM !== void 0 && _this3$orderSettingsM.shouldShowLocationSearchByState))) {
                    _context7.next = 3;
                    break;
                  }

                  _context7.next = 3;
                  return _this3.selectNearestRestaurant();

                case 3:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x6) {
          return _ref3.apply(this, arguments);
        };
      }()); //app-init

      reaction(function () {
        return {
          appAttributes: _this3.rootStore.common.appAttributes
        };
      }, function (data) {
        _this3._processAppAttributes(data.appAttributes);

        _this3.menuListModel.setAppAttributesData(data.appAttributes);

        _this3.menuDetailModel.setAppAttributesData(data.appAttributes);

        _this3.cartModel.setAppAttributesData(data.appAttributes);
      }); //session-details

      reaction(function () {
        return {
          sessionDetails: _this3.rootStore.user.sessionDetails
        };
      }, /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(data) {
          var _data$sessionDetails, _data$sessionDetails$, _data$sessionDetails$2;

          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _this3.menuListModel.setOrderTypeValue(data === null || data === void 0 ? void 0 : (_data$sessionDetails = data.sessionDetails) === null || _data$sessionDetails === void 0 ? void 0 : (_data$sessionDetails$ = _data$sessionDetails.successResponse) === null || _data$sessionDetails$ === void 0 ? void 0 : (_data$sessionDetails$2 = _data$sessionDetails$.sessionContext) === null || _data$sessionDetails$2 === void 0 ? void 0 : _data$sessionDetails$2.orderTypeValue);

                  _this3.menuListModel.setSessionDetails(data.sessionDetails);

                  _context8.next = 4;
                  return _this3._processSessionDetails(data.sessionDetails);

                case 4:
                  _this3.menuDetailModel.setSessionDetails(data.sessionDetails);

                  _this3.orderSettingsModel.setSessionDetails(data.sessionDetails);

                case 6:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x7) {
          return _ref4.apply(this, arguments);
        };
      }()); //user-profile

      reaction(function () {
        return {
          userProfile: _this3.rootStore.user.userProfile,
          isLoggedIn: _this3.rootStore.user.isLoggedIn
        };
      }, /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(data) {
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  if (!data.isLoggedIn) {
                    _context9.next = 3;
                    break;
                  }

                  _context9.next = 3;
                  return _this3._processUserProfile(data.isLoggedIn);

                case 3:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));

        return function (_x8) {
          return _ref5.apply(this, arguments);
        };
      }()); //onRestaurantChange/determination

      reaction(function () {
        var _this3$rootStore, _this3$rootStore$rest;

        return {
          detail: (_this3$rootStore = _this3.rootStore) === null || _this3$rootStore === void 0 ? void 0 : (_this3$rootStore$rest = _this3$rootStore.restaurant) === null || _this3$rootStore$rest === void 0 ? void 0 : _this3$rootStore$rest.detail
        };
      }, /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(data) {
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  if (!(data !== null && data !== void 0 && data.detail)) {
                    _context10.next = 4;
                    break;
                  }

                  _this3.locationTimeExplicitlySelected = false;
                  _context10.next = 4;
                  return _this3.processSelectedRestaurant(data === null || data === void 0 ? void 0 : data.detail);

                case 4:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }));

        return function (_x9) {
          return _ref6.apply(this, arguments);
        };
      }());
      reaction(function () {
        var _this3$orderSettingsM2;

        return {
          showRestaurantSearchModal: (_this3$orderSettingsM2 = _this3.orderSettingsModel) === null || _this3$orderSettingsM2 === void 0 ? void 0 : _this3$orderSettingsM2.showRestaurantSearchModal
        };
      }, function (data) {
        var _this3$orderSettingsM3;

        (_this3$orderSettingsM3 = _this3.orderSettingsModel) === null || _this3$orderSettingsM3 === void 0 ? void 0 : _this3$orderSettingsM3.setShowLocationSettings(true);
      }); // Pickup Time Selection Change

      reaction(function () {
        var _this3$timeModel, _this3$timeModel$curr;

        return {
          startTimeInMs: (_this3$timeModel = _this3.timeModel) === null || _this3$timeModel === void 0 ? void 0 : (_this3$timeModel$curr = _this3$timeModel.currentTimeSlot) === null || _this3$timeModel$curr === void 0 ? void 0 : _this3$timeModel$curr.startTimeInMs
        };
      }, function (data) {
        if (data) {
          var _this3$timeModel2, _this3$timeModel3, _this3$timeModel4, _this3$timeModel5, _this3$timeModel6;

          _this3.menuListModel.setPickupTimeData((_this3$timeModel2 = _this3.timeModel) === null || _this3$timeModel2 === void 0 ? void 0 : _this3$timeModel2.currentTimeSlot);

          _this3.menuListModel.updateMenuItemsAvailabity();

          _this3.orderHistoryModel.setPickupTimeData((_this3$timeModel3 = _this3.timeModel) === null || _this3$timeModel3 === void 0 ? void 0 : _this3$timeModel3.currentTimeSlot);

          _this3.menuEditModel.setPickupTimeData((_this3$timeModel4 = _this3.timeModel) === null || _this3$timeModel4 === void 0 ? void 0 : _this3$timeModel4.currentTimeSlot);

          _this3.menuQuickAddModel.setPickupTimeData((_this3$timeModel5 = _this3.timeModel) === null || _this3$timeModel5 === void 0 ? void 0 : _this3$timeModel5.currentTimeSlot);

          _this3.menuDetailModel.setPickupTimeData((_this3$timeModel6 = _this3.timeModel) === null || _this3$timeModel6 === void 0 ? void 0 : _this3$timeModel6.currentTimeSlot);
        }
      });
      reaction(function () {
        var _this3$orderSettingsM4;

        return {
          showTimeSidebar: (_this3$orderSettingsM4 = _this3.orderSettingsModel) === null || _this3$orderSettingsM4 === void 0 ? void 0 : _this3$orderSettingsM4.showTimeSidebar
        };
      }, /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(data) {
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  if (!(data.showTimeSidebar === true)) {
                    _context11.next = 4;
                    break;
                  }

                  _this3.timeModel.resetTimeModel();

                  _context11.next = 4;
                  return _this3.fetchTimes();

                case 4:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        }));

        return function (_x10) {
          return _ref7.apply(this, arguments);
        };
      }());
      reaction(function () {
        var _this3$orderSettingsM5;

        return {
          showLocationSearchModal: (_this3$orderSettingsM5 = _this3.orderSettingsModel) === null || _this3$orderSettingsM5 === void 0 ? void 0 : _this3$orderSettingsM5.showRestaurantSearchModal
        };
      }, /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(data) {
          var _this3$orderSettingsM6;

          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  if (data.showLocationSearchModal === false) {
                    (_this3$orderSettingsM6 = _this3.orderSettingsModel) === null || _this3$orderSettingsM6 === void 0 ? void 0 : _this3$orderSettingsM6.setFilterTogo(false);
                  }

                case 1:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12);
        }));

        return function (_x11) {
          return _ref8.apply(this, arguments);
        };
      }()); // reaction to make isFavourite

      reaction(function () {
        var _this3$rootStore2, _this3$rootStore2$use, _this3$rootStore2$use2;

        return {
          restaurantSearchResults: _this3.restaurantSearchResults,
          userProfileFavoriteLocation: (_this3$rootStore2 = _this3.rootStore) === null || _this3$rootStore2 === void 0 ? void 0 : (_this3$rootStore2$use = _this3$rootStore2.user) === null || _this3$rootStore2$use === void 0 ? void 0 : (_this3$rootStore2$use2 = _this3$rootStore2$use.userProfile) === null || _this3$rootStore2$use2 === void 0 ? void 0 : _this3$rootStore2$use2.favoriteLocation
        };
      }, function (data) {
        var _this3$rootStore3, _this3$rootStore3$use;

        if (!!((_this3$rootStore3 = _this3.rootStore) !== null && _this3$rootStore3 !== void 0 && (_this3$rootStore3$use = _this3$rootStore3.user) !== null && _this3$rootStore3$use !== void 0 && _this3$rootStore3$use.isLoggedIn)) {
          var _data$userProfileFavo, _data$restaurantSearc, _this3$orderSettingsM7;

          var restaurantSearchResults = [];
          var favouriteLocations = new Set();
          (_data$userProfileFavo = data.userProfileFavoriteLocation) === null || _data$userProfileFavo === void 0 ? void 0 : _data$userProfileFavo.forEach(function (favLocation) {
            var restaurantInfo = favLocation.restaurantInfo;
            favouriteLocations.add(restaurantInfo);
          });
          var restaurantsSearchResultsLength = data === null || data === void 0 ? void 0 : (_data$restaurantSearc = data.restaurantSearchResults) === null || _data$restaurantSearc === void 0 ? void 0 : _data$restaurantSearc.length;

          for (var idx = 0; idx < restaurantsSearchResultsLength; idx++) {
            restaurantSearchResults.push(_objectSpread({}, data.restaurantSearchResults[idx]));
            var restaurantId = restaurantSearchResults[idx].restaurantId;
            restaurantSearchResults[idx].isFavourite = favouriteLocations.has(restaurantId);
          }

          (_this3$orderSettingsM7 = _this3.orderSettingsModel) === null || _this3$orderSettingsM7 === void 0 ? void 0 : _this3$orderSettingsM7.setRestaurantSearchResultsData(restaurantSearchResults);
        } else {
          var _this3$orderSettingsM8;

          (_this3$orderSettingsM8 = _this3.orderSettingsModel) === null || _this3$orderSettingsM8 === void 0 ? void 0 : _this3$orderSettingsM8.setRestaurantSearchResultsData(data.restaurantSearchResults);
        }
      });
    }
  }, {
    key: "processSelectedRestaurant",
    value: function () {
      var _processSelectedRestaurant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(restaurantDetail) {
        var _this$orderSettingsMo4;

        var Phone;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this._restaurantDetail = restaurantDetail;
                this.menuListModel.restaurantHourList = restaurantDetail === null || restaurantDetail === void 0 ? void 0 : restaurantDetail.weeklyHours;
                this.orderSettingsModel.showRestaurantSearchModal = false;
                this.processRestaurantCurrentDayOPHours(restaurantDetail);
                this.orderSettingsModel.setRestaurantDetailData(restaurantDetail);
                this.cartModel.setRestaurantDetailData(restaurantDetail);
                this.analyticsModel.setRestaurantDetailData(restaurantDetail);
                this.breadSticksModel.isBreadCountEnabled = restaurantDetail === null || restaurantDetail === void 0 ? void 0 : restaurantDetail.breadCountEnable; // restPhoneNumber

                Phone = (_this$orderSettingsMo4 = this.orderSettingsModel.currentRestaurant.restPhoneNumber.find(function (item) {
                  return item.useType.toLowerCase() === "primary";
                })) === null || _this$orderSettingsMo4 === void 0 ? void 0 : _this$orderSettingsMo4.Phone;
                this.orderSettingsModel.setRestPhoneNumber(Phone);
                _context13.next = 12;
                return this.fetchTimes(null, null, FETCH_TIME_TYPE.NEW_LOCATION);

              case 12:
                _context13.next = 14;
                return this._loadPageData();

              case 14:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function processSelectedRestaurant(_x12) {
        return _processSelectedRestaurant.apply(this, arguments);
      }

      return processSelectedRestaurant;
    }()
  }, {
    key: "storeReset",
    value: function () {
      var _storeReset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var _this$timeModel4, _this$rootStore6, _this$rootStore7;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this._recommendation = null;
                this.orderSettingsModel.setLocationTimeConfirmData(false);
                this.menuList = null;
                this._unavailableItems = null;
                (_this$timeModel4 = this.timeModel) === null || _this$timeModel4 === void 0 ? void 0 : _this$timeModel4.resetTimeModel();
                _context14.next = 7;
                return (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : _this$rootStore6.platformUtil.clearSessionStorage(["MENU_LIST"]);

              case 7:
                _context14.next = 9;
                return (_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : _this$rootStore7.platformUtil.clearSessionStorage(["UPSELL_CHECKOUT_CONFIRMATION"]);

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function storeReset() {
        return _storeReset.apply(this, arguments);
      }

      return storeReset;
    }()
  }, {
    key: "_processAppAttributes",
    value: function _processAppAttributes(appAttributes) {
      var _this$menuEditModel;

      this.appAttributes = appAttributes;
      this._currentConceptCode = appAttributes === null || appAttributes === void 0 ? void 0 : appAttributes.currentConceptCode;
      this.timeModel.setAppAttributes(appAttributes);
      this.menuListModel.setAttributes(appAttributes);
      this.menuDetailModel.setAppAttributesData(appAttributes);
      this.cartModel.setAppAttributesData(appAttributes);
      (_this$menuEditModel = this.menuEditModel) === null || _this$menuEditModel === void 0 ? void 0 : _this$menuEditModel.setAppAttributesData(appAttributes);
      this.menuQuickAddModel.setAppAttributesData(appAttributes);
      this.orderHistoryModel.setAppAttributesData(appAttributes);
      this.orderSettingsModel.setAppAttributes(appAttributes);
      this.searchModel.setAppAttributesData(appAttributes);
      this.unavailableItemsModel.setAppAttributes(appAttributes);
      this.breadSticksModel.setAppAttributesData(appAttributes);
    }
  }, {
    key: "processSessionLocationConfirmed",
    value: function processSessionLocationConfirmed(sessionContext) {
      var isLocaitonConfirmed = sessionContext === null || sessionContext === void 0 ? void 0 : sessionContext.isToGoLocationConfirmed;
      this.orderSettingsModel.setLocationTimeConfirmData(isLocaitonConfirmed);
    }
  }, {
    key: "processSessionPickupDateTime",
    value: function processSessionPickupDateTime(sessionDetails) {
      var _this$orderSettingsMo5;

      var sessionContext = sessionDetails.sessionContext;
      var isDateTimeSelected = !!(sessionContext !== null && sessionContext !== void 0 && sessionContext.actualPickupDateTime);
      (_this$orderSettingsMo5 = this.orderSettingsModel) === null || _this$orderSettingsMo5 === void 0 ? void 0 : _this$orderSettingsMo5.setPickupDatetimeselected(isDateTimeSelected);

      if (sessionDetails !== null && sessionDetails !== void 0 && sessionDetails.actualPickupTime) {
        var _this$orderSettingsMo6;

        (_this$orderSettingsMo6 = this.orderSettingsModel) === null || _this$orderSettingsMo6 === void 0 ? void 0 : _this$orderSettingsMo6.setPickupDatetimeselected(true);
      }
    }
  }, {
    key: "_checkForUnsupportedOrderTypesForApp",
    value: function () {
      var _checkForUnsupportedOrderTypesForApp2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(sessionDetails) {
        var _sessionDetails$succe8, _sessionDetails$succe9;

        var orderType, isPlatformApp;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                orderType = sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$succe8 = sessionDetails.successResponse) === null || _sessionDetails$succe8 === void 0 ? void 0 : (_sessionDetails$succe9 = _sessionDetails$succe8.sessionContext) === null || _sessionDetails$succe9 === void 0 ? void 0 : _sessionDetails$succe9.orderTypeValue;
                isPlatformApp = this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP;
                _context15.next = 4;
                return this.prepareLocation(sessionDetails);

              case 4:
                if (isPlatformApp && orderType === ORDER_TYPES.CATERING_DELIVERY) {
                  // switch to Pickup if received Delivery/DIPO OrderType
                  this.deliveryToPickupSwitch();
                }

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function _checkForUnsupportedOrderTypesForApp(_x13) {
        return _checkForUnsupportedOrderTypesForApp2.apply(this, arguments);
      }

      return _checkForUnsupportedOrderTypesForApp;
    }()
  }, {
    key: "_processSessionDetails",
    value: function () {
      var _processSessionDetails2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(sessionDetails) {
        var _sessionDetails$succe11, _sessionDetails$succe12, _this$rootStore8, _this$rootStore8$user;

        var _sessionDetails$succe10, _this$rootStore9, _this$rootStore9$user, _this$rootStore9$user2, _this$rootStore10, _this$rootStore10$pla;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                this.timeModel.setSessionDetails(sessionDetails);
                _context16.next = 3;
                return this._checkForUnsupportedOrderTypesForApp(sessionDetails);

              case 3:
                _context16.next = 5;
                return this.validateSessionRequestedPickupTime(sessionDetails);

              case 5:
                this.cartModel.setSessionDetails(sessionDetails);

                if (sessionDetails !== null && sessionDetails !== void 0 && sessionDetails.successResponse) {
                  this.processSessionLocationConfirmed(sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$succe10 = sessionDetails.successResponse) === null || _sessionDetails$succe10 === void 0 ? void 0 : _sessionDetails$succe10.sessionContext);
                  this.processSessionPickupDateTime(sessionDetails === null || sessionDetails === void 0 ? void 0 : sessionDetails.successResponse);
                }

                this.menuListModel.setSessionDetails(sessionDetails);
                this.menuDetailModel.setSessionDetails(sessionDetails);
                this.menuEditModel.setSessionDetails(sessionDetails);
                this.menuQuickAddModel.setSessionDetails(sessionDetails);
                this.orderSettingsModel.setSessionDetails(sessionDetails);
                this.orderSettingsModel.currentOrderType = sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$succe11 = sessionDetails.successResponse) === null || _sessionDetails$succe11 === void 0 ? void 0 : (_sessionDetails$succe12 = _sessionDetails$succe11.sessionContext) === null || _sessionDetails$succe12 === void 0 ? void 0 : _sessionDetails$succe12.orderTypeValue;

                if ((_this$rootStore8 = this.rootStore) !== null && _this$rootStore8 !== void 0 && (_this$rootStore8$user = _this$rootStore8.user) !== null && _this$rootStore8$user !== void 0 && _this$rootStore8$user.isLoggedIn) {
                  this.userUniqueId = (_this$rootStore9 = this.rootStore) === null || _this$rootStore9 === void 0 ? void 0 : (_this$rootStore9$user = _this$rootStore9.user) === null || _this$rootStore9$user === void 0 ? void 0 : (_this$rootStore9$user2 = _this$rootStore9$user.userProfile) === null || _this$rootStore9$user2 === void 0 ? void 0 : _this$rootStore9$user2.userId;
                } else {
                  this.userUniqueId = moment().format() + ((_this$rootStore10 = this.rootStore) === null || _this$rootStore10 === void 0 ? void 0 : (_this$rootStore10$pla = _this$rootStore10.platformUtil) === null || _this$rootStore10$pla === void 0 ? void 0 : _this$rootStore10$pla.randomUniqueId());
                }

              case 14:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function _processSessionDetails(_x14) {
        return _processSessionDetails2.apply(this, arguments);
      }

      return _processSessionDetails;
    }()
  }, {
    key: "_getOrderHistory",
    value: function () {
      var _getOrderHistory2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var orderHistory, cacheOrderHistoryStr;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                orderHistory = null;
                _context17.next = 3;
                return this.rootStore.platformUtil.getFromLocalStorage("ORDER_HISTORY");

              case 3:
                cacheOrderHistoryStr = _context17.sent;

                if (!cacheOrderHistoryStr) {
                  _context17.next = 9;
                  break;
                }

                orderHistory = JSON.parse(cacheOrderHistoryStr);
                return _context17.abrupt("return", orderHistory);

              case 9:
                _context17.next = 11;
                return DPServices.User.getOrderHistory();

              case 11:
                orderHistory = _context17.sent;
                this.rootStore.platformUtil.saveInLocalStorage("ORDER_HISTORY", JSON.stringify(orderHistory));
                return _context17.abrupt("return", orderHistory);

              case 14:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function _getOrderHistory() {
        return _getOrderHistory2.apply(this, arguments);
      }

      return _getOrderHistory;
    }()
  }, {
    key: "_processUserProfile",
    value: function () {
      var _processUserProfile2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(isLoggedIn) {
        var _preferredRestaurant$, orderHistory, _e$response2, _e$response2$data, _yield$this$_getUserF, favorites, preferredRestaurant, restaurantId;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (this._userProfileCallsInProgress) {
                  _context18.next = 39;
                  break;
                }

                this.menuListModel.setUserLoggedInData(isLoggedIn);

                if (!isLoggedIn) {
                  _context18.next = 39;
                  break;
                }

                this._userProfileCallsInProgress = true;
                _context18.prev = 4;
                _context18.next = 7;
                return this._getOrderHistory();

              case 7:
                orderHistory = _context18.sent;
                this.orderHistoryModel.setOrderHistoryData(orderHistory);
                this.analyticsModel.dispatchSetOrderHistoryDataEvent(this.orderHistoryModel.orderHistory);
                _context18.next = 12;
                return this._loadFrequentlyOrderedItem();

              case 12:
                this._userProfileCallsInProgress = false;
                _context18.next = 23;
                break;

              case 15:
                _context18.prev = 15;
                _context18.t0 = _context18["catch"](4);
                this._userProfileCallsInProgress = false;

                if (!( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                ((_e$response2 = _context18.t0.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.fault.faultCode) === "500")) {
                  _context18.next = 22;
                  break;
                }

                return _context18.abrupt("return");

              case 22:
                this.appMessages.showError("Order History", "Unable to load Order History. Please try again.");

              case 23:
                _context18.prev = 23;
                _context18.next = 26;
                return this._getUserFavorites();

              case 26:
                _yield$this$_getUserF = _context18.sent;
                favorites = _yield$this$_getUserF.favorites;
                this.menuListModel.setFavorites(favorites);
                this._userProfileCallsInProgress = false;
                _context18.next = 36;
                break;

              case 32:
                _context18.prev = 32;
                _context18.t1 = _context18["catch"](23);
                this._userProfileCallsInProgress = false;
                console.error(_context18.t1);

              case 36:
                preferredRestaurant = this.processUserPreferredLocations();
                restaurantId = preferredRestaurant === null || preferredRestaurant === void 0 ? void 0 : (_preferredRestaurant$ = preferredRestaurant.preferredRestaurant) === null || _preferredRestaurant$ === void 0 ? void 0 : _preferredRestaurant$.restaurantIdentifier;

                if (restaurantId && !this.restaurantId) {
                  this.selectRestaurant(restaurantId);
                }

              case 39:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[4, 15], [23, 32]]);
      }));

      function _processUserProfile(_x15) {
        return _processUserProfile2.apply(this, arguments);
      }

      return _processUserProfile;
    }()
  }, {
    key: "_getUserFavorites",
    value: function () {
      var _getUserFavorites2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var favorites, favoritesStr, _yield$DPServices$Men, _favorites;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                favorites = null;
                _context19.next = 3;
                return this.rootStore.platformUtil.getFromLocalStorage("FAVORITE_PRODUCTS");

              case 3:
                favoritesStr = _context19.sent;

                if (favoritesStr) {
                  favorites = JSON.parse(favoritesStr);
                }

                if (!favorites) {
                  _context19.next = 9;
                  break;
                }

                return _context19.abrupt("return", favorites);

              case 9:
                _context19.next = 11;
                return DPServices.Menu.getFavorites();

              case 11:
                _yield$DPServices$Men = _context19.sent;
                _favorites = _yield$DPServices$Men.favorites;
                this.rootStore.platformUtil.saveInLocalStorage("FAVORITE_PRODUCTS", JSON.stringify({
                  favorites: _favorites
                }));
                return _context19.abrupt("return", {
                  favorites: _favorites
                });

              case 15:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function _getUserFavorites() {
        return _getUserFavorites2.apply(this, arguments);
      }

      return _getUserFavorites;
    }()
  }, {
    key: "processUserPreferredLocations",
    value: function processUserPreferredLocations() {
      var _this$rootStore11, _this$rootStore11$use, _this$rootStore11$use2;

      var preferredRestaurantList = (_this$rootStore11 = this.rootStore) === null || _this$rootStore11 === void 0 ? void 0 : (_this$rootStore11$use = _this$rootStore11.user) === null || _this$rootStore11$use === void 0 ? void 0 : (_this$rootStore11$use2 = _this$rootStore11$use.userProfile) === null || _this$rootStore11$use2 === void 0 ? void 0 : _this$rootStore11$use2.preferredRestaurantList;
      var siteIds = DPServices.Config.getSiteIds();
      var res = preferredRestaurantList === null || preferredRestaurantList === void 0 ? void 0 : preferredRestaurantList.find(function (el) {
        return el.siteId === siteIds.mobileSiteId || el.siteId === siteIds.siteId;
      });
      return res;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var _this$rootStore12, _this$rootStore12$use, _this$rootStore13, _this$rootStore13$use;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return handle(this.rootStore.platformUtil.hydrateUsingSessionStorage("MENU_LIST_MODEL_INFO", this.menuListModel));

              case 2:
                _context20.next = 4;
                return handle(this.rootStore.platformUtil.hydrateUsingLocalStorage("ORDER_SETTINGS_MODEL_INFO", this.orderSettingsModel));

              case 4:
                this.appMessages = this.rootStore.appMessages;
                this.analyticsModel = (_this$rootStore12 = this.rootStore) === null || _this$rootStore12 === void 0 ? void 0 : (_this$rootStore12$use = _this$rootStore12.user) === null || _this$rootStore12$use === void 0 ? void 0 : _this$rootStore12$use.analyticsModel;
                this.analyticsModel.setReturnWindowDigData(this.fromConfirmation);
                this.populateRecentLocationSearchKeywords();

                this._processAppAttributes(this.rootStore.common.appAttributes);

                this.menuListModel.setSessionDetails(this.rootStore.user.sessionDetails);
                _context20.next = 12;
                return this._processSessionDetails(this.rootStore.user.sessionDetails);

              case 12:
                _context20.next = 14;
                return this._processUserProfile((_this$rootStore13 = this.rootStore) === null || _this$rootStore13 === void 0 ? void 0 : (_this$rootStore13$use = _this$rootStore13.user) === null || _this$rootStore13$use === void 0 ? void 0 : _this$rootStore13$use.isLoggedIn);

              case 14:
                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP)) {
                  _context20.next = 17;
                  break;
                }

                _context20.next = 17;
                return this.fetchRecentOrdersFromLocalStorage();

              case 17:
                this.orderSettingsModel.isFromLocationSearchPage = this.fromLocationSearch;

              case 18:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "prepareLocation",
    value: function () {
      var _prepareLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(session) {
        var _this4 = this;

        var _this$orderSettingsMo7, _session$successRespo, _session$successRespo2, _this$rootStore14, _this$rootStore14$pla, _this$rootStore15, _this$rootStore15$use, _this$rootStore15$use2, shouldShowLocationSearchByState, resturantId, isCookiedLocationLoaded, setRestaurantIfLocationAvailable, userPosition, _this$orderSettingsMo8;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;

                if (!this.escapeLocationSelectionForDIPO) {
                  _context21.next = 3;
                  break;
                }

                return _context21.abrupt("return");

              case 3:
                shouldShowLocationSearchByState = this === null || this === void 0 ? void 0 : (_this$orderSettingsMo7 = this.orderSettingsModel) === null || _this$orderSettingsMo7 === void 0 ? void 0 : _this$orderSettingsMo7.shouldShowLocationSearchByState;
                resturantId = session === null || session === void 0 ? void 0 : (_session$successRespo = session.successResponse) === null || _session$successRespo === void 0 ? void 0 : (_session$successRespo2 = _session$successRespo.restaurantDetails) === null || _session$successRespo2 === void 0 ? void 0 : _session$successRespo2.restaurantId;
                _context21.next = 7;
                return this._loadCookiedLocation(resturantId);

              case 7:
                isCookiedLocationLoaded = _context21.sent;
                setRestaurantIfLocationAvailable = false;

                if (!(((_this$rootStore14 = this.rootStore) === null || _this$rootStore14 === void 0 ? void 0 : (_this$rootStore14$pla = _this$rootStore14.platformUtil) === null || _this$rootStore14$pla === void 0 ? void 0 : _this$rootStore14$pla.PLATFORM_TYPE) === PlatformType.APP && ((_this$rootStore15 = this.rootStore) === null || _this$rootStore15 === void 0 ? void 0 : (_this$rootStore15$use = _this$rootStore15.user) === null || _this$rootStore15$use === void 0 ? void 0 : (_this$rootStore15$use2 = _this$rootStore15$use.foreGroundLocationPermissions) === null || _this$rootStore15$use2 === void 0 ? void 0 : _this$rootStore15$use2.status) !== "denied")) {
                  _context21.next = 20;
                  break;
                }

                userPosition = this.rootStore.user.currentUserLocation;

                if (!userPosition) {
                  _context21.next = 16;
                  break;
                }

                this.setLocationData(userPosition);
                setRestaurantIfLocationAvailable = true;
                _context21.next = 20;
                break;

              case 16:
                _context21.next = 18;
                return this.rootStore.user.obtainUserGeoCoordinates();

              case 18:
                userPosition = this.rootStore.user.currentUserLocation;

                if (userPosition) {
                  this.setLocationData(userPosition);
                  setRestaurantIfLocationAvailable = true;
                }

              case 20:
                if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB && !isCookiedLocationLoaded && this.isLocationSelectionMandatory || setRestaurantIfLocationAvailable) {
                  // Changed await to .then not blocking UI till user permission
                  // after resolving locationData triggers all the computation
                  this.rootStore.user.obtainUserGeoCoordinates().then(function () {
                    _this4.setLocationData(_this4.rootStore.user.currentUserLocation);
                  });
                }

                if (!(isCookiedLocationLoaded || !this.isLocationSelectionMandatory && !setRestaurantIfLocationAvailable)) {
                  _context21.next = 32;
                  break;
                }

                if (isCookiedLocationLoaded) {
                  _context21.next = 27;
                  break;
                }

                _context21.next = 25;
                return this._loadPageData();

              case 25:
                _context21.next = 30;
                break;

              case 27:
                if (!(shouldShowLocationSearchByState && !((_this$orderSettingsMo8 = this.orderSettingsModel) !== null && _this$orderSettingsMo8 !== void 0 && _this$orderSettingsMo8.restaurantSearchResults))) {
                  _context21.next = 30;
                  break;
                }

                _context21.next = 30;
                return this.getAllRestaurants(resturantId);

              case 30:
                _context21.next = 56;
                break;

              case 32:
                if (!shouldShowLocationSearchByState) {
                  _context21.next = 49;
                  break;
                }

                if (!this.fromRestDetails) {
                  _context21.next = 35;
                  break;
                }

                return _context21.abrupt("return");

              case 35:
                if (!this.fromLocationSearch) {
                  _context21.next = 39;
                  break;
                }

                _context21.next = 38;
                return this.getAllRestaurants(resturantId);

              case 38:
                return _context21.abrupt("return");

              case 39:
                if (!(resturantId || this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB)) {
                  _context21.next = 44;
                  break;
                }

                _context21.next = 42;
                return this.getAllRestaurants(resturantId);

              case 42:
                _context21.next = 46;
                break;

              case 44:
                _context21.next = 46;
                return this.selectNearestRestaurant();

              case 46:
                this.orderSettingsModel.showRestaurantSearchModal = true;
                _context21.next = 56;
                break;

              case 49:
                if (!this.fromRestDetails) {
                  _context21.next = 51;
                  break;
                }

                return _context21.abrupt("return");

              case 51:
                _context21.next = 53;
                return this.selectNearestRestaurant();

              case 53:
                if (!(setRestaurantIfLocationAvailable && !this.restaurantId && !isCookiedLocationLoaded)) {
                  _context21.next = 56;
                  break;
                }

                _context21.next = 56;
                return this._loadPageData();

              case 56:
                _context21.next = 60;
                break;

              case 58:
                _context21.prev = 58;
                _context21.t0 = _context21["catch"](0);

              case 60:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this, [[0, 58]]);
      }));

      function prepareLocation(_x16) {
        return _prepareLocation.apply(this, arguments);
      }

      return prepareLocation;
    }()
  }, {
    key: "selectNearestRestaurant",
    value: function () {
      var _selectNearestRestaurant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        var currentUserLocation, coordinates, results, filteredRestaurantArray, selectedResult;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB)) {
                  _context22.next = 2;
                  break;
                }

                return _context22.abrupt("return", Promise.resolve());

              case 2:
                currentUserLocation = this.rootStore.user.currentUserLocation;

                if (!currentUserLocation) {
                  _context22.next = 12;
                  break;
                }

                coordinates = [currentUserLocation.coords.latitude, currentUserLocation.coords.longitude];
                this.setLocationData(currentUserLocation);
                _context22.next = 8;
                return this.searchRestaurants(coordinates);

              case 8:
                results = this.orderSettingsModel.restaurantSearchResults;

                if (results && results.length) {
                  filteredRestaurantArray = results.filter(function (rest) {
                    return rest.onlineTogo;
                  });
                  selectedResult = filteredRestaurantArray[0];
                  this.selectRestaurant(selectedResult.restaurantId);
                } else {
                  this.orderSettingsModel.showRestaurantSearchModal = true;
                }

                _context22.next = 13;
                break;

              case 12:
                this.orderSettingsModel.showRestaurantSearchModal = true;

              case 13:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function selectNearestRestaurant() {
        return _selectNearestRestaurant.apply(this, arguments);
      }

      return selectNearestRestaurant;
    }()
  }, {
    key: "openLocationSearchModal",
    value: function () {
      var _openLocationSearchModal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        var _this$orderSettingsMo9, _this$rootStore16, _this$rootStore16$use, shouldShowLocationSearchByState, searchedLocationDetail, platformIsMobileApp, currentUserLocation, coordinates;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.prev = 0;

                if (!this.fromLocationSearch) {
                  this.orderSettingsModel.showRestaurantSearchModal = true;
                  this.analyticsModel.dispatchDisplayModalEvent("Show location search", "Display the location search modal", "LocationSearchModal", null);
                }

                shouldShowLocationSearchByState = this === null || this === void 0 ? void 0 : (_this$orderSettingsMo9 = this.orderSettingsModel) === null || _this$orderSettingsMo9 === void 0 ? void 0 : _this$orderSettingsMo9.shouldShowLocationSearchByState;

                if (!shouldShowLocationSearchByState) {
                  _context23.next = 5;
                  break;
                }

                return _context23.abrupt("return");

              case 5:
                _context23.next = 7;
                return (_this$rootStore16 = this.rootStore) === null || _this$rootStore16 === void 0 ? void 0 : (_this$rootStore16$use = _this$rootStore16.user) === null || _this$rootStore16$use === void 0 ? void 0 : _this$rootStore16$use.obtainUserGeoCoordinates();

              case 7:
                searchedLocationDetail = this.orderSettingsModel.searchedLocationDetail;
                platformIsMobileApp = this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP;

                if (!(searchedLocationDetail && !platformIsMobileApp)) {
                  _context23.next = 16;
                  break;
                }

                this.orderSettingsModel.locationSearchStringWithoutSearchMode = searchedLocationDetail.searchString;
                this.setLocationData({
                  coords: {
                    latitude: Number(searchedLocationDetail === null || searchedLocationDetail === void 0 ? void 0 : searchedLocationDetail.lat),
                    longitude: Number(searchedLocationDetail === null || searchedLocationDetail === void 0 ? void 0 : searchedLocationDetail["long"]),
                    accuracy: null,
                    altitude: null,
                    altitudeAccuracy: null,
                    heading: null,
                    speed: null
                  },
                  timestamp: Date.now()
                });
                _context23.next = 14;
                return this.searchRestaurantsWithoutDistanceCalculations([Number(searchedLocationDetail === null || searchedLocationDetail === void 0 ? void 0 : searchedLocationDetail.lat), Number(searchedLocationDetail === null || searchedLocationDetail === void 0 ? void 0 : searchedLocationDetail["long"])]);

              case 14:
                _context23.next = 29;
                break;

              case 16:
                currentUserLocation = this.rootStore.user.currentUserLocation;

                if (!currentUserLocation) {
                  _context23.next = 29;
                  break;
                }

                this.setLocationData(currentUserLocation);
                coordinates = [currentUserLocation.coords.latitude, currentUserLocation.coords.longitude];

                if (!this.fromLocationSearch) {
                  this.analyticsModel.dispatchLocationSearchModalEvent(currentUserLocation.coords);
                }

                if (!this.fromLocationSearch) {
                  _context23.next = 27;
                  break;
                }

                this.orderSettingsModel.showYouAreHere = true;
                _context23.next = 25;
                return this.searchRestaurantsWithoutDistanceCalculations(coordinates);

              case 25:
                _context23.next = 29;
                break;

              case 27:
                _context23.next = 29;
                return this.searchRestaurants(coordinates);

              case 29:
                _context23.next = 33;
                break;

              case 31:
                _context23.prev = 31;
                _context23.t0 = _context23["catch"](0);

              case 33:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this, [[0, 31]]);
      }));

      function openLocationSearchModal() {
        return _openLocationSearchModal.apply(this, arguments);
      }

      return openLocationSearchModal;
    }()
  }, {
    key: "_loadCart",
    value: function () {
      var _loadCart2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        var _this5 = this;

        var _yield$handle, _yield$handle2, cartDetailsErr, cartDetailsResponse;

        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.prev = 0;
                _context25.next = 3;
                return handle(DPServices.Cart.getCartDetails());

              case 3:
                _yield$handle = _context25.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                cartDetailsErr = _yield$handle2[0];
                cartDetailsResponse = _yield$handle2[1];

                if (cartDetailsErr) {
                  this.handleOrderError(cartDetailsErr);
                } else {
                  runInAction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
                    var _cartDetailsResponse$;

                    var order;
                    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                      while (1) {
                        switch (_context24.prev = _context24.next) {
                          case 0:
                            order = cartDetailsResponse === null || cartDetailsResponse === void 0 ? void 0 : (_cartDetailsResponse$ = cartDetailsResponse.successResponse) === null || _cartDetailsResponse$ === void 0 ? void 0 : _cartDetailsResponse$.order;

                            if (order) {
                              _this5.cartModel.setCartData(order);

                              _this5.breadSticksModel.cartItems = order === null || order === void 0 ? void 0 : order.commerceItems;

                              _this5.analyticsModel.setCartData(order);

                              _this5._setOrderTypeValue(order);
                            }

                          case 2:
                          case "end":
                            return _context24.stop();
                        }
                      }
                    }, _callee24);
                  })));
                }

                _context25.next = 13;
                break;

              case 10:
                _context25.prev = 10;
                _context25.t0 = _context25["catch"](0);
                this.appMessages.showError("Error", "Error Loading Cart Items.");

              case 13:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this, [[0, 10]]);
      }));

      function _loadCart() {
        return _loadCart2.apply(this, arguments);
      }

      return _loadCart;
    }()
  }, {
    key: "_loadCookiedLocation",
    value: function () {
      var _loadCookiedLocation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(resturantIdFromSession) {
        var _this$rootStore17, _this$rootStore17$res;

        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                return _context26.abrupt("return", (_this$rootStore17 = this.rootStore) === null || _this$rootStore17 === void 0 ? void 0 : (_this$rootStore17$res = _this$rootStore17.restaurant) === null || _this$rootStore17$res === void 0 ? void 0 : _this$rootStore17$res.determineCookiedLocation(resturantIdFromSession, this.restaurantId));

              case 1:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function _loadCookiedLocation(_x17) {
        return _loadCookiedLocation2.apply(this, arguments);
      }

      return _loadCookiedLocation;
    }()
  }, {
    key: "_loadPageData",
    value: function () {
      var _loadPageData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        var _this6 = this;

        var menuListStr, savedMenuList, _this$orderSettingsMo10, _this$orderSettingsMo11, menu;

        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                if (!(this.restaurantId || this.menuListModel.isDefaultMenuSupported)) {
                  _context27.next = 35;
                  break;
                }

                _context27.prev = 1;

                if (this._recommendation) {
                  _context27.next = 5;
                  break;
                }

                _context27.next = 5;
                return this._loadRecommendations();

              case 5:
                //this.menuListModel.setStyleCode(this.rootStore.styleCode);
                this.menuListModel.setReturantId(this.restaurantId); //will get set as null for defaultMenu. TODO::// handle it for CSK

                runInAction(function () {
                  _this6.loading.menuList = true;
                });
                _context27.next = 9;
                return this.rootStore.platformUtil.getFromSessionStorage("MENU_LIST");

              case 9:
                menuListStr = _context27.sent;
                savedMenuList = menuListStr ? JSON.parse(menuListStr) : null;

                if (this._unavailableItems) {
                  _context27.next = 14;
                  break;
                }

                _context27.next = 14;
                return this._loadAvailability();

              case 14:
                if (!savedMenuList) {
                  _context27.next = 20;
                  break;
                }

                this.menuListModel.setMenuDetailData(savedMenuList);
                this.orderHistoryModel.setMenuDetailData(savedMenuList);
                this.menuList = savedMenuList;
                _context27.next = 28;
                break;

              case 20:
                _context27.next = 22;
                return DPServices.Menu.getMenu(this.restaurantId, "--", (_this$orderSettingsMo10 = this.orderSettingsModel) === null || _this$orderSettingsMo10 === void 0 ? void 0 : (_this$orderSettingsMo11 = _this$orderSettingsMo10.currentRestaurant) === null || _this$orderSettingsMo11 === void 0 ? void 0 : _this$orderSettingsMo11.restaurantNum);

              case 22:
                menu = _context27.sent;
                this.menuListModel.setMenuDetailData(menu);
                this.orderHistoryModel.setMenuDetailData(menu);
                _context27.next = 27;
                return this.rootStore.platformUtil.saveInSessionStorage("MENU_LIST", JSON.stringify(menu));

              case 27:
                this.menuList = menu;

              case 28:
                runInAction(function () {
                  _this6.loading.menuList = false;

                  _this6.searchModel.setMenuListData(_this6.menuList);
                });
                _context27.next = 35;
                break;

              case 31:
                _context27.prev = 31;
                _context27.t0 = _context27["catch"](1);
                runInAction(function () {
                  _this6.loading.menuList = false;
                });
                this.appMessages.showError("Error Loading Menu 1", "We could not load menu at this time. Please try again");

              case 35:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this, [[1, 31]]);
      }));

      function _loadPageData() {
        return _loadPageData2.apply(this, arguments);
      }

      return _loadPageData;
    }()
  }, {
    key: "_loadFrequentlyOrderedItem",
    value: function () {
      var _loadFrequentlyOrderedItem2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
        var items, itemsStr;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.prev = 0;
                items = null;
                _context28.next = 4;
                return this.rootStore.platformUtil.getFromLocalStorage("FREQUENTLY_ORDERED_ITEMS");

              case 4:
                itemsStr = _context28.sent;

                if (itemsStr) {
                  items = JSON.parse(itemsStr);
                }

                if (!items) {
                  _context28.next = 10;
                  break;
                }

                this.menuListModel.setFrequentlyOrderItemData(items);
                _context28.next = 15;
                break;

              case 10:
                _context28.next = 12;
                return DPServices.Menu.getFrequesntlyOrderedItem();

              case 12:
                items = _context28.sent;
                this.menuListModel.setFrequentlyOrderItemData(items);
                this.rootStore.platformUtil.saveInLocalStorage("FREQUENTLY_ORDERED_ITEMS", JSON.stringify(items));

              case 15:
                _context28.next = 19;
                break;

              case 17:
                _context28.prev = 17;
                _context28.t0 = _context28["catch"](0);

              case 19:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this, [[0, 17]]);
      }));

      function _loadFrequentlyOrderedItem() {
        return _loadFrequentlyOrderedItem2.apply(this, arguments);
      }

      return _loadFrequentlyOrderedItem;
    }()
  }, {
    key: "saveSmartRecommendationCheckOutSession",
    value: function () {
      var _saveSmartRecommendationCheckOutSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(value) {
        var _this$rootStore18, _this$rootStore18$pla;

        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return (_this$rootStore18 = this.rootStore) === null || _this$rootStore18 === void 0 ? void 0 : (_this$rootStore18$pla = _this$rootStore18.platformUtil) === null || _this$rootStore18$pla === void 0 ? void 0 : _this$rootStore18$pla.saveInSessionStorage("UPSELL_CHECKOUT_CONFIRMATION", value);

              case 2:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function saveSmartRecommendationCheckOutSession(_x18) {
        return _saveSmartRecommendationCheckOutSession.apply(this, arguments);
      }

      return saveSmartRecommendationCheckOutSession;
    }()
  }, {
    key: "loadSmartRecommendationCheckOutConfirmationData",
    value: function () {
      var _loadSmartRecommendationCheckOutConfirmationData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        var _this$rootStore19, _this$rootStore19$pla;

        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return (_this$rootStore19 = this.rootStore) === null || _this$rootStore19 === void 0 ? void 0 : (_this$rootStore19$pla = _this$rootStore19.platformUtil) === null || _this$rootStore19$pla === void 0 ? void 0 : _this$rootStore19$pla.getFromSessionStorage("UPSELL_CHECKOUT_CONFIRMATION");

              case 2:
                _context30.t0 = _context30.sent;
                return _context30.abrupt("return", _context30.t0 === "true");

              case 4:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function loadSmartRecommendationCheckOutConfirmationData() {
        return _loadSmartRecommendationCheckOutConfirmationData.apply(this, arguments);
      }

      return loadSmartRecommendationCheckOutConfirmationData;
    }()
  }, {
    key: "checkCartValidity",
    value: function checkCartValidity() {
      var _this$menuListModel2, _this$cartModel2, _this$cartModel3;

      var orderType = (_this$menuListModel2 = this.menuListModel) === null || _this$menuListModel2 === void 0 ? void 0 : _this$menuListModel2.orderType;
      var minOrder = (_this$cartModel2 = this.cartModel) === null || _this$cartModel2 === void 0 ? void 0 : _this$cartModel2.minDeliveryAmmount;

      if (orderType === ORDER_TYPES.CATERING_DELIVERY && Number((_this$cartModel3 = this.cartModel) === null || _this$cartModel3 === void 0 ? void 0 : _this$cartModel3.totalCartAmount) < minOrder) {
        var _this$cartModel4;

        (_this$cartModel4 = this.cartModel) === null || _this$cartModel4 === void 0 ? void 0 : _this$cartModel4.setNotQualifiedDeliveryMessageVisibility(true);
        return false;
      }

      return true;
    }
  }, {
    key: "_loadSmartRecommendationForCheckOut",
    value: function () {
      var _loadSmartRecommendationForCheckOut2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
        var _this$menuListModel3, _this$menuListModel4, _this$cartModel5, _this$cartModel6, isValidCart, showSmartRecModalAtCheckout, orderType, minOrder, _this$_currentConcept, _this$_restaurantDeta2, _this$menuListModel5, _this$menuListModel5$, brandCode, marketingCloudVisitorId, recomendation, _this$cartModel7;

        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.prev = 0; //Recommendation List Call

                this.cartModel.setIsCheckoutLoading(true);
                isValidCart = this.checkCartValidity();

                if (isValidCart) {
                  _context31.next = 6;
                  break;
                }

                this.cartModel.setIsCheckoutLoading(false);
                return _context31.abrupt("return");

              case 6:
                _context31.t0 = (_this$menuListModel3 = this.menuListModel) === null || _this$menuListModel3 === void 0 ? void 0 : _this$menuListModel3.enableShoppingCartSmartRec;

                if (!_context31.t0) {
                  _context31.next = 11;
                  break;
                }

                _context31.next = 10;
                return this.loadSmartRecommendationCheckOutConfirmationData();

              case 10:
                _context31.t0 = !_context31.sent;

              case 11:
                showSmartRecModalAtCheckout = _context31.t0;

                if (showSmartRecModalAtCheckout) {
                  _context31.next = 15;
                  break;
                }

                this.tryCheckout();
                return _context31.abrupt("return");

              case 15:
                orderType = (_this$menuListModel4 = this.menuListModel) === null || _this$menuListModel4 === void 0 ? void 0 : _this$menuListModel4.orderType;
                minOrder = (_this$cartModel5 = this.cartModel) === null || _this$cartModel5 === void 0 ? void 0 : _this$cartModel5.minDeliveryAmmount;

                if (!(orderType === ORDER_TYPES.CATERING_DELIVERY && Number((_this$cartModel6 = this.cartModel) === null || _this$cartModel6 === void 0 ? void 0 : _this$cartModel6.totalCartAmount) < minOrder)) {
                  _context31.next = 20;
                  break;
                }

                this.tryCheckout();
                return _context31.abrupt("return");

              case 20:
                if (!(orderType === ORDER_TYPES.TOGO_PICKUP || orderType === ORDER_TYPES.CATERING_PICKUP || orderType === ORDER_TYPES.CATERING_DELIVERY)) {
                  _context31.next = 38;
                  break;
                }

                brandCode = (_this$_currentConcept = this._currentConceptCode) === null || _this$_currentConcept === void 0 ? void 0 : _this$_currentConcept.toUpperCase();
                marketingCloudVisitorId = this.marketingCloudVisitorId();
                _context31.next = 25;
                return DPServices.Menu.getRecommentation({
                  orderType: this.menuListModel.orderType,
                  restaurantId: Number(this.restaurantId),
                  numberOfRecommandtions: this.upsellRecommendationsThreshold,
                  name: this.upsellRecommendationsMboxName,
                  recType: "shoppingcart",
                  marketingCloudVisitorId: marketingCloudVisitorId
                });

              case 25:
                recomendation = _context31.sent;
                this.analyticsModel.dispatchSmartRecommendationsForCheckoutEvent(this.restaurantId, (_this$_restaurantDeta2 = this._restaurantDetail) === null || _this$_restaurantDeta2 === void 0 ? void 0 : _this$_restaurantDeta2.restaurantNum.toString(), recomendation);
                this.menuListModel.setCheckoutSmartRecommendationList(recomendation);

                if (!((_this$menuListModel5 = this.menuListModel) !== null && _this$menuListModel5 !== void 0 && (_this$menuListModel5$ = _this$menuListModel5.checkoutsmartrecommendations) !== null && _this$menuListModel5$ !== void 0 && _this$menuListModel5$.length)) {
                  _context31.next = 35;
                  break;
                }

                (_this$cartModel7 = this.cartModel) === null || _this$cartModel7 === void 0 ? void 0 : _this$cartModel7.toggleSmartRecommendationMenuListModal(true);
                this.cartModel.setIsCheckoutLoading(false);
                _context31.next = 33;
                return this.saveSmartRecommendationCheckOutSession("true");

              case 33:
                _context31.next = 36;
                break;

              case 35:
                this.tryCheckout();

              case 36:
                _context31.next = 39;
                break;

              case 38:
                this.tryCheckout();

              case 39:
                _context31.next = 46;
                break;

              case 41:
                _context31.prev = 41;
                _context31.t1 = _context31["catch"](0);
                console.log(_context31.t1, "error");
                this.cartModel.setIsCheckoutLoading(false);
                this.tryCheckout();
              //Fail silently

              case 46:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this, [[0, 41]]);
      }));

      function _loadSmartRecommendationForCheckOut() {
        return _loadSmartRecommendationForCheckOut2.apply(this, arguments);
      }

      return _loadSmartRecommendationForCheckOut;
    }()
  }, {
    key: "loadRecommendations",
    value: function () {
      var _loadRecommendations2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                this.menuListModel.setRoute("recommendations");

                this._loadRecommendations();

              case 2:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function loadRecommendations() {
        return _loadRecommendations2.apply(this, arguments);
      }

      return loadRecommendations;
    }()
  }, {
    key: "_loadRecommendations",
    value: function () {
      var _loadRecommendations3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
        var _this$orderSettingsMo12, _this$menuListModel6, _this$menuListModel7;

        var makeRecommendationsCall;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                if (!((_this$orderSettingsMo12 = this.orderSettingsModel) !== null && _this$orderSettingsMo12 !== void 0 && _this$orderSettingsMo12.isDineInEnabled)) {
                  _context33.next = 2;
                  break;
                }

                return _context33.abrupt("return");

              case 2:
                if (!this.fromRestDetails) {
                  _context33.next = 4;
                  break;
                }

                return _context33.abrupt("return");

              case 4:
                //Recommendation List Call
                makeRecommendationsCall = (_this$menuListModel6 = this.menuListModel) === null || _this$menuListModel6 === void 0 ? void 0 : _this$menuListModel6.enableMenuItemsSmartRec;

                if (!(!makeRecommendationsCall && ((_this$menuListModel7 = this.menuListModel) === null || _this$menuListModel7 === void 0 ? void 0 : _this$menuListModel7.route) === "menuListing")) {
                  _context33.next = 7;
                  break;
                }

                return _context33.abrupt("return");

              case 7:
                _context33.next = 9;
                return handle(this._getRecommendationsFromApi());

              case 9:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function _loadRecommendations() {
        return _loadRecommendations3.apply(this, arguments);
      }

      return _loadRecommendations;
    }()
  }, {
    key: "_getRecommendationsFromApi",
    value: function () {
      var _getRecommendationsFromApi2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
        var _this$menuListModel8, _this$_restaurantDeta3;

        var marketingCloudVisitorId, recommendations;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                marketingCloudVisitorId = this.marketingCloudVisitorId();

                if (this.restaurantId) {
                  _context34.next = 3;
                  break;
                }

                return _context34.abrupt("return");

              case 3:
                _context34.next = 5;
                return DPServices.Menu.getRecommentation({
                  restaurantId: Number(this.restaurantId),
                  numberOfRecommandtions: this.frequentlyOrderedRecommendationsThreshold,
                  name: ((_this$menuListModel8 = this.menuListModel) === null || _this$menuListModel8 === void 0 ? void 0 : _this$menuListModel8.route) === "menuListing" ? this.frequentlyOrderedRecommendationsMboxName : this.guestPicksRecommendationsMboxName,
                  recType: "menuGrid",
                  marketingCloudVisitorId: marketingCloudVisitorId
                });

              case 5:
                recommendations = _context34.sent;
                this.analyticsModel.dispatchGetRecommendationsEvent(this.restaurantId, (_this$_restaurantDeta3 = this._restaurantDetail) === null || _this$_restaurantDeta3 === void 0 ? void 0 : _this$_restaurantDeta3.restaurantNum.toString(), recommendations, "menuGrid");
                this.menuListModel.setRecommendationData(recommendations);
                this._recommendation = recommendations;

              case 9:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function _getRecommendationsFromApi() {
        return _getRecommendationsFromApi2.apply(this, arguments);
      }

      return _getRecommendationsFromApi;
    }() // TODO: made public temporary as needed to use in CartModel (TASK NO 17024)
    // Need to disucss how we are calling it for AddToCart invoke 86ed call

  }, {
    key: "_loadAvailability",
    value: function () {
      var _loadAvailability2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
        var _this$_restaurantDeta4, _86Items, dayPartInfo;

        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.prev = 0;

                if (!this.fromConfirmation) {
                  _context35.next = 3;
                  break;
                }

                return _context35.abrupt("return");

              case 3:
                if (!this.fromRestDetails) {
                  _context35.next = 5;
                  break;
                }

                return _context35.abrupt("return");

              case 5:
                if (this.restaurantId) {
                  _context35.next = 7;
                  break;
                }

                return _context35.abrupt("return");

              case 7:
                _context35.next = 9;
                return DPServices.Menu.get86edItemIds(this.restaurantId);

              case 9:
                _86Items = _context35.sent;
                this.menuListModel.setUnavailableItemsData(_86Items);
                this.orderHistoryModel.setUnavailableItemsData(_86Items);
                this.menuDetailModel.setUnavailableItemsData(_86Items); // Refactor

                this.menuEditModel.setUnavailableItemsData(_86Items);
                this.menuQuickAddModel.setUnavailableItemsData(_86Items);
                this._unavailableItems = _86Items;
                this.analyticsModel.dispatchUnavailableItemsEvent(this.restaurantId, (_this$_restaurantDeta4 = this._restaurantDetail) === null || _this$_restaurantDeta4 === void 0 ? void 0 : _this$_restaurantDeta4.restaurantNum.toString(), _86Items.productIds); //DayPart Call

                _context35.next = 19;
                return DPServices.Menu.getDayPartInfo(this.restaurantId);

              case 19:
                dayPartInfo = _context35.sent;
                this.menuListModel.setDayPartInfoData(dayPartInfo);
                this.orderHistoryModel.setDayPartInfoData(dayPartInfo);
                this.menuDetailModel.setDayPartInfoData(dayPartInfo); // Refactor

                this.menuEditModel.setDayPartInfoData(dayPartInfo);
                this.menuQuickAddModel.setDayPartInfoData(dayPartInfo); //SmartRec Call

                _context35.next = 29;
                break;

              case 27:
                _context35.prev = 27;
                _context35.t0 = _context35["catch"](0);

              case 29:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this, [[0, 27]]);
      }));

      function _loadAvailability() {
        return _loadAvailability2.apply(this, arguments);
      }

      return _loadAvailability;
    }()
  }, {
    key: "saveWaitlistRestaurantToMyLocations",
    value: function () {
      var _saveWaitlistRestaurantToMyLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(restaurantId) {
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.next = 2;
                return this.saveToMyLocations(restaurantId);

              case 2:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function saveWaitlistRestaurantToMyLocations(_x19) {
        return _saveWaitlistRestaurantToMyLocations.apply(this, arguments);
      }

      return saveWaitlistRestaurantToMyLocations;
    }()
  }, {
    key: "saveToMyLocations",
    value: function () {
      var _saveToMyLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(restaurantId) {
        var myLocations, newMyLocations;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.prev = 0;
                _context37.next = 3;
                return this.rootStore.platformUtil.getFromLocalStorage("MY_LOCATIONS").then(JSON.parse);

              case 3:
                myLocations = _context37.sent;
                newMyLocations = myLocations;

                if (myLocations && Array.isArray(myLocations)) {
                  newMyLocations = [restaurantId].concat(_toConsumableArray(myLocations.filter(function (r) {
                    return r !== restaurantId;
                  }).slice(0, 2)));
                } else {
                  newMyLocations = [restaurantId];
                }

                this.rootStore.platformUtil.saveInLocalStorage("MY_LOCATIONS", JSON.stringify(newMyLocations));
                _context37.next = 11;
                break;

              case 9:
                _context37.prev = 9;
                _context37.t0 = _context37["catch"](0);

              case 11:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this, [[0, 9]]);
      }));

      function saveToMyLocations(_x20) {
        return _saveToMyLocations.apply(this, arguments);
      }

      return saveToMyLocations;
    }()
  }, {
    key: "populateRecentLocationSearchKeywords",
    value: function () {
      var _populateRecentLocationSearchKeywords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
        var recentLocationKeys;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return this.rootStore.platformUtil.getFromLocalStorage("RECENT_LOCATION_SEARCH_KEYS").then(JSON.parse);

              case 2:
                recentLocationKeys = _context38.sent;

                if (recentLocationKeys && Array.isArray(recentLocationKeys)) {
                  this.orderSettingsModel.setSavedLocationSearchEntries(recentLocationKeys);
                }

              case 4:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function populateRecentLocationSearchKeywords() {
        return _populateRecentLocationSearchKeywords.apply(this, arguments);
      }

      return populateRecentLocationSearchKeywords;
    }()
  }, {
    key: "saveRecentLocationSearchEntry",
    value: function () {
      var _saveRecentLocationSearchEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(searchKeyWord) {
        var myLocations, updated, filtered;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.prev = 0;
                _context39.next = 3;
                return this.rootStore.platformUtil.getFromLocalStorage("RECENT_LOCATION_SEARCH_KEYS").then(JSON.parse);

              case 3:
                myLocations = _context39.sent;
                updated = null;

                if (myLocations && Array.isArray(myLocations)) {
                  filtered = myLocations.filter(function (entry) {
                    return entry.label === searchKeyWord.label;
                  });

                  if (filtered.length === 0) {
                    updated = [searchKeyWord].concat(_toConsumableArray(myLocations.slice(0, 4)));
                  }
                } else {
                  updated = [searchKeyWord];
                }

                if (updated && updated.length) {
                  this.orderSettingsModel.setSavedLocationSearchEntries(updated);
                  this.rootStore.platformUtil.saveInLocalStorage("RECENT_LOCATION_SEARCH_KEYS", JSON.stringify(updated));
                }

                _context39.next = 11;
                break;

              case 9:
                _context39.prev = 9;
                _context39.t0 = _context39["catch"](0);

              case 11:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this, [[0, 9]]);
      }));

      function saveRecentLocationSearchEntry(_x21) {
        return _saveRecentLocationSearchEntry.apply(this, arguments);
      }

      return saveRecentLocationSearchEntry;
    }()
  }, {
    key: "openMyLocationSlider",
    value: function () {
      var _openMyLocationSlider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
        var _this$orderSettingsMo13, _this$orderSettingsMo14, savedLocationIds, _this$orderSettingsMo15, _resturants, resturants, _this$orderSettingsMo16, _this$orderSettingsMo17;

        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.prev = 0;
                (_this$orderSettingsMo13 = this.orderSettingsModel) === null || _this$orderSettingsMo13 === void 0 ? void 0 : _this$orderSettingsMo13.toggleMyLocationLoading(true);

                if (!(((_this$orderSettingsMo14 = this.orderSettingsModel) === null || _this$orderSettingsMo14 === void 0 ? void 0 : _this$orderSettingsMo14.savedResturants.length) > 2)) {
                  _context41.next = 4;
                  break;
                }

                return _context41.abrupt("return");

              case 4:
                _context41.next = 6;
                return this.rootStore.platformUtil.getFromLocalStorage("MY_LOCATIONS").then(JSON.parse);

              case 6:
                savedLocationIds = _context41.sent;

                if (!(savedLocationIds && Array.isArray(savedLocationIds))) {
                  _context41.next = 13;
                  break;
                }

                _resturants = savedLocationIds.map( /*#__PURE__*/function () {
                  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(_rid) {
                    var details;
                    return _regeneratorRuntime.wrap(function _callee40$(_context40) {
                      while (1) {
                        switch (_context40.prev = _context40.next) {
                          case 0:
                            _context40.prev = 0;
                            _context40.next = 3;
                            return DPServices.Restaurant.getRestaurantDetailsById(_rid);

                          case 3:
                            details = _context40.sent;

                            if (!details) {
                              _context40.next = 6;
                              break;
                            }

                            return _context40.abrupt("return", details);

                          case 6:
                            throw new Error();

                          case 9:
                            _context40.prev = 9;
                            _context40.t0 = _context40["catch"](0);
                            return _context40.abrupt("return", false);

                          case 12:
                          case "end":
                            return _context40.stop();
                        }
                      }
                    }, _callee40, null, [[0, 9]]);
                  }));

                  return function (_x22) {
                    return _ref10.apply(this, arguments);
                  };
                }());
                _context41.next = 11;
                return Promise.all(_resturants);

              case 11:
                resturants = _context41.sent.filter(Boolean);
                (_this$orderSettingsMo15 = this.orderSettingsModel) === null || _this$orderSettingsMo15 === void 0 ? void 0 : _this$orderSettingsMo15.setSavedRestaurants(resturants);

              case 13:
                _context41.next = 18;
                break;

              case 15:
                _context41.prev = 15;
                _context41.t0 = _context41["catch"](0);
                console.log("hit");
              // TODO

              case 18:
                _context41.prev = 18;
                (_this$orderSettingsMo16 = this.orderSettingsModel) === null || _this$orderSettingsMo16 === void 0 ? void 0 : _this$orderSettingsMo16.toggleMyLocationLoading(false);
                (_this$orderSettingsMo17 = this.orderSettingsModel) === null || _this$orderSettingsMo17 === void 0 ? void 0 : _this$orderSettingsMo17.setShowMyLocations(true);
                return _context41.finish(18);

              case 22:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this, [[0, 15, 18, 22]]);
      }));

      function openMyLocationSlider() {
        return _openMyLocationSlider.apply(this, arguments);
      }

      return openMyLocationSlider;
    }()
  }, {
    key: "searchAddressSuggestions",
    value: function () {
      var _searchAddressSuggestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(searchText) {
        var _this$_restaurantDeta5, _this$_restaurantDeta6, results, longitudeLatitude, coords, coordinates;

        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                if (!(searchText && searchText.length > 2)) {
                  _context42.next = 11;
                  break;
                }

                this.orderSettingsModel.setIsSearchResultLoading(true);
                results = null;
                longitudeLatitude = (_this$_restaurantDeta5 = this._restaurantDetail) === null || _this$_restaurantDeta5 === void 0 ? void 0 : (_this$_restaurantDeta6 = _this$_restaurantDeta5.address) === null || _this$_restaurantDeta6 === void 0 ? void 0 : _this$_restaurantDeta6.longitudeLatitude;
                coords = longitudeLatitude ? longitudeLatitude.split(",") : null;
                coordinates = this.fromLocationSearch && coords ? [coords !== null && coords !== void 0 && coords[0] ? +(coords === null || coords === void 0 ? void 0 : coords[0]) : undefined, coords !== null && coords !== void 0 && coords[1] ? +(coords === null || coords === void 0 ? void 0 : coords[1]) : undefined] : this._locationData ? [this._locationData.coords.latitude, this._locationData.coords.longitude] : null;
                _context42.next = 8;
                return DPServices.Location.getMapboxPlaceSuggestions("", searchText, this._currentConceptCode, this.rootStore.user.foregroundLocationPermissionGranted, false, coordinates ? {
                  lat: coordinates[0],
                  lng: coordinates[1]
                } : null, this.fromLocationSearch);

              case 8:
                results = _context42.sent;
                this.orderSettingsModel.setAddressSuggestionsData(results);
                this.orderSettingsModel.setIsSearchResultLoading(false);

              case 11:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function searchAddressSuggestions(_x23) {
        return _searchAddressSuggestions.apply(this, arguments);
      }

      return searchAddressSuggestions;
    }() //reverse geo code, works when enter pressed on input box

  }, {
    key: "searchRestaurantsUsingText",
    value: function () {
      var _searchRestaurantsUsingText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(searchText) {
        var _results, _results$features, _results2, _results2$features$, results, startPointLongLat, lng, lat, _this$orderSettingsMo18, _this$orderSettingsMo19, _this$rootStore20, _this$rootStore20$pla;

        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                if (!(searchText && searchText.length > 2)) {
                  _context43.next = 7;
                  break;
                }

                results = null;
                _context43.next = 4;
                return DPServices.Location.getMapboxPlaceSuggestionsUsingText("", searchText);

              case 4:
                results = _context43.sent;
                startPointLongLat = ((_results = results) === null || _results === void 0 ? void 0 : (_results$features = _results.features) === null || _results$features === void 0 ? void 0 : _results$features.length) > 0 && ((_results2 = results) === null || _results2 === void 0 ? void 0 : (_results2$features$ = _results2.features[0]) === null || _results2$features$ === void 0 ? void 0 : _results2$features$.center);

                if (startPointLongLat) {
                  lng = startPointLongLat[0];
                  lat = startPointLongLat[1];
                  this.saveRecentLocationSearchEntry({
                    searchString: searchText,
                    label: searchText,
                    lat: lat,
                    "long": lng
                  });
                  this.orderSettingsModel.searchedLocationDetail = {
                    searchString: searchText,
                    label: searchText,
                    lat: lat,
                    "long": lng
                  };
                  this === null || this === void 0 ? void 0 : this.setLocationData({
                    coords: {
                      latitude: lat,
                      longitude: lng,
                      accuracy: null,
                      altitude: null,
                      altitudeAccuracy: null,
                      heading: null,
                      speed: null
                    },
                    timestamp: Date.now()
                  });
                  this === null || this === void 0 ? void 0 : this.searchRestaurantsWithoutDistanceCalculations([lat, lng]);
                } else {
                  (_this$orderSettingsMo18 = this.orderSettingsModel) === null || _this$orderSettingsMo18 === void 0 ? void 0 : _this$orderSettingsMo18.setIsLocationsListLoading(true);
                  this.restaurantSearchResults = [];
                  (_this$orderSettingsMo19 = this.orderSettingsModel) === null || _this$orderSettingsMo19 === void 0 ? void 0 : _this$orderSettingsMo19.setIsLocationsListLoading(false); // Dispatch No results found search event

                  (_this$rootStore20 = this.rootStore) === null || _this$rootStore20 === void 0 ? void 0 : (_this$rootStore20$pla = _this$rootStore20.platformUtil) === null || _this$rootStore20$pla === void 0 ? void 0 : _this$rootStore20$pla.dispatchEvent("AnalyticsEvent", "locationSearchNoResults", {});
                }

              case 7:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function searchRestaurantsUsingText(_x24) {
        return _searchRestaurantsUsingText.apply(this, arguments);
      }

      return searchRestaurantsUsingText;
    }()
  }, {
    key: "getStateBasedOnCoords",
    value: function () {
      var _getStateBasedOnCoords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(latitude, longitude) {
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                return _context44.abrupt("return", DPServices.Location.getMapboxPlaceSuggestionsUsingText("", "".concat(longitude, ",").concat(latitude)));

              case 1:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44);
      }));

      function getStateBasedOnCoords(_x25, _x26) {
        return _getStateBasedOnCoords.apply(this, arguments);
      }

      return getStateBasedOnCoords;
    }()
  }, {
    key: "setStateBasedOnUserCoords",
    value: function () {
      var _setStateBasedOnUserCoords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
        var _this$orderSettingsMo20, _this$orderSettingsMo21, _this$rootStore21, _this$rootStore21$use, _locationData$coords, _locationData$coords2, _results$features2, _results$features2$, _results$features2$$c, _this$orderSettingsMo22, _this$orderSettingsMo23, _this$orderSettingsMo24;

        var locationData, latitude, longitude, results, state, stateExistsInAllRests;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                if (!((this === null || this === void 0 ? void 0 : (_this$orderSettingsMo20 = this.orderSettingsModel) === null || _this$orderSettingsMo20 === void 0 ? void 0 : (_this$orderSettingsMo21 = _this$orderSettingsMo20.currentRestaurantId) === null || _this$orderSettingsMo21 === void 0 ? void 0 : _this$orderSettingsMo21.length) > 0)) {
                  _context45.next = 2;
                  break;
                }

                return _context45.abrupt("return");

              case 2:
                locationData = (_this$rootStore21 = this.rootStore) === null || _this$rootStore21 === void 0 ? void 0 : (_this$rootStore21$use = _this$rootStore21.user) === null || _this$rootStore21$use === void 0 ? void 0 : _this$rootStore21$use.currentUserLocation;

                if (locationData) {
                  _context45.next = 5;
                  break;
                }

                return _context45.abrupt("return");

              case 5:
                latitude = locationData === null || locationData === void 0 ? void 0 : (_locationData$coords = locationData.coords) === null || _locationData$coords === void 0 ? void 0 : _locationData$coords.latitude;
                longitude = locationData === null || locationData === void 0 ? void 0 : (_locationData$coords2 = locationData.coords) === null || _locationData$coords2 === void 0 ? void 0 : _locationData$coords2.longitude;
                _context45.next = 9;
                return this.getStateBasedOnCoords(latitude, longitude);

              case 9:
                results = _context45.sent;
                state = null;
                results === null || results === void 0 ? void 0 : (_results$features2 = results.features) === null || _results$features2 === void 0 ? void 0 : (_results$features2$ = _results$features2[0]) === null || _results$features2$ === void 0 ? void 0 : (_results$features2$$c = _results$features2$.context) === null || _results$features2$$c === void 0 ? void 0 : _results$features2$$c.forEach(function (dataType) {
                  if (dataType["id"].includes("region.")) {
                    state = dataType["text"].trim();
                  }
                });
                stateExistsInAllRests = (_this$orderSettingsMo22 = this.orderSettingsModel) === null || _this$orderSettingsMo22 === void 0 ? void 0 : (_this$orderSettingsMo23 = _this$orderSettingsMo22.allRests) === null || _this$orderSettingsMo23 === void 0 ? void 0 : _this$orderSettingsMo23.some(function (rest) {
                  return (rest === null || rest === void 0 ? void 0 : rest.state) === state;
                });
                state && stateExistsInAllRests && ((_this$orderSettingsMo24 = this.orderSettingsModel) === null || _this$orderSettingsMo24 === void 0 ? void 0 : _this$orderSettingsMo24.setSelectedLocationState(state));

              case 14:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));

      function setStateBasedOnUserCoords() {
        return _setStateBasedOnUserCoords.apply(this, arguments);
      }

      return setStateBasedOnUserCoords;
    }()
  }, {
    key: "searchRestaurants",
    value: function () {
      var _searchRestaurants2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(coordinates) {
        var offset,
            pageSize,
            _args46 = arguments;
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                offset = _args46.length > 1 && _args46[1] !== undefined ? _args46[1] : 0;
                pageSize = _args46.length > 2 && _args46[2] !== undefined ? _args46[2] : 10;
                _context46.next = 4;
                return this._searchRestaurants(coordinates, true, offset, pageSize);

              case 4:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));

      function searchRestaurants(_x27) {
        return _searchRestaurants2.apply(this, arguments);
      }

      return searchRestaurants;
    }()
  }, {
    key: "searchRestaurantsWithoutDistanceCalculations",
    value: function () {
      var _searchRestaurantsWithoutDistanceCalculations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(coordinates) {
        var offset,
            pageSize,
            _args47 = arguments;
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                offset = _args47.length > 1 && _args47[1] !== undefined ? _args47[1] : 0;
                pageSize = _args47.length > 2 && _args47[2] !== undefined ? _args47[2] : 10;
                _context47.next = 4;
                return this._searchRestaurants(coordinates, false, offset, pageSize);

              case 4:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function searchRestaurantsWithoutDistanceCalculations(_x28) {
        return _searchRestaurantsWithoutDistanceCalculations.apply(this, arguments);
      }

      return searchRestaurantsWithoutDistanceCalculations;
    }()
    /** Search location at current geo point,
     * LocationData will be derrived from LocationServices in Restaurant store.
     */

  }, {
    key: "_searchRestaurants",
    value: function () {
      var _searchRestaurants3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(coordinates) {
        var _this$orderSettingsMo27, _this$menuListModel9, _response$successResp, _response$successResp2, _response$successResp3, _response$successResp4, _results3, _results4, _results5, _currentLocation$coor, _currentLocation$coor2, _currentLocation$coor3, _currentLocation$coor4, _results6, _sortedResult, _this$orderSettingsMo28, _this$orderSettingsMo29;

        var calculateDistances,
            offset,
            pageSize,
            _this$orderSettingsMo25,
            _this$orderSettingsMo26,
            _this$rootStore22,
            _this$rootStore22$pla,
            filterTogo,
            computedPageSize,
            results,
            response,
            _this$rootStore23,
            _this$rootStore23$pla,
            _response$successResp5,
            _response$successResp6,
            _response$successResp7,
            _response$successResp8,
            _response$successResp9,
            _response$successResp10,
            _response$successResp11,
            restaurantIds,
            currentLocation,
            coordsObj,
            distanceResults,
            sortedResult,
            searchStringZipCode,
            _this$restaurantSearc,
            _this$restaurantSearc2,
            samezipCodeRestaurants,
            otherRestaurants,
            updatedRestaurantSearchResults,
            _args48 = arguments;

        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                calculateDistances = _args48.length > 1 && _args48[1] !== undefined ? _args48[1] : true;
                offset = _args48.length > 2 && _args48[2] !== undefined ? _args48[2] : 0;
                pageSize = _args48.length > 3 && _args48[3] !== undefined ? _args48[3] : 10;

                if (this.fromLocationSearch) {
                  (_this$orderSettingsMo25 = this.orderSettingsModel) === null || _this$orderSettingsMo25 === void 0 ? void 0 : _this$orderSettingsMo25.setNearbyRestaurantRefsToEmpty();
                  (_this$orderSettingsMo26 = this.orderSettingsModel) === null || _this$orderSettingsMo26 === void 0 ? void 0 : _this$orderSettingsMo26.setIsScrollEnableOnLocationPinClick(false); // Dispatch search event

                  (_this$rootStore22 = this.rootStore) === null || _this$rootStore22 === void 0 ? void 0 : (_this$rootStore22$pla = _this$rootStore22.platformUtil) === null || _this$rootStore22$pla === void 0 ? void 0 : _this$rootStore22$pla.dispatchEvent("AnalyticsEvent", "locationSearch", {});
                }

                filterTogo = this.orderSettingsModel.filterTogo;
                (_this$orderSettingsMo27 = this.orderSettingsModel) === null || _this$orderSettingsMo27 === void 0 ? void 0 : _this$orderSettingsMo27.setIsLocationsListLoading(true);
                computedPageSize = ((_this$menuListModel9 = this.menuListModel) === null || _this$menuListModel9 === void 0 ? void 0 : _this$menuListModel9.searchRestaurantsPageSize) || pageSize;
                results = [];
                _context48.next = 10;
                return DPServices.Restaurant.searchRestaurants(coordinates[0], coordinates[1], offset, computedPageSize);

              case 10:
                response = _context48.sent;

                if ((response === null || response === void 0 ? void 0 : (_response$successResp = response.successResponse) === null || _response$successResp === void 0 ? void 0 : (_response$successResp2 = _response$successResp.locationSearchResult) === null || _response$successResp2 === void 0 ? void 0 : _response$successResp2.resultsCount) === 0 && this.fromLocationSearch) {
                  // Dispatch No results found search event
                  (_this$rootStore23 = this.rootStore) === null || _this$rootStore23 === void 0 ? void 0 : (_this$rootStore23$pla = _this$rootStore23.platformUtil) === null || _this$rootStore23$pla === void 0 ? void 0 : _this$rootStore23$pla.dispatchEvent("AnalyticsEvent", "locationSearchNoResults", {});
                }

                if (response !== null && response !== void 0 && (_response$successResp3 = response.successResponse) !== null && _response$successResp3 !== void 0 && (_response$successResp4 = _response$successResp3.locationSearchResult) !== null && _response$successResp4 !== void 0 && _response$successResp4.opnHoursDisplayOrder) {
                  this.orderSettingsModel.openHoursDisplayOrder = response === null || response === void 0 ? void 0 : (_response$successResp5 = response.successResponse) === null || _response$successResp5 === void 0 ? void 0 : (_response$successResp6 = _response$successResp5.locationSearchResult) === null || _response$successResp6 === void 0 ? void 0 : _response$successResp6.opnHoursDisplayOrder;
                }

                if (this.fromLocationSearch || this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
                  results = response === null || response === void 0 ? void 0 : (_response$successResp7 = response.successResponse) === null || _response$successResp7 === void 0 ? void 0 : (_response$successResp8 = _response$successResp7.locationSearchResult) === null || _response$successResp8 === void 0 ? void 0 : _response$successResp8.Location;
                } else {
                  results = response === null || response === void 0 ? void 0 : (_response$successResp9 = response.successResponse) === null || _response$successResp9 === void 0 ? void 0 : (_response$successResp10 = _response$successResp9.locationSearchResult) === null || _response$successResp10 === void 0 ? void 0 : (_response$successResp11 = _response$successResp10.Location) === null || _response$successResp11 === void 0 ? void 0 : _response$successResp11.filter(function (location) {
                    return !location.isComingSoon;
                  });
                }

                if (filterTogo && (_results3 = results) !== null && _results3 !== void 0 && _results3.length) {
                  results = this.filterNotTogoRestaurants(results);
                }

                restaurantIds = (_results4 = results) === null || _results4 === void 0 ? void 0 : _results4.map(function (restaurant) {
                  return restaurant === null || restaurant === void 0 ? void 0 : restaurant.restaurantId;
                });
                this.analyticsModel.dispatchSearchMyLocationEvent(coordinates, (_results5 = results) === null || _results5 === void 0 ? void 0 : _results5.length, restaurantIds);
                currentLocation = this.rootStore.user.currentUserLocation;
                coordsObj = {
                  latitude: (_currentLocation$coor = currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor2 = currentLocation.coords) === null || _currentLocation$coor2 === void 0 ? void 0 : _currentLocation$coor2.latitude) !== null && _currentLocation$coor !== void 0 ? _currentLocation$coor : coordinates[0],
                  longitude: (_currentLocation$coor3 = currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor4 = currentLocation.coords) === null || _currentLocation$coor4 === void 0 ? void 0 : _currentLocation$coor4.longitude) !== null && _currentLocation$coor3 !== void 0 ? _currentLocation$coor3 : coordinates[1],
                  accuracy: null,
                  altitude: null,
                  altitudeAccuracy: null,
                  heading: null,
                  speed: null
                };

                if (!(calculateDistances && (_results6 = results) !== null && _results6 !== void 0 && _results6.length)) {
                  _context48.next = 25;
                  break;
                }

                _context48.next = 22;
                return fetchDistances(coordsObj, results);

              case 22:
                _context48.t0 = _context48.sent;
                _context48.next = 26;
                break;

              case 25:
                _context48.t0 = null;

              case 26:
                distanceResults = _context48.t0;
                sortedResult = results;

                if (results && results.length && distanceResults) {
                  results = results.map(function (result) {
                    var temp = result;
                    temp.mapBoxDistance = distanceResults[result === null || result === void 0 ? void 0 : result.restaurantId];
                    return temp;
                  });
                  sortedResult = orderBy(results, "mapBoxDistance", "asc");
                }

                this.restaurantSearchResults = sortedResult;

                if ((_sortedResult = sortedResult) !== null && _sortedResult !== void 0 && _sortedResult.length) {
                  this.orderSettingsModel.activeLocationListIndex = 0;
                }

                searchStringZipCode = this === null || this === void 0 ? void 0 : (_this$orderSettingsMo28 = this.orderSettingsModel) === null || _this$orderSettingsMo28 === void 0 ? void 0 : _this$orderSettingsMo28.locationSearchString.match(/\b\d{5}\b/g);

                if (searchStringZipCode && searchStringZipCode.length > 0) {
                  samezipCodeRestaurants = (_this$restaurantSearc = this.restaurantSearchResults) === null || _this$restaurantSearc === void 0 ? void 0 : _this$restaurantSearc.filter(function (restaurant) {
                    var _restaurant$zip;

                    return (restaurant === null || restaurant === void 0 ? void 0 : (_restaurant$zip = restaurant.zip) === null || _restaurant$zip === void 0 ? void 0 : _restaurant$zip.substring(0, 5)) === searchStringZipCode[0];
                  });
                  otherRestaurants = (_this$restaurantSearc2 = this.restaurantSearchResults) === null || _this$restaurantSearc2 === void 0 ? void 0 : _this$restaurantSearc2.filter(function (restaurant) {
                    var _restaurant$zip2;

                    return (restaurant === null || restaurant === void 0 ? void 0 : (_restaurant$zip2 = restaurant.zip) === null || _restaurant$zip2 === void 0 ? void 0 : _restaurant$zip2.substring(0, 5)) !== searchStringZipCode[0];
                  });
                  updatedRestaurantSearchResults = samezipCodeRestaurants.concat(otherRestaurants);
                  this.restaurantSearchResults = updatedRestaurantSearchResults;
                }

                (_this$orderSettingsMo29 = this.orderSettingsModel) === null || _this$orderSettingsMo29 === void 0 ? void 0 : _this$orderSettingsMo29.setIsLocationsListLoading(false);
                this.showSearchThisArea = false;

              case 35:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));

      function _searchRestaurants(_x29) {
        return _searchRestaurants3.apply(this, arguments);
      }

      return _searchRestaurants;
    }() // Search for all locations for SRG brands

  }, {
    key: "getAllRestaurants",
    value: function () {
      var _getAllRestaurants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(restaurantId) {
        var _this$orderSettingsMo30, _this$orderSettingsMo31;

        var results, response, _response$successResp12, _response$successResp13, _response$successResp14, _response$successResp15, selectedRest;

        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                (_this$orderSettingsMo30 = this.orderSettingsModel) === null || _this$orderSettingsMo30 === void 0 ? void 0 : _this$orderSettingsMo30.setIsLocationsListLoading(true);
                results = [];
                _context49.next = 4;
                return DPServices.Restaurant.getAllRestaurants(this._currentConceptCode);

              case 4:
                response = _context49.sent;

                if (this.fromLocationSearch) {
                  results = response === null || response === void 0 ? void 0 : (_response$successResp12 = response.successResponse) === null || _response$successResp12 === void 0 ? void 0 : (_response$successResp13 = _response$successResp12.locationSearchResult) === null || _response$successResp13 === void 0 ? void 0 : _response$successResp13.Location;
                } else {
                  results = response === null || response === void 0 ? void 0 : (_response$successResp14 = response.successResponse) === null || _response$successResp14 === void 0 ? void 0 : (_response$successResp15 = _response$successResp14.locationSearchResult) === null || _response$successResp15 === void 0 ? void 0 : _response$successResp15.Location.filter(function (location) {
                    return !location.isComingSoon;
                  });
                }

                if (restaurantId) {
                  selectedRest = results.filter(function (item) {
                    return item.restaurantId === restaurantId;
                  });
                  this.orderSettingsModel.setSelectedLocationState(selectedRest[0].stateName);
                }

                this.orderSettingsModel.setRestaurantSearchResultsData(results);
                this.restaurantSearchResults = results;
                (_this$orderSettingsMo31 = this.orderSettingsModel) === null || _this$orderSettingsMo31 === void 0 ? void 0 : _this$orderSettingsMo31.setIsLocationsListLoading(false);

              case 10:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function getAllRestaurants(_x30) {
        return _getAllRestaurants.apply(this, arguments);
      }

      return getAllRestaurants;
    }()
  }, {
    key: "filterNotTogoRestaurants",
    value: function filterNotTogoRestaurants(results) {
      return results.filter(function (r) {
        return r.onlineTogo;
      });
    }
  }, {
    key: "fetchTimes",
    value: function () {
      var _fetchTimes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50() {
        var _this$rootStore$user$,
            _this$rootStore$user$2,
            _this$orderSettingsMo32,
            _this$orderSettingsMo33,
            _this7 = this;

        var realtime,
            selectedDate,
            from,
            retry,
            restId,
            platformIsMobileApp,
            sessionContext,
            _storeResturant,
            resturantId,
            derrivedDate,
            orderType,
            _yield$handle3,
            _yield$handle4,
            timesResponse,
            _timesResponse$times,
            _timesResponse$succes,
            _timesResponse$succes2,
            _this$_restaurantDeta7,
            _timesResponse$succes3,
            _timesResponse$succes4,
            responseOrderType,
            _timesResponse$times2,
            _timesResponse$times3,
            _this$orderSettingsMo34,
            lunch,
            dinner,
            firstSlotDateTime,
            _this$timeModel5,
            _this$timeModel5$curr,
            _this$timeModel6,
            _this$timeModel6$curr,
            newSelectedTimeDate,
            _args50 = arguments;

        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                realtime = _args50.length > 0 && _args50[0] !== undefined ? _args50[0] : false;
                selectedDate = _args50.length > 1 ? _args50[1] : undefined;
                from = _args50.length > 2 ? _args50[2] : undefined;
                retry = _args50.length > 3 ? _args50[3] : undefined;
                restId = _args50.length > 4 ? _args50[4] : undefined;
                platformIsMobileApp = this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP;
                sessionContext = (_this$rootStore$user$ = this.rootStore.user.sessionDetails) === null || _this$rootStore$user$ === void 0 ? void 0 : (_this$rootStore$user$2 = _this$rootStore$user$.successResponse) === null || _this$rootStore$user$2 === void 0 ? void 0 : _this$rootStore$user$2.sessionContext;
                _storeResturant = (_this$orderSettingsMo32 = this.orderSettingsModel) !== null && _this$orderSettingsMo32 !== void 0 && _this$orderSettingsMo32.resturantSelectedForChangeId ? (_this$orderSettingsMo33 = this.orderSettingsModel) === null || _this$orderSettingsMo33 === void 0 ? void 0 : _this$orderSettingsMo33.resturantSelectedForChangeId : this.restaurantId;
                resturantId = restId !== null && restId !== void 0 ? restId : _storeResturant;
                derrivedDate = selectedDate ? selectedDate : this.timeModel.selectedCalendarDate; //revisit this, send date based on

                if (!resturantId) {
                  _context50.next = 49;
                  break;
                }

                _context50.prev = 11;

                if (!((sessionContext === null || sessionContext === void 0 ? void 0 : sessionContext.orderTypeValue) === 5 && !platformIsMobileApp)) {
                  _context50.next = 14;
                  break;
                }

                return _context50.abrupt("return");

              case 14:
                if (!this.fromConfirmation) {
                  _context50.next = 16;
                  break;
                }

                return _context50.abrupt("return");

              case 16:
                orderType = from === FETCH_TIME_TYPE.PICKUP_FLOW ? 0 : from === FETCH_TIME_TYPE.DINE_IN_FLOW ? 5 : this.menuListModel.orderType;
                _context50.next = 19;
                return handle(DPServices.Times.getPickupTimes(resturantId, orderType, derrivedDate, realtime, sessionContext.isCapacityCheckEnabled, this.timeModel.isAsapSelected));

              case 19:
                _yield$handle3 = _context50.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                timesResponse = _yield$handle4[1];

                if (!timesResponse) {
                  _context50.next = 44;
                  break;
                }

                this.menuListModel.setLunchSlotsAndCurrentTime(timesResponse === null || timesResponse === void 0 ? void 0 : (_timesResponse$times = timesResponse.times) === null || _timesResponse$times === void 0 ? void 0 : _timesResponse$times.lunch, timesResponse === null || timesResponse === void 0 ? void 0 : (_timesResponse$succes = timesResponse.successResponse) === null || _timesResponse$succes === void 0 ? void 0 : _timesResponse$succes.currentTime);
                this.timeModel.currentRequestedDate = derrivedDate.getTime(); // the times call return a lead time only when ASAP is true. And the value returned is consistent to the items in the cart.
                // So when ASAP is true, the returned value can be set as lead time
                // which solves the issue with in consistent lead time showing up as we change from future dates scheduled pickup to current ASAP today.

                if (timesResponse !== null && timesResponse !== void 0 && (_timesResponse$succes2 = timesResponse.successResponse) !== null && _timesResponse$succes2 !== void 0 && _timesResponse$succes2.leadTime) {
                  this.timeModel.setCartLeadTime(timesResponse === null || timesResponse === void 0 ? void 0 : (_timesResponse$succes3 = timesResponse.successResponse) === null || _timesResponse$succes3 === void 0 ? void 0 : _timesResponse$succes3.leadTime, timesResponse === null || timesResponse === void 0 ? void 0 : (_timesResponse$succes4 = timesResponse.successResponse) === null || _timesResponse$succes4 === void 0 ? void 0 : _timesResponse$succes4.asapEnabled);
                }

                runInAction(function () {
                  _this7.timeModel.setCapacitySlotsResponse(timesResponse);

                  _this7.timeModel.setRecentTimeSelectionFromAPi(UserTypes.ERecentTimeSelectionFromAPI.FETCH_TIME_API);

                  _this7.timeModel.setFetchTimeOrderTypeData = from === FETCH_TIME_TYPE.PICKUP_SWITCH ? 0 : timesResponse.orderType;
                });
                this.analyticsModel.dispatchFetchTimesEvent(resturantId, (_this$_restaurantDeta7 = this._restaurantDetail) === null || _this$_restaurantDeta7 === void 0 ? void 0 : _this$_restaurantDeta7.restaurantNum.toString(), this.timeModel.selectedCalendarDate, sessionContext.orderTypeValue, sessionContext.isCapacityCheckEnabled, this.timeModel.isAsapSelected);

                if (from !== FETCH_TIME_TYPE.USER_ACTION) {
                  this.advanceDateIfNeeded(retry, from, derrivedDate, timesResponse);
                }
                /*if (
                  from === FETCH_TIME_TYPE.NEW_LOCATION ||
                  from === FETCH_TIME_TYPE.PICKUP_FLOW
                ) {
                  return await this.updateTimeInNewLocation(timesResponse, from);
                }*/


                responseOrderType = Number(timesResponse === null || timesResponse === void 0 ? void 0 : timesResponse.orderType);

                if (!(from !== FETCH_TIME_TYPE.USER_ACTION)) {
                  _context50.next = 44;
                  break;
                }

                if (!(responseOrderType === ORDER_TYPE.TOGO_PICKUP || responseOrderType === ORDER_TYPE.CATERING_PICKUP)) {
                  _context50.next = 43;
                  break;
                }

                if (!(!this.timeModel.doesApiPickupTimeHasSlot || this.timeModel.doesCartHaveItemWithNoPickupTime || retry)) {
                  _context50.next = 41;
                  break;
                }

                lunch = timesResponse === null || timesResponse === void 0 ? void 0 : (_timesResponse$times2 = timesResponse.times) === null || _timesResponse$times2 === void 0 ? void 0 : _timesResponse$times2.lunch;
                dinner = timesResponse === null || timesResponse === void 0 ? void 0 : (_timesResponse$times3 = timesResponse.times) === null || _timesResponse$times3 === void 0 ? void 0 : _timesResponse$times3.dinner;
                firstSlotDateTime = (lunch === null || lunch === void 0 ? void 0 : lunch.startDateTime) || (dinner === null || dinner === void 0 ? void 0 : dinner.startDateTime); // If user has not confirmed location-time and if user has selected Asap
                //on location-time confirmation  then no need to invoke a setPickupTime

                if (!((_this$orderSettingsMo34 = this.orderSettingsModel) !== null && _this$orderSettingsMo34 !== void 0 && _this$orderSettingsMo34.locationTimeConfirmed)) {
                  _context50.next = 41;
                  break;
                }

                _context50.next = 39;
                return this.setOrderPickupTime(retry ? moment(firstSlotDateTime).toDate() : null, null, false);

              case 39:
                // If not retry then showing the first available slot as new time.
                // since we make setPickupDateAndTime api call also with the same.
                newSelectedTimeDate = retry ? moment(firstSlotDateTime).toDate() : moment((_this$timeModel5 = this.timeModel) !== null && _this$timeModel5 !== void 0 && (_this$timeModel5$curr = _this$timeModel5.currentTimeSlot) !== null && _this$timeModel5$curr !== void 0 && _this$timeModel5$curr.startTimeInMs ? (_this$timeModel6 = this.timeModel) === null || _this$timeModel6 === void 0 ? void 0 : (_this$timeModel6$curr = _this$timeModel6.currentTimeSlot) === null || _this$timeModel6$curr === void 0 ? void 0 : _this$timeModel6$curr.startTimeInMs : undefined).toDate();
                this.appMessages.showError(i18next.t("pickuptime_update_title"), // i18next.t("pickuptime_update_copy"), this copy does not support dynamic time
                i18next.t("pickuptime_update_include_time_copy", {
                  defaultValue: "Your pickup time has been updated to ".concat("\n", " ", formatAMPM(newSelectedTimeDate)),
                  interpolation: {
                    prefix: "${",
                    suffix: "}"
                  },
                  0: formatAMPM(newSelectedTimeDate)
                }));

              case 41:
                _context50.next = 44;
                break;

              case 43:
                if (responseOrderType === ORDER_TYPE.CATERING_DELIVERY) {
                  if (!this.timeModel.isValidDeliveryDate) {
                    this.showCateringDeliveryAnonymousErrorDialog();
                  }
                }

              case 44:
                _context50.next = 49;
                break;

              case 46:
                _context50.prev = 46;
                _context50.t0 = _context50["catch"](11);
                if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) this.appMessages.showError("Error", "Error Fetching Time Slots.");

              case 49:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this, [[11, 46]]);
      }));

      function fetchTimes() {
        return _fetchTimes.apply(this, arguments);
      }

      return fetchTimes;
    }()
  }, {
    key: "advanceDateIfNeeded",
    value: function () {
      var _advanceDateIfNeeded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(retry, from, selectedDate, timesResponse) {
        var _this$timeModel7, _timesResponse$times4, _timesResponse$times5;

        var isRestClosed, availableSlots, timesUnavailable, slotsNotAvailable, nextDay;
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                //const areSlotsAvailable = this.timeModel.areSlotsAvailable;
                isRestClosed = timesResponse === null || timesResponse === void 0 ? void 0 : timesResponse.restaurantClosed;
                availableSlots = (_this$timeModel7 = this.timeModel) === null || _this$timeModel7 === void 0 ? void 0 : _this$timeModel7.availableSlots;
                timesUnavailable = !(timesResponse !== null && timesResponse !== void 0 && (_timesResponse$times4 = timesResponse.times) !== null && _timesResponse$times4 !== void 0 && _timesResponse$times4.lunch) && !(timesResponse !== null && timesResponse !== void 0 && (_timesResponse$times5 = timesResponse.times) !== null && _timesResponse$times5 !== void 0 && _timesResponse$times5.dinner);
                slotsNotAvailable = isRestClosed || (availableSlots === null || availableSlots === void 0 ? void 0 : availableSlots.length) === 0 || timesUnavailable;

                if (!retry && slotsNotAvailable) {
                  nextDay = moment(selectedDate).toDate();
                  nextDay.setDate(nextDay.getDate() + 1);
                  this.fetchTimes(false, nextDay, from, true); //Show message only if there is a confirmed pickupTime

                  if (this.orderSettingsModel.locationTimeConfirmed) {
                    this.appMessages.showError(i18next.t("pickuptime_update_title"), "Some of the items in your cart take a little longer to prepare. Your selected time has been updated to the next available time.");
                  }
                }

              case 5:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));

      function advanceDateIfNeeded(_x31, _x32, _x33, _x34) {
        return _advanceDateIfNeeded.apply(this, arguments);
      }

      return advanceDateIfNeeded;
    }()
    /*private async updateTimeInNewLocation(
      timesResponse: TimesTypes.CapacitySlotsResponse,
      from?: FETCH_TIME_TYPE,
    ): Promise<any> {
      try {
        const allowUpateTime =
          this.orderSettingsModel?.pickupDateTimeSelected ||
          this.orderSettingsModel?.locationTimeConfirmed;
        const newTimesModel = new TimeModel(this.rootStore?.platformUtil);
        if (this.timeModel?.selectedCalendarDate) {
          newTimesModel.selectedCalendarDate =
            this.timeModel?.selectedCalendarDate;
        }
        runInAction(() => {
          newTimesModel.setCapacitySlotsResponse(timesResponse);
        });
        const availableSlots = newTimesModel?.availableSlots;
        const currentTime = this.timeModel?.currentTimeSlot?.startTimeInMs;
        const setPickupTimeRequired = currentTime
          ? !availableSlots.find((_a) =>
              moment(_a.startTimeInMs).isSame(moment(currentTime)),
            )
          : false;
        let nextAvailableSlotStart: number;
        if (setPickupTimeRequired) {
          nextAvailableSlotStart =
            newTimesModel?.getNextAvailableDPSlot(currentTime)?.startTimeInMs;
        }
        if (
          availableSlots?.length &&
          this.timeModel?.isAsapSelected &&
          from !== FETCH_TIME_TYPE.PICKUP_FLOW &&
          this.timeModel?.currentTimeSlot?.startTimeInMs &&
          allowUpateTime
        ) {
          const starTimeSlotStartTimeMs = availableSlots[0].startTimeInMs;
          await this.setOrderPickupTime(new Date(starTimeSlotStartTimeMs));
          this.appMessages.showError(
            "Update to Your Pickup Time",
            "Our apologies, you will need to select a new date and time for the new location selected.",
          );
        } else if (
          nextAvailableSlotStart &&
          from !== FETCH_TIME_TYPE.PICKUP_FLOW &&
          allowUpateTime
        ) {
          await this.setOrderPickupTime(new Date(nextAvailableSlotStart));
          this.appMessages.showError(
            "Update to Your Pickup Time",
            "Our apologies, you will need to select a new date and time for the new location selected.",
          );
        }
        runInAction(() => {
          this.timeModel.setCapacitySlotsResponse(timesResponse);
        });
        this.timeModel.setRecentTimeSelectionFromAPi(
          UserTypes.ERecentTimeSelectionFromAPI.FETCH_TIME_API,
        );
        if (from === FETCH_TIME_TYPE.PICKUP_FLOW) {
          return (
            nextAvailableSlotStart ||
            currentTime ||
            availableSlots[0]?.startTimeInMs
          );
        }
      } catch (e) {
        this.appMessages.showError("Error", "No pickup time available.");
      }
    }*/

  }, {
    key: "showCateringDeliveryAnonymousErrorDialog",
    value: function showCateringDeliveryAnonymousErrorDialog() {
      var _this8 = this;

      this.appMessages.showError(i18next.t("error.cateringdelivery_invalidtime_modal_title", {
        defaultValue: "Continue Delivery Order"
      }), i18next.t("error.cateringdelivery_invalidtime_modal_desc", {
        defaultValue: "Your existing delivery order will be moved to the next available date if you wish to continue."
      }), [], {
        showIconBox: false,
        undismissible: true,
        cancelBtnText: "Order Pickup Instead",
        okBtnText: "Continue",
        okBtnOnClick: function okBtnOnClick() {
          var _this8$rootStore, _this8$rootStore$plat;

          (_this8$rootStore = _this8.rootStore) === null || _this8$rootStore === void 0 ? void 0 : (_this8$rootStore$plat = _this8$rootStore.platformUtil) === null || _this8$rootStore$plat === void 0 ? void 0 : _this8$rootStore$plat.redirectToURL("/delivery/catering-delivery-address");
        },
        cancelBtnOnClick: function () {
          var _cancelBtnOnClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
            return _regeneratorRuntime.wrap(function _callee52$(_context52) {
              while (1) {
                switch (_context52.prev = _context52.next) {
                  case 0:
                    _context52.next = 2;
                    return _this8.deliveryToPickupSwitch();

                  case 2:
                  case "end":
                    return _context52.stop();
                }
              }
            }, _callee52);
          }));

          function cancelBtnOnClick() {
            return _cancelBtnOnClick.apply(this, arguments);
          }

          return cancelBtnOnClick;
        }()
      });
    }
  }, {
    key: "deliveryToPickupSwitch",
    value: function () {
      var _deliveryToPickupSwitch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53() {
        var _this9 = this;

        var _this$rootStore24, _this$rootStore24$use, _this$rootStore24$use2, _this$rootStore24$use3, _this$rootStore24$use4, _this$orderSettingsMo35, _this$timeModel$avail2, _this$orderSettingsMo36, restID, startTime, _this$rootStore25, _this$rootStore25$use, _this$orderSettingsMo37;

        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                _context53.prev = 0;
                restID = (_this$rootStore24 = this.rootStore) === null || _this$rootStore24 === void 0 ? void 0 : (_this$rootStore24$use = _this$rootStore24.user) === null || _this$rootStore24$use === void 0 ? void 0 : (_this$rootStore24$use2 = _this$rootStore24$use.sessionDetails) === null || _this$rootStore24$use2 === void 0 ? void 0 : (_this$rootStore24$use3 = _this$rootStore24$use2.successResponse) === null || _this$rootStore24$use3 === void 0 ? void 0 : (_this$rootStore24$use4 = _this$rootStore24$use3.restaurantDetails) === null || _this$rootStore24$use4 === void 0 ? void 0 : _this$rootStore24$use4.restaurantId;
                (_this$orderSettingsMo35 = this.orderSettingsModel) === null || _this$orderSettingsMo35 === void 0 ? void 0 : _this$orderSettingsMo35.toggleDeliveryToPickupConfirmationLoader(true);
                _context53.next = 5;
                return this.fetchTimes(null, moment().toDate(), FETCH_TIME_TYPE.PICKUP_SWITCH, null, restID);

              case 5:
                startTime = (_this$timeModel$avail2 = this.timeModel.availableSlots[0]) === null || _this$timeModel$avail2 === void 0 ? void 0 : _this$timeModel$avail2.startTimeInMs;

                if (!startTime) {
                  _context53.next = 14;
                  break;
                }

                _context53.next = 9;
                return this.setOrderPickupTimeAndLocation(moment(startTime).toDate(), restID);

              case 9:
                _context53.next = 11;
                return (_this$rootStore25 = this.rootStore) === null || _this$rootStore25 === void 0 ? void 0 : (_this$rootStore25$use = _this$rootStore25.user) === null || _this$rootStore25$use === void 0 ? void 0 : _this$rootStore25$use.updateSession();

              case 11:
                this.orderSettingsModel.showTimeSidebar = false;
                _context53.next = 15;
                break;

              case 14:
                this.appMessages.showError("Error", "No pickup time available.", [], {
                  okBtnText: "OK",
                  undismissible: !this.timeModel.isValidDeliveryDate ? true : false,
                  okBtnOnClick: function okBtnOnClick() {
                    if (!_this9.timeModel.isValidDeliveryDate) {
                      _this9.showCateringDeliveryAnonymousErrorDialog();
                    }
                  }
                });

              case 15:
                (_this$orderSettingsMo36 = this.orderSettingsModel) === null || _this$orderSettingsMo36 === void 0 ? void 0 : _this$orderSettingsMo36.toggleDeliveryToPickupConfirmationLoader(false);
                _context53.next = 22;
                break;

              case 18:
                _context53.prev = 18;
                _context53.t0 = _context53["catch"](0);
                (_this$orderSettingsMo37 = this.orderSettingsModel) === null || _this$orderSettingsMo37 === void 0 ? void 0 : _this$orderSettingsMo37.toggleDeliveryToPickupConfirmationLoader(true);
                this.appMessages.showError("Something went wrong", "Delivery to pickup switch failed", [], {
                  okBtnText: "OK",
                  undismissible: !this.timeModel.isValidDeliveryDate ? true : false,
                  okBtnOnClick: function okBtnOnClick() {
                    if (!_this9.timeModel.isValidDeliveryDate) {
                      _this9.showCateringDeliveryAnonymousErrorDialog();
                    }
                  }
                });

              case 22:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this, [[0, 18]]);
      }));

      function deliveryToPickupSwitch() {
        return _deliveryToPickupSwitch.apply(this, arguments);
      }

      return deliveryToPickupSwitch;
    }()
  }, {
    key: "setOrderPickupTime",
    value: function () {
      var _setOrderPickupTime2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(newPickupTime, removalCommerceIds) {
        var validateCartItems,
            _e$response3,
            _errors$fault,
            _this$rootStore26,
            _this$rootStore26$pla,
            errors,
            faultDesc,
            productIds,
            commerceIDs,
            unAvailableItems,
            _args54 = arguments;

        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                validateCartItems = _args54.length > 2 && _args54[2] !== undefined ? _args54[2] : true;
                _context54.prev = 1;
                _context54.next = 4;
                return this._setOrderPickupTime(newPickupTime, removalCommerceIds, validateCartItems);

              case 4:
                _context54.next = 15;
                break;

              case 6:
                _context54.prev = 6;
                _context54.t0 = _context54["catch"](1);
                errors = _context54.t0 === null || _context54.t0 === void 0 ? void 0 : (_e$response3 = _context54.t0.response) === null || _e$response3 === void 0 ? void 0 : _e$response3.data;
                faultDesc = errors === null || errors === void 0 ? void 0 : (_errors$fault = errors.fault) === null || _errors$fault === void 0 ? void 0 : _errors$fault.faultDescription;
                productIds = [];
                commerceIDs = [];
                unAvailableItems = (errors === null || errors === void 0 ? void 0 : errors.unavailableItems) || [];
                unAvailableItems.forEach(function (item) {
                  productIds.push(item.productId);
                  commerceIDs.push(item.id);
                });

                if (productIds.length > 0 && ((_this$rootStore26 = this.rootStore) === null || _this$rootStore26 === void 0 ? void 0 : (_this$rootStore26$pla = _this$rootStore26.platformUtil) === null || _this$rootStore26$pla === void 0 ? void 0 : _this$rootStore26$pla.PLATFORM_TYPE) === "APP") {
                  this.unavailableItemsModel.setUnavailableProducts(faultDesc, productIds, commerceIDs);
                  this.unavailableItemsModel.setDisplayUnavailableItemIssueModal(true);
                } else {
                  this.handleOrderError(_context54.t0);
                }

              case 15:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this, [[1, 6]]);
      }));

      function setOrderPickupTime(_x35, _x36) {
        return _setOrderPickupTime2.apply(this, arguments);
      }

      return setOrderPickupTime;
    }()
  }, {
    key: "_setOrderPickupTime",
    value: function () {
      var _setOrderPickupTime3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(newPickupTime, removalCommerceIds) {
        var _this$timeModel8,
            _this$timeModel8$curr,
            _this10 = this,
            _this$timeModel9,
            _this$orderSettingsMo38;

        var validateCartItems,
            newSelectedTime,
            newSelectedTimeDate,
            setPickupResponse,
            _args55 = arguments;
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                validateCartItems = _args55.length > 2 && _args55[2] !== undefined ? _args55[2] : true;
                newSelectedTime = newPickupTime !== null && newPickupTime !== void 0 ? newPickupTime : (_this$timeModel8 = this.timeModel) === null || _this$timeModel8 === void 0 ? void 0 : (_this$timeModel8$curr = _this$timeModel8.currentTimeSlot) === null || _this$timeModel8$curr === void 0 ? void 0 : _this$timeModel8$curr.startTimeInMs;
                console.log("*** _setOrderPickupTime newSelectedTime ".concat(newSelectedTime));
                newSelectedTimeDate = moment(newSelectedTime).toDate();
                console.log("*** _setOrderPickupTime newSelectedTimeDate ".concat(newSelectedTimeDate));
                _context55.next = 7;
                return DPServices.Times.setOrderPickupTime(newSelectedTimeDate, true, newPickupTime ? false : this.timeModel.isAsapSelected, removalCommerceIds, validateCartItems);

              case 7:
                setPickupResponse = _context55.sent;
                runInAction(function () {
                  _this10.timeModel.setPickupTimeResponse(setPickupResponse);
                });
                (_this$timeModel9 = this.timeModel) === null || _this$timeModel9 === void 0 ? void 0 : _this$timeModel9.setRecentTimeSelectionFromAPi(UserTypes.ERecentTimeSelectionFromAPI.SET_PICKUP_TIME_API);
                (_this$orderSettingsMo38 = this.orderSettingsModel) === null || _this$orderSettingsMo38 === void 0 ? void 0 : _this$orderSettingsMo38.setPickupDatetimeselected(true);
                this.analyticsModel.dispatchSetOrderPickupTimeEvent(formatDate(newSelectedTimeDate), formatAMPM(newSelectedTimeDate), this.timeModel.isAsapSelected);

              case 12:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));

      function _setOrderPickupTime(_x37, _x38) {
        return _setOrderPickupTime3.apply(this, arguments);
      }

      return _setOrderPickupTime;
    }()
  }, {
    key: "setOrderPickupTimeAndLocation",
    value: function () {
      var _setOrderPickupTimeAndLocation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(newtime, newRestaurantId, orderFlow) {
        var _e$response4, _errors$fault2, errors, faultDesc;

        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                _context56.prev = 0;
                _context56.next = 3;
                return this._setOrderPickupTimeAndLocation(newtime, newRestaurantId, orderFlow);

              case 3:
                _context56.next = 10;
                break;

              case 5:
                _context56.prev = 5;
                _context56.t0 = _context56["catch"](0); // this.appMessages.showError("Error", "Error Setting Time");

                errors = _context56.t0 === null || _context56.t0 === void 0 ? void 0 : (_e$response4 = _context56.t0.response) === null || _e$response4 === void 0 ? void 0 : _e$response4.data;
                faultDesc = errors === null || errors === void 0 ? void 0 : (_errors$fault2 = errors.fault) === null || _errors$fault2 === void 0 ? void 0 : _errors$fault2.faultDescription;
                throw new Error(faultDesc || "Error Setting Time");

              case 10:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this, [[0, 5]]);
      }));

      function setOrderPickupTimeAndLocation(_x39, _x40, _x41) {
        return _setOrderPickupTimeAndLocation2.apply(this, arguments);
      }

      return setOrderPickupTimeAndLocation;
    }() // /*
    //     Syncs up locally selected time at component level with the current timeslot in timemodel.
    // */
    // private syncWithLocalDateTimeSelection() {
    //   if (this.timeModel?.localSelectedTime && !this.timeModel.isAsapSelected) {
    //     this.timeModel.selectedCalendarDate = moment(
    //       this.timeModel?.localSelectedDate,
    //       DATE_FORMAT,
    //     ).toDate();
    //     this.timeModel.onTimeSlotSelection(this.timeModel?.localSelectedTime);
    //   }
    // }

  }, {
    key: "_setOrderPickupTimeAndLocation",
    value: function () {
      var _setOrderPickupTimeAndLocation3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(newtime, newRestaurantId) {
        var _this$timeModel10, _this$timeModel10$cur;

        var orderFlow,
            newSelectedTime,
            newSelectedTimeDate,
            currentRestaurantId,
            restaurantNum,
            _this$timeModel11,
            _this$cartModel8,
            cartId,
            serializedCartId,
            _args57 = arguments;

        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                orderFlow = _args57.length > 2 && _args57[2] !== undefined ? _args57[2] : "togo-pickup-order";
                newSelectedTime = newtime !== null && newtime !== void 0 ? newtime : (_this$timeModel10 = this.timeModel) === null || _this$timeModel10 === void 0 ? void 0 : (_this$timeModel10$cur = _this$timeModel10.currentTimeSlot) === null || _this$timeModel10$cur === void 0 ? void 0 : _this$timeModel10$cur.startTimeInMs;
                newSelectedTimeDate = newSelectedTime ? moment(newSelectedTime).toDate() : moment().toDate();
                currentRestaurantId = newRestaurantId !== null && newRestaurantId !== void 0 ? newRestaurantId : this.orderSettingsModel.currentRestaurantId;
                restaurantNum = newRestaurantId !== null && newRestaurantId !== void 0 ? newRestaurantId : this.orderSettingsModel.currentRestaurant.restaurantNum;

                if (!currentRestaurantId) {
                  _context57.next = 12;
                  break;
                }

                _context57.next = 8;
                return DPServices.Times.setOrderRestaurantAndPickupTime(currentRestaurantId, newSelectedTimeDate, orderFlow, false, newtime ? false : this.timeModel.isAsapSelected);

              case 8:
                (_this$timeModel11 = this.timeModel) === null || _this$timeModel11 === void 0 ? void 0 : _this$timeModel11.setRecentTimeSelectionFromAPi(UserTypes.ERecentTimeSelectionFromAPI.LOCATION_CONFIRMATION_API);
                cartId = (_this$cartModel8 = this.cartModel) === null || _this$cartModel8 === void 0 ? void 0 : _this$cartModel8.orderId;
                serializedCartId = {
                  "&&events": "event161:".concat(cartId)
                };
                this.analyticsModel.dispatchSetOrderPickupTimeAndLocationEvent(currentRestaurantId, restaurantNum, formatDate(newSelectedTimeDate), formatAMPM(newSelectedTimeDate), this.timeModel.isAsapSelected, serializedCartId);

              case 12:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));

      function _setOrderPickupTimeAndLocation(_x42, _x43) {
        return _setOrderPickupTimeAndLocation3.apply(this, arguments);
      }

      return _setOrderPickupTimeAndLocation;
    }()
  }, {
    key: "isMenuOrSubCategory",
    value: function isMenuOrSubCategory(slug) {
      var result = null;

      if (this._menuList) {
        var _iterator = _createForOfIteratorHelper(this._menuList.subCategories),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _cat$menucategories, _cat$menu;

            var cat = _step.value;
            var subCats = (_cat$menucategories = cat === null || cat === void 0 ? void 0 : cat.menucategories) !== null && _cat$menucategories !== void 0 ? _cat$menucategories : [];
            var menuUnderCat = (_cat$menu = cat === null || cat === void 0 ? void 0 : cat.menu) !== null && _cat$menu !== void 0 ? _cat$menu : [];

            var _iterator3 = _createForOfIteratorHelper(subCats),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var subCat = _step3.value;

                if (subCat.slug === slug) {
                  result = "CATEGORY";
                  break;
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (result === null) {
          var _this$menuListModel10;

          var _iterator2 = _createForOfIteratorHelper((_this$menuListModel10 = this.menuListModel) === null || _this$menuListModel10 === void 0 ? void 0 : _this$menuListModel10.menulistItems),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var m = _step2.value;

              if (m.id === slug) {
                result = "MENU";
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }

      return result;
    }
  }, {
    key: "saveToFavorites",
    value: function () {
      var _saveToFavorites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(productId) {
        var response, giftListItemId, giftListId;
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                _context58.prev = 0;
                _context58.next = 3;
                return DPServices.Menu.saveToFavorites(productId);

              case 3:
                response = _context58.sent;

                if ((response === null || response === void 0 ? void 0 : response.status) === "success") {
                  this.rootStore.platformUtil.clearLocalStorage(["FAVORITE_PRODUCTS"]);
                  giftListItemId = response.giftListItemId, giftListId = response.giftListId;
                  this.menuListModel.setFavorite({
                    giftListId: giftListId,
                    giftListItemId: giftListItemId,
                    productId: productId
                  });
                  this.analyticsModel.dispatchSaveToFavoritesEvent(giftListId, giftListItemId, productId);
                }

                _context58.next = 10;
                break;

              case 7:
                _context58.prev = 7;
                _context58.t0 = _context58["catch"](0);
                console.error(_context58.t0);

              case 10:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this, [[0, 7]]);
      }));

      function saveToFavorites(_x44) {
        return _saveToFavorites.apply(this, arguments);
      }

      return saveToFavorites;
    }()
  }, {
    key: "removeFromFavorites",
    value: function () {
      var _removeFromFavorites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(productId) {
        var _this$menuListModel11, favoriteToRemove, response, filteredFavs;

        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _context59.prev = 0;
                favoriteToRemove = (_this$menuListModel11 = this.menuListModel) === null || _this$menuListModel11 === void 0 ? void 0 : _this$menuListModel11.favorites.find(function (fav) {
                  return fav.productId === productId;
                });
                _context59.next = 4;
                return DPServices.Menu.removeFromFavorites(favoriteToRemove.giftItemId, favoriteToRemove.giftListId);

              case 4:
                response = _context59.sent;
                this.rootStore.platformUtil.clearLocalStorage(["FAVORITE_PRODUCTS"]);
                this.analyticsModel.dispatchRemoveFromFavoritesEvent(favoriteToRemove.giftListId, favoriteToRemove.giftItemId, productId);

                if (response.successResponse === "success") {
                  filteredFavs = this.menuListModel.favorites.filter(function (fav) {
                    return fav.productId !== productId;
                  });
                  this.menuListModel.setFavorites(filteredFavs);
                }

                _context59.next = 13;
                break;

              case 10:
                _context59.prev = 10;
                _context59.t0 = _context59["catch"](0);
                console.error(_context59.t0);

              case 13:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this, [[0, 10]]);
      }));

      function removeFromFavorites(_x45) {
        return _removeFromFavorites.apply(this, arguments);
      }

      return removeFromFavorites;
    }()
    /*
      default menu is enabled
      no restaurant selected
      prepare menuDetails data from menulist
    */

  }, {
    key: "prepareMenuDetailsDataFromMenuList",
    value: function prepareMenuDetailsDataFromMenuList(menuId) {
      var _this$menuListModel12;

      if ((_this$menuListModel12 = this.menuListModel) !== null && _this$menuListModel12 !== void 0 && _this$menuListModel12.menulistItems) {
        var _this$menuListModel13, _this$menuListModel14;

        var item = (_this$menuListModel13 = this.menuListModel) === null || _this$menuListModel13 === void 0 ? void 0 : (_this$menuListModel14 = _this$menuListModel13.menulistItems) === null || _this$menuListModel14 === void 0 ? void 0 : _this$menuListModel14.find(function (_item) {
          return _item.id === menuId;
        });
        if (!item) return null;
        var detilObject = {
          successResponse: {
            menuId: menuId,
            nutritionaldetails: [{
              nutritionalFDAMessage: item.nutritionalFDAMessage || item.calorieCount,
              calValue: item.calorieCount
            }],
            menubean: [],
            product: {
              longDescription: item.longDescription,
              displayName: item.name,
              largeImageUrl: item.imageUrl,
              mobileAppLargeImage: item.imageUrl,
              mobileAppSmallImage: item.imageUrl,
              repositoryId: menuId,
              isToGo: !item.isDineInOnly,
              description: item.description
            },
            price: [{
              listPrice: item.price
            }]
          }
        };
        return detilObject;
      }

      return null;
    }
  }, {
    key: "getRecommendations",
    value: function () {
      var _getRecommendations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(params) {
        var _this$_restaurantDeta8;

        var recommendations;
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.next = 2;
                return DPServices.Menu.getRecommentation(params);

              case 2:
                recommendations = _context60.sent;
                this.menuDetailModel.setRecommendationData(recommendations);
                this.analyticsModel.dispatchGetRecommendationsEvent(this.restaurantId, (_this$_restaurantDeta8 = this._restaurantDetail) === null || _this$_restaurantDeta8 === void 0 ? void 0 : _this$_restaurantDeta8.restaurantNum.toString(), recommendations, "productDetail");

              case 5:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));

      function getRecommendations(_x46) {
        return _getRecommendations.apply(this, arguments);
      }

      return getRecommendations;
    }()
    /*private analyticsFailedSubmitOrderEvent() {
      this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "Payment", {
        success: false,
      });
    }*/

  }, {
    key: "loadMenuDetail",
    value: function () {
      var _loadMenuDetail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(menuId, catergory, isRecomm) {
        var apiRespClone, _this$cartModel9, _this$_restaurantDeta9, _this$menuDetailModel, _this$menuDetailModel2, _this$menuDetailModel3, _this$menuDetailModel4, _this$menuDetailModel5, _this$menuDetailModel6, _this$menuDetailModel7, _this$menuDetailModel8, _this$menuDetailModel9, _this$menuDetailModel10, productData, _this$orderSettingsMo39, _this$menuListModel15, marketingCloudVisitorId, _apiRespClone, _apiRespClone$success, _this$rootStore27, _this$rootStore27$pla, recommendationObj, rawAPIResponse, cartId, serializedCartId, _this$orderSettingsMo40, _this$menuListModel16, resturantId, _marketingCloudVisitorId, _apiRespClone2, _apiRespClone2$succes, _this$rootStore28, _this$rootStore28$pla, _recommendationObj;

        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                _context61.prev = 0;

                if (!this.isLocationSelectionMandatory) {
                  _context61.next = 3;
                  break;
                }

                return _context61.abrupt("return");

              case 3:
                if (this.restaurantId) {
                  _context61.next = 23;
                  break;
                }

                productData = this.prepareMenuDetailsDataFromMenuList(menuId);

                if (!productData) {
                  _context61.next = 21;
                  break;
                }

                this.menuDetailModel.setMenuItemDetailData(new MenuItemDetail(productData));
                marketingCloudVisitorId = this.marketingCloudVisitorId();

                if ((_this$orderSettingsMo39 = this.orderSettingsModel) !== null && _this$orderSettingsMo39 !== void 0 && _this$orderSettingsMo39.isDineInEnabled) {
                  _context61.next = 16;
                  break;
                }

                recommendationObj = {
                  numberOfRecommandtions: this.menuDetailsRecommendationsThreshold,
                  id: menuId,
                  excludedIds: menuId,
                  categoryType: (_apiRespClone = apiRespClone) === null || _apiRespClone === void 0 ? void 0 : (_apiRespClone$success = _apiRespClone.successResponse) === null || _apiRespClone$success === void 0 ? void 0 : _apiRespClone$success.categoryType,
                  name: this.menuDetailsRecommendationsMboxName,
                  recType: "productDetail",
                  marketingCloudVisitorId: marketingCloudVisitorId
                };

                if (!(((_this$rootStore27 = this.rootStore) === null || _this$rootStore27 === void 0 ? void 0 : (_this$rootStore27$pla = _this$rootStore27.platformUtil) === null || _this$rootStore27$pla === void 0 ? void 0 : _this$rootStore27$pla.PLATFORM_TYPE) === "APP")) {
                  _context61.next = 14;
                  break;
                }

                this.getRecommendations(recommendationObj);
                _context61.next = 16;
                break;

              case 14:
                _context61.next = 16;
                return this.getRecommendations(recommendationObj);

              case 16:
                this.menuDetailModel.setCategoryData(catergory);
                this.menuDetailModel.setMenuListData((_this$menuListModel15 = this.menuListModel) === null || _this$menuListModel15 === void 0 ? void 0 : _this$menuListModel15.menulistItems);
                this.menuDetailModel.quantity = 1;
                _context61.next = 22;
                break;

              case 21:
                this.appMessages.showError( // eslint-disable-next-line sonarjs/no-duplicate-string
                "Error Loading Menu", // eslint-disable-next-line sonarjs/no-duplicate-string
                "Please select a location, and try again");

              case 22:
                return _context61.abrupt("return");

              case 23:
                this.menuDetailModel.setReturantId(this.restaurantId);
                this.menuDetailModel.setIsFromRecommended(isRecomm);
                this.menuDetailModel.setIsMenuItemLoading(true);
                _context61.next = 28;
                return DPServices.Menu.getMenuItemDetail(this.restaurantId, menuId, this.isDipo ? 5 : undefined);

              case 28:
                rawAPIResponse = _context61.sent;
                apiRespClone = rawAPIResponse;
                this.menuDetailModel.setMenuItemDetailData(new MenuItemDetail(rawAPIResponse));
                this.analyticsModel.setMenuItemDetailData(new MenuItemDetail(rawAPIResponse));
                cartId = (_this$cartModel9 = this.cartModel) === null || _this$cartModel9 === void 0 ? void 0 : _this$cartModel9.orderId;
                serializedCartId = {
                  "&&events": "event164:".concat(cartId)
                };
                this.menuDetailModel.setIsMenuItemLoading(false);
                this.analyticsModel.dispatchLoadMenuDetailEvent(this.restaurantId, (_this$_restaurantDeta9 = this._restaurantDetail) === null || _this$_restaurantDeta9 === void 0 ? void 0 : _this$_restaurantDeta9.restaurantNum.toString(), catergory, "Product Details", "menu", null, null, null, (_this$menuDetailModel = this.menuDetailModel) === null || _this$menuDetailModel === void 0 ? void 0 : (_this$menuDetailModel2 = _this$menuDetailModel.menuItem) === null || _this$menuDetailModel2 === void 0 ? void 0 : _this$menuDetailModel2.price, (_this$menuDetailModel3 = this.menuDetailModel) === null || _this$menuDetailModel3 === void 0 ? void 0 : (_this$menuDetailModel4 = _this$menuDetailModel3.menuItem) === null || _this$menuDetailModel4 === void 0 ? void 0 : _this$menuDetailModel4.id, (_this$menuDetailModel5 = this.menuDetailModel) === null || _this$menuDetailModel5 === void 0 ? void 0 : (_this$menuDetailModel6 = _this$menuDetailModel5.menuItem) === null || _this$menuDetailModel6 === void 0 ? void 0 : _this$menuDetailModel6.name, (_this$menuDetailModel7 = this.menuDetailModel) === null || _this$menuDetailModel7 === void 0 ? void 0 : (_this$menuDetailModel8 = _this$menuDetailModel7.selectedMenuItemDetail) === null || _this$menuDetailModel8 === void 0 ? void 0 : _this$menuDetailModel8.description, (_this$menuDetailModel9 = this.menuDetailModel) === null || _this$menuDetailModel9 === void 0 ? void 0 : (_this$menuDetailModel10 = _this$menuDetailModel9.menuItem) === null || _this$menuDetailModel10 === void 0 ? void 0 : _this$menuDetailModel10.isSuggested, false, false, serializedCartId);
                _context61.next = 42;
                break;

              case 38:
                _context61.prev = 38;
                _context61.t0 = _context61["catch"](0);
                this.menuDetailModel.setIsMenuItemLoading(false);
                this.appMessages.showError( // eslint-disable-next-line sonarjs/no-duplicate-string
                "Error Loading Menu", // eslint-disable-next-line sonarjs/no-duplicate-string
                "We could not load menu detail at this time. Please try again");

              case 42:
                _context61.prev = 42;
                resturantId = this.restaurantId;
                _marketingCloudVisitorId = this.marketingCloudVisitorId();

                if ((_this$orderSettingsMo40 = this.orderSettingsModel) !== null && _this$orderSettingsMo40 !== void 0 && _this$orderSettingsMo40.isDineInEnabled) {
                  _context61.next = 53;
                  break;
                }

                _recommendationObj = {
                  restaurantId: Number(resturantId),
                  numberOfRecommandtions: this.menuDetailsRecommendationsThreshold,
                  id: menuId,
                  excludedIds: menuId,
                  categoryType: (_apiRespClone2 = apiRespClone) === null || _apiRespClone2 === void 0 ? void 0 : (_apiRespClone2$succes = _apiRespClone2.successResponse) === null || _apiRespClone2$succes === void 0 ? void 0 : _apiRespClone2$succes.categoryType,
                  name: this.menuDetailsRecommendationsMboxName,
                  recType: "productDetail",
                  marketingCloudVisitorId: _marketingCloudVisitorId
                };

                if (!(((_this$rootStore28 = this.rootStore) === null || _this$rootStore28 === void 0 ? void 0 : (_this$rootStore28$pla = _this$rootStore28.platformUtil) === null || _this$rootStore28$pla === void 0 ? void 0 : _this$rootStore28$pla.PLATFORM_TYPE) === "APP")) {
                  _context61.next = 51;
                  break;
                }

                this.getRecommendations(_recommendationObj);
                _context61.next = 53;
                break;

              case 51:
                _context61.next = 53;
                return this.getRecommendations(_recommendationObj);

              case 53:
                this.menuDetailModel.setMenuListData((_this$menuListModel16 = this.menuListModel) === null || _this$menuListModel16 === void 0 ? void 0 : _this$menuListModel16.menulistItems);
                this.menuDetailModel.setCategoryData(catergory);
                this.menuDetailModel.quantity = 1;
                _context61.next = 60;
                break;

              case 58:
                _context61.prev = 58;
                _context61.t1 = _context61["catch"](42);

              case 60:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, this, [[0, 38], [42, 58]]);
      }));

      function loadMenuDetail(_x47, _x48, _x49) {
        return _loadMenuDetail.apply(this, arguments);
      }

      return loadMenuDetail;
    }()
  }, {
    key: "onLocationConfirmChange",
    value: function () {
      var _onLocationConfirmChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62() {
        var _this$_restaurantDeta10, _this$timeModel12, _this$timeModel13;

        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                // this.orderSettingsModel.showOrderSettingsConfirmationModal = false;
                // this.orderSettingsModel.showRestaurantSearchModal = true;
                this.openLocationSearchModal();

                try {
                  this.analyticsModel.dispatchLocationConfirmChangeEvent(this.restaurantId, (_this$_restaurantDeta10 = this._restaurantDetail) === null || _this$_restaurantDeta10 === void 0 ? void 0 : _this$_restaurantDeta10.restaurantNum.toString(), true, formatDate((_this$timeModel12 = this.timeModel) === null || _this$timeModel12 === void 0 ? void 0 : _this$timeModel12.selectedCalendarDate), formatAMPM((_this$timeModel13 = this.timeModel) === null || _this$timeModel13 === void 0 ? void 0 : _this$timeModel13.selectedTimeSlot), false, this.rootStore.user.sessionDetails.successResponse.sessionContext.orderTypeValue, false);
                } catch (error) {}

              case 2:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));

      function onLocationConfirmChange() {
        return _onLocationConfirmChange.apply(this, arguments);
      }

      return onLocationConfirmChange;
    }()
  }, {
    key: "onTimeConfirmChange",
    value: function () {
      var _onTimeConfirmChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63() {
        var _this$timeModel14, _this$timeModel15;

        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                this.orderSettingsModel.showOrderSettingsConfirmationModal = false;
                this.orderSettingsModel.showTimeSidebar = true;
                this.analyticsModel.dispatchTimeConfirmChangeEvent(formatDate((_this$timeModel14 = this.timeModel) === null || _this$timeModel14 === void 0 ? void 0 : _this$timeModel14.selectedCalendarDate), formatAMPM((_this$timeModel15 = this.timeModel) === null || _this$timeModel15 === void 0 ? void 0 : _this$timeModel15.currentTimeSlot), this.timeModel.isAsapSelected);

              case 3:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));

      function onTimeConfirmChange() {
        return _onTimeConfirmChange.apply(this, arguments);
      }

      return onTimeConfirmChange;
    }()
    /*
        Confirm selected location and time before add to cart, required only once per session and for togo pickup.
        i) Validateds selected time.
        ii) Set Pickup Time and Location.
        iii) Calls add to cart / reorder.
    */

  }, {
    key: "onLocationTimeConfirm",
    value: function () {
      var _onLocationTimeConfirm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64() {
        var _this11 = this;

        var _this$rootStore29, _this$rootStore29$use, _this$menuListModel17, _this$menuListModel18, _this$menuListModel19, _this$menuListModel20, _this$menuListModel21, _this$menuListModel22, _this$menuListModel23, _this$menuListModel24, _this$menuListModel25, _this$menuListModel26, errMsg;

        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                _context64.prev = 0;
                this.orderSettingsModel.toggleConfirmTimeLocationLoader(true);
                this.timeModel.syncAsapSelectionData();
                _context64.next = 5;
                return this.setOrderPickupTimeAndLocation();

              case 5:
                this.orderSettingsModel.toggleConfirmTimeLocationLoader(false);
                this.orderSettingsModel.showOrderSettingsConfirmationModal = false;
                this.orderSettingsModel.setLocationTimeConfirmData(true);

                if (!this._isReorderAddToCart) {
                  _context64.next = 13;
                  break;
                }

                _context64.next = 11;
                return this.reOrderAddToCart(this.orderHistoryModel.currentOrderDetails.orderId, this.orderHistoryModel.currentOrderDetails.itemId);

              case 11:
                _context64.next = 20;
                break;

              case 13:
                if (!this._isReorderAddAllToCart) {
                  _context64.next = 18;
                  break;
                }

                _context64.next = 16;
                return this.reOrderAddAllToCart(this.orderHistoryModel.currentOrderDetails.orderId);

              case 16:
                _context64.next = 20;
                break;

              case 18:
                _context64.next = 20;
                return this.addToCart((_this$menuListModel17 = this.menuListModel) === null || _this$menuListModel17 === void 0 ? void 0 : (_this$menuListModel18 = _this$menuListModel17.quickAddItem) === null || _this$menuListModel18 === void 0 ? void 0 : _this$menuListModel18.productId, (_this$menuListModel19 = this.menuListModel) === null || _this$menuListModel19 === void 0 ? void 0 : (_this$menuListModel20 = _this$menuListModel19.quickAddItem) === null || _this$menuListModel20 === void 0 ? void 0 : _this$menuListModel20.type, (_this$menuListModel21 = this.menuListModel) === null || _this$menuListModel21 === void 0 ? void 0 : (_this$menuListModel22 = _this$menuListModel21.quickAddItem) === null || _this$menuListModel22 === void 0 ? void 0 : _this$menuListModel22.isSimpleProduct, (_this$menuListModel23 = this.menuListModel) === null || _this$menuListModel23 === void 0 ? void 0 : (_this$menuListModel24 = _this$menuListModel23.quickAddItem) === null || _this$menuListModel24 === void 0 ? void 0 : _this$menuListModel24.isFrom, (_this$menuListModel25 = this.menuListModel) === null || _this$menuListModel25 === void 0 ? void 0 : (_this$menuListModel26 = _this$menuListModel25.quickAddItem) === null || _this$menuListModel26 === void 0 ? void 0 : _this$menuListModel26.isRecommended);

              case 20:
                runInAction(function () {
                  _this11._isReorderAddToCart = false;
                  _this11._isReorderAddAllToCart = false;
                });
                _context64.next = 23;
                return (_this$rootStore29 = this.rootStore) === null || _this$rootStore29 === void 0 ? void 0 : (_this$rootStore29$use = _this$rootStore29.user) === null || _this$rootStore29$use === void 0 ? void 0 : _this$rootStore29$use.updateSession();

              case 23:
                _context64.next = 30;
                break;

              case 25:
                _context64.prev = 25;
                _context64.t0 = _context64["catch"](0);
                this.orderSettingsModel.toggleConfirmTimeLocationLoader(false);
                errMsg = typeof _context64.t0 === "string" ? _context64.t0 : _context64.t0 === null || _context64.t0 === void 0 ? void 0 : _context64.t0.message;
                this.appMessages.showError("Something went wrong", errMsg || "Location and Time confirmation failed");

              case 30:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this, [[0, 25]]);
      }));

      function onLocationTimeConfirm() {
        return _onLocationTimeConfirm.apply(this, arguments);
      }

      return onLocationTimeConfirm;
    }()
  }, {
    key: "getModelFromType",
    value: function getModelFromType(type) {
      if (type === "quick-add") return this.menuQuickAddModel;else return this.menuDetailModel;
    }
  }, {
    key: "reOrderAddAllToCart",
    value: function () {
      var _reOrderAddAllToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(orderId) {
        var _this$menuListModel27,
            _this$orderSettingsMo41,
            _this12 = this;

        var orderItems, isDefaultMenuSupported, isLocationConfirmed, orderType, itemCount, unavailableItems, availableItems, index, itemsName;
        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                this.orderHistoryModel.setCurrentOrderDetails({
                  orderId: orderId
                });
                orderItems = this.orderHistoryModel.getRequiredAddAllToCartData(orderId);
                isDefaultMenuSupported = (_this$menuListModel27 = this.menuListModel) === null || _this$menuListModel27 === void 0 ? void 0 : _this$menuListModel27.isDefaultMenuSupported;
                isLocationConfirmed = (_this$orderSettingsMo41 = this.orderSettingsModel) === null || _this$orderSettingsMo41 === void 0 ? void 0 : _this$orderSettingsMo41.locationTimeConfirmed;
                orderType = this.menuListModel.orderType;
                itemCount = this.rootStore.user.sessionDetails.successResponse.sessionContext.itemCount;

                if (!(isDefaultMenuSupported && !this.restaurantId)) {
                  _context65.next = 9;
                  break;
                }

                this.openLocationSearchModal();
                return _context65.abrupt("return");

              case 9:
                if (isLocationConfirmed) {
                  _context65.next = 16;
                  break;
                }

                this._isReorderAddAllToCart = true;
                _context65.next = 13;
                return this.fetchTimes();

              case 13:
                this.orderSettingsModel.showOrderSettingsConfirmationModal = true;
                _context65.next = 17;
                break;

              case 16:
                if (orderType === ORDER_TYPES.GIFT_CARD && itemCount > 0) {
                  this.cartModel.setGiftCardPresentMessageVisibility(true);
                } else {
                  unavailableItems = [];
                  availableItems = [];

                  for (index = 0; index < orderItems.length; index++) {
                    if (orderItems[index].isUnavailable) {
                      unavailableItems.push(orderItems[index]);
                    } else {
                      availableItems.push(orderItems[index]);
                    }
                  }

                  if (unavailableItems.length > 0) {
                    itemsName = "";
                    unavailableItems.forEach(function (item) {
                      // eslint-disable-next-line
                      // @ts-ignore
                      var productID = item.productId;
                      itemsName += "-".concat(_this12.orderHistoryModel.getItemName(orderId, productID), "\n");
                    });
                    this.appMessages.showError("Item(s) Not Available", "One or more of the items that you are trying to reorder from your original order are not currently available.\n\nIf you proceed the following items will not be added to the cart : \n\n".concat(itemsName), null, {
                      undismissible: true,
                      cancelBtnText: "Cancel",
                      okBtnText: "Continue",
                      okBtnOnClick: function okBtnOnClick() {
                        if ((availableItems === null || availableItems === void 0 ? void 0 : availableItems.length) > 0) {
                          _this12._doReorderAddAllToCart(availableItems, orderId);
                        }
                      }
                    });
                  } else {
                    this._doReorderAddAllToCart(availableItems, orderId);
                  }
                }

              case 17:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, this);
      }));

      function reOrderAddAllToCart(_x50) {
        return _reOrderAddAllToCart.apply(this, arguments);
      }

      return reOrderAddAllToCart;
    }()
  }, {
    key: "_doReorderAddAllToCart",
    value: function () {
      var _doReorderAddAllToCart2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(orderItems, orderId) {
        var _this13 = this;

        var successResponse, errorResponse, index, _response$order$comme, _this$cartModel10, orderItem, response, currentItem, cartId, serializedCartId, _orderItem$subItem, _orderItem$subItem$ma, _ref11, _orderItem$priceInfo, _orderItem$productInf, _orderItem$productRef, totalBreadCount, addOnsPrice, basePrice, _successResponse, _successResponse2, _successResponse2$ord, _successResponse3, _successResponse$slic, _successResponse$slic2, itemsName;

        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                successResponse = [];
                errorResponse = [];
                index = 0;

              case 3:
                if (!(index < orderItems.length)) {
                  _context66.next = 22;
                  break;
                }

                _context66.prev = 4;
                orderItem = orderItems[index];
                _context66.next = 8;
                return DPServices.Cart.addItem(this.orderSettingsModel.currentRestaurantId, orderItem.productId, [orderItem.catalogRefIds], orderItem.selectedIds, orderItem.quantity, orderItem.configQuantity, orderItem.fromPage, orderItem.smartRecommended, orderItem.itemInstructions, orderItem.guestName // "DEFAULT_COURSE", TODO: confirm field for reorder itemCourse
                );

              case 8:
                response = _context66.sent;
                currentItem = response === null || response === void 0 ? void 0 : (_response$order$comme = response.order.commerceItems) === null || _response$order$comme === void 0 ? void 0 : _response$order$comme[(response === null || response === void 0 ? void 0 : response.order.commerceItems.length) - 1];
                cartId = (_this$cartModel10 = this.cartModel) === null || _this$cartModel10 === void 0 ? void 0 : _this$cartModel10.orderId;
                serializedCartId = {
                  "&&events": "event158:".concat(cartId)
                };

                try {
                  totalBreadCount = this.breadSticksModel.totalBreadCount;
                  addOnsPrice = orderItem === null || orderItem === void 0 ? void 0 : (_orderItem$subItem = orderItem.subItem) === null || _orderItem$subItem === void 0 ? void 0 : (_orderItem$subItem$ma = _orderItem$subItem.map(function (item) {
                    return item === null || item === void 0 ? void 0 : item.unitPrice;
                  })) === null || _orderItem$subItem$ma === void 0 ? void 0 : _orderItem$subItem$ma.reduce(function (prev, curr) {
                    return prev + curr;
                  }, 0);
                  basePrice = parseFloat((_ref11 = (orderItem === null || orderItem === void 0 ? void 0 : (_orderItem$priceInfo = orderItem.priceInfo) === null || _orderItem$priceInfo === void 0 ? void 0 : _orderItem$priceInfo.listPrice) - addOnsPrice) === null || _ref11 === void 0 ? void 0 : _ref11.toFixed(2));
                  this.analyticsModel.dispatchAddToCartEvent("quick-add", orderItem === null || orderItem === void 0 ? void 0 : orderItem.fromPage, "menu", null, null, null, basePrice, orderItem === null || orderItem === void 0 ? void 0 : (_orderItem$productInf = orderItem.productInfo) === null || _orderItem$productInf === void 0 ? void 0 : _orderItem$productInf.listPrice, "USD", orderItem === null || orderItem === void 0 ? void 0 : orderItem.subItem, orderItem === null || orderItem === void 0 ? void 0 : orderItem.productId, orderItem === null || orderItem === void 0 ? void 0 : orderItem.displayName, orderItem === null || orderItem === void 0 ? void 0 : (_orderItem$productRef = orderItem.productRef) === null || _orderItem$productRef === void 0 ? void 0 : _orderItem$productRef.description, orderItem === null || orderItem === void 0 ? void 0 : orderItem.catalogRefId, orderItem === null || orderItem === void 0 ? void 0 : orderItem.smartRecommended, true, false, currentItem === null || currentItem === void 0 ? void 0 : currentItem.breadCount, totalBreadCount, serializedCartId, "reorder");
                } catch (error) {}

                successResponse.push(response);
                _context66.next = 19;
                break;

              case 16:
                _context66.prev = 16;
                _context66.t0 = _context66["catch"](4);
                errorResponse.push(_context66.t0);

              case 19:
                index++;
                _context66.next = 3;
                break;

              case 22:
                if (successResponse.length > 0) {
                  this.cartModel.setCartData( // eslint-disable-next-line
                  // @ts-ignore
                  (_successResponse = successResponse[successResponse.length - 1]) === null || _successResponse === void 0 ? void 0 : _successResponse.order);
                  this.breadSticksModel.cartItems = (_successResponse2 = successResponse[successResponse.length - 1]) === null || _successResponse2 === void 0 ? void 0 : (_successResponse2$ord = _successResponse2.order) === null || _successResponse2$ord === void 0 ? void 0 : _successResponse2$ord.commerceItems;
                  this.analyticsModel.setCartData((_successResponse3 = successResponse[successResponse.length - 1]) === null || _successResponse3 === void 0 ? void 0 : _successResponse3.order);
                  this.cartModel.setCurrentItemAddedToCart((_successResponse$slic = successResponse.slice(-1)[0]) === null || _successResponse$slic === void 0 ? void 0 : (_successResponse$slic2 = _successResponse$slic.order) === null || _successResponse$slic2 === void 0 ? void 0 : _successResponse$slic2.commerceItems.slice(-successResponse.length));
                  this.cartModel.setItemAddedToCartMessageVisibility(true);
                  setTimeout(function () {
                    _this13.cartModel.setItemAddedToCartMessageVisibility(false);
                  }, 10000);
                }

                if (errorResponse.length > 0) {
                  itemsName = "";
                  errorResponse.forEach(function (error) {
                    var _faults$faults, _error$config; // eslint-disable-next-line
                    // @ts-ignore


                    var faults = DPServices.Cart.parseErrors(error);
                    var firstFault = (faults === null || faults === void 0 ? void 0 : (_faults$faults = faults.faults) === null || _faults$faults === void 0 ? void 0 : _faults$faults.length) > 0 ? faults === null || faults === void 0 ? void 0 : faults.faults[0] : {};
                    var faultCode = firstFault === null || firstFault === void 0 ? void 0 : firstFault.faultCode;

                    if (faultCode === "sessionExpired") {
                      _this13.handleOrderError(error);

                      return;
                    }

                    var productID = JSON.parse(error === null || error === void 0 ? void 0 : (_error$config = error.config) === null || _error$config === void 0 ? void 0 : _error$config.data).productID;
                    itemsName += "* ".concat(_this13.orderHistoryModel.getItemName(orderId, productID), "\n");
                  });
                  this.appMessages.showError("Something went wrong", "Some of the items could not be added to the cart.\n\n".concat(itemsName));
                }

              case 24:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this, [[4, 16]]);
      }));

      function _doReorderAddAllToCart(_x51, _x52) {
        return _doReorderAddAllToCart2.apply(this, arguments);
      }

      return _doReorderAddAllToCart;
    }()
  }, {
    key: "reOrderAddToCart",
    value: function () {
      var _reOrderAddToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(orderId, itemId) {
        var _this$orderSettingsMo42, _this$menuListModel28;

        var item, isLocationConfirmed, productId, productName, productSku, productPrice, catalogRefIds, selectedIds, quantity, fromPage, itemInstructions, guestName, orderType, itemCount, isDefaultMenuSupported;
        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                this.orderHistoryModel.setCurrentOrderDetails({
                  orderId: orderId,
                  itemId: itemId
                });
                item = this.orderHistoryModel.getRequiredAddToCartData(orderId, itemId);
                isLocationConfirmed = (_this$orderSettingsMo42 = this.orderSettingsModel) === null || _this$orderSettingsMo42 === void 0 ? void 0 : _this$orderSettingsMo42.locationTimeConfirmed;
                productId = item.productId, productName = item.productName, productSku = item.productSku, productPrice = item.productPrice, catalogRefIds = item.catalogRefIds, selectedIds = item.selectedIds, quantity = item.quantity, fromPage = item.fromPage, itemInstructions = item.itemInstructions, guestName = item.guestName;
                orderType = this.menuListModel.orderType;
                itemCount = this.rootStore.user.sessionDetails.successResponse.sessionContext.itemCount;
                isDefaultMenuSupported = (_this$menuListModel28 = this.menuListModel) === null || _this$menuListModel28 === void 0 ? void 0 : _this$menuListModel28.isDefaultMenuSupported;

                if (!(isDefaultMenuSupported && !this.restaurantId)) {
                  _context67.next = 10;
                  break;
                }

                this.openLocationSearchModal();
                return _context67.abrupt("return");

              case 10:
                if (isLocationConfirmed) {
                  _context67.next = 17;
                  break;
                }

                this._isReorderAddToCart = true;
                _context67.next = 14;
                return this.fetchTimes();

              case 14:
                this.orderSettingsModel.showOrderSettingsConfirmationModal = true;
                _context67.next = 18;
                break;

              case 17:
                if (orderType === ORDER_TYPES.GIFT_CARD && itemCount > 0) {
                  this.cartModel.setGiftCardPresentMessageVisibility(true);
                } else {
                  this._doAddToCart(productId, catalogRefIds, selectedIds, quantity, itemInstructions, guestName, true, fromPage, false, true, false, false, undefined, "reorder" // TODO: confirm the itemCourse for Reorder
                  );
                }

              case 18:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this);
      }));

      function reOrderAddToCart(_x53, _x54) {
        return _reOrderAddToCart.apply(this, arguments);
      }

      return reOrderAddToCart;
    }()
  }, {
    key: "addToCart",
    value: function () {
      var _addToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(itemID) {
        var _this$menuListModel29;

        var type,
            isSimpleProduct,
            isFrom,
            isRecommended,
            model,
            menuItemSku,
            quantity,
            label,
            specialInstructions,
            selectedProductId,
            selectedSkuId,
            selectedIds,
            menuItem,
            category,
            isValid,
            itemCourse,
            isFromRecommended,
            _this$menuListModel30,
            _this$menuListModel31,
            _this$cartModel11,
            orderType,
            itemCount,
            _this$menuListModel34,
            _this$orderSettingsMo43,
            isLocationConfirmed,
            _this$timeModel16,
            _this$menuListModel32,
            _this$menuListModel33,
            fromPage,
            showAddedToCartMessage,
            doCheckout,
            _this$menuListModel35,
            _args68 = arguments;

        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                type = _args68.length > 1 && _args68[1] !== undefined ? _args68[1] : "menu-details";
                isSimpleProduct = _args68.length > 2 ? _args68[2] : undefined;
                isFrom = _args68.length > 3 && _args68[3] !== undefined ? _args68[3] : "menu-list";
                isRecommended = _args68.length > 4 ? _args68[4] : undefined;
                model = this.getModelFromType(type);
                menuItemSku = model.menuItemSku, quantity = model.quantity, label = model.label, specialInstructions = model.specialInstructions, selectedProductId = model.selectedProductId, selectedSkuId = model.selectedSkuId, selectedIds = model.selectedIds, menuItem = model.menuItem, category = model.category, isValid = model.isValid, itemCourse = model.itemCourse;

                if (menuItem.isAdvanceOrderingProduct) {
                  this._unAvailableMessage = menuItem.unAvailableMessage;
                  this._productAvailableStartDate = menuItem.productAvailableStartDate;
                }

                isFromRecommended = model === null || model === void 0 ? void 0 : model.isFromRecommended; // if clicked on addtocart button of menu listing item

                (_this$menuListModel29 = this.menuListModel) === null || _this$menuListModel29 === void 0 ? void 0 : _this$menuListModel29.setQuickAddItemData({
                  productId: itemID,
                  type: type,
                  isSimpleProduct: !!isSimpleProduct,
                  isFrom: isFrom,
                  isRecommended: isRecommended
                }); // QUICK_ADD_MODAL_LOGIC

                if (!(!isSimpleProduct && type === "quick-add" && itemID)) {
                  _context68.next = 15;
                  break;
                }

                (_this$menuListModel30 = this.menuListModel) === null || _this$menuListModel30 === void 0 ? void 0 : _this$menuListModel30.toggleShowQuickAddMenuCustomizationModal(true);
                (_this$menuListModel31 = this.menuListModel) === null || _this$menuListModel31 === void 0 ? void 0 : _this$menuListModel31.setCurrentAddToCartLoadingItemID(null);
                this.cartModel.setIsAddToCartLoading(false);
                this.analyticsModel.dispatchProductDetailsModalEvent(type, menuItem.id, menuItemSku.code, menuItem.name, false);
                return _context68.abrupt("return");

              case 15:
                if (isValid) {
                  _context68.next = 18;
                  break;
                }

                this.appMessages.showError("Error", "You forgot to add customizations");
                return _context68.abrupt("return");

              case 18:
                // clicked on addtocart button from menu details page of item
                if (!itemID) {
                  (_this$cartModel11 = this.cartModel) === null || _this$cartModel11 === void 0 ? void 0 : _this$cartModel11.setIsAddToCartLoading(true);
                }

                orderType = this.menuListModel.orderType;
                itemCount = this.rootStore.user.sessionDetails.successResponse.sessionContext.itemCount;

                if (!menuItemSku) {
                  _context68.next = 45;
                  break;
                }

                if (!isValid) {
                  _context68.next = 41;
                  break;
                }

                isLocationConfirmed = (_this$orderSettingsMo43 = this.orderSettingsModel) === null || _this$orderSettingsMo43 === void 0 ? void 0 : _this$orderSettingsMo43.locationTimeConfirmed;

                if (isLocationConfirmed) {
                  _context68.next = 32;
                  break;
                }

                (_this$timeModel16 = this.timeModel) === null || _this$timeModel16 === void 0 ? void 0 : _this$timeModel16.resetTimeModel();
                _context68.next = 28;
                return this.fetchTimes();

              case 28:
                this.orderSettingsModel.showOrderSettingsConfirmationModal = true;
                (_this$menuListModel32 = this.menuListModel) === null || _this$menuListModel32 === void 0 ? void 0 : _this$menuListModel32.setCurrentAddToCartLoadingItemID(null);
                _context68.next = 41;
                break;

              case 32:
                if (!(orderType === ORDER_TYPES.GIFT_CARD && itemCount > 0)) {
                  _context68.next = 36;
                  break;
                }

                this.cartModel.setGiftCardPresentMessageVisibility(true);
                _context68.next = 41;
                break;

              case 36:
                fromPage = type === "menu-details" ? "menu-detail" : "menu";
                showAddedToCartMessage = isFrom !== "upsell-recommendation";
                doCheckout = isFrom === "upsell-recommendation";
                _context68.next = 41;
                return this._doAddToCart(selectedProductId, selectedSkuId, selectedIds, quantity, specialInstructions, label, showAddedToCartMessage, fromPage, doCheckout, false, false, isFromRecommended, itemCourse, ((_this$menuListModel33 = this.menuListModel) === null || _this$menuListModel33 === void 0 ? void 0 : _this$menuListModel33.route) === "recommendations" ? "guest-favourites" : isFrom);

              case 41:
                (_this$menuListModel34 = this.menuListModel) === null || _this$menuListModel34 === void 0 ? void 0 : _this$menuListModel34.setCurrentAddToCartLoadingItemID(false);
                this.cartModel.setIsAddToCartLoading(false);
                _context68.next = 48;
                break;

              case 45:
                (_this$menuListModel35 = this.menuListModel) === null || _this$menuListModel35 === void 0 ? void 0 : _this$menuListModel35.setCurrentAddToCartLoadingItemID(false);
                this.cartModel.setIsAddToCartLoading(false);
                this.appMessages.showError("Error", "Please Make a Selection.");

              case 48:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this);
      }));

      function addToCart(_x55) {
        return _addToCart.apply(this, arguments);
      }

      return addToCart;
    }()
  }, {
    key: "_doReAddToCart",
    value: function () {
      var _doReAddToCart2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(isReorder) {
        var _this$menuListModel36, _this$menuListModel37, _this$menuListModel38, _this$menuListModel39, _this$menuListModel40, _this$menuListModel41, _this$menuListModel42, _this$menuListModel43;

        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                if (!isReorder) {
                  _context69.next = 5;
                  break;
                }

                _context69.next = 3;
                return this.reOrderAddToCart(this.orderHistoryModel.currentOrderDetails.orderId, this.orderHistoryModel.currentOrderDetails.itemId);

              case 3:
                _context69.next = 7;
                break;

              case 5:
                _context69.next = 7;
                return this.addToCart((_this$menuListModel36 = this.menuListModel) === null || _this$menuListModel36 === void 0 ? void 0 : (_this$menuListModel37 = _this$menuListModel36.quickAddItem) === null || _this$menuListModel37 === void 0 ? void 0 : _this$menuListModel37.productId, (_this$menuListModel38 = this.menuListModel) === null || _this$menuListModel38 === void 0 ? void 0 : (_this$menuListModel39 = _this$menuListModel38.quickAddItem) === null || _this$menuListModel39 === void 0 ? void 0 : _this$menuListModel39.type, (_this$menuListModel40 = this.menuListModel) === null || _this$menuListModel40 === void 0 ? void 0 : (_this$menuListModel41 = _this$menuListModel40.quickAddItem) === null || _this$menuListModel41 === void 0 ? void 0 : _this$menuListModel41.isSimpleProduct, (_this$menuListModel42 = this.menuListModel) === null || _this$menuListModel42 === void 0 ? void 0 : (_this$menuListModel43 = _this$menuListModel42.quickAddItem) === null || _this$menuListModel43 === void 0 ? void 0 : _this$menuListModel43.isFrom);

              case 7:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this);
      }));

      function _doReAddToCart(_x56) {
        return _doReAddToCart2.apply(this, arguments);
      }

      return _doReAddToCart;
    }()
  }, {
    key: "handleOrderError",
    value: function () {
      var _handleOrderError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(e) {
        var isReorder,
            error,
            _args70 = arguments;
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                isReorder = _args70.length > 1 && _args70[1] !== undefined ? _args70[1] : false;
                _context70.next = 3;
                return this.parseOrderError(e, isReorder);

              case 3:
                error = _context70.sent;

                if (error) {
                  this.appMessages.showError(error.title, error.message, error.additionalMessages, error.options, error.showDateTimeSelection, error.showLeadTimeRadioSelection);
                }

              case 5:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, this);
      }));

      function handleOrderError(_x57) {
        return _handleOrderError.apply(this, arguments);
      }

      return handleOrderError;
    }()
  }, {
    key: "handleUnavailableItemsModalCTAClick",
    value: function () {
      var _handleUnavailableItemsModalCTAClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(removalCommerceIds) {
        return _regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                _context71.next = 2;
                return this.setOrderPickupTime(null, removalCommerceIds, false);

              case 2:
                if (!(this.orderSettingsModel.resturantSelectedForChangeId && this.orderSettingsModel.resturantSelectedForChangeId !== this.restaurantId)) {
                  _context71.next = 5;
                  break;
                }

                _context71.next = 5;
                return this.selectRestaurant(this.orderSettingsModel.resturantSelectedForChangeId, "", false, false);

              case 5:
                _context71.next = 7;
                return this._loadCart();

              case 7:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71, this);
      }));

      function handleUnavailableItemsModalCTAClick(_x58) {
        return _handleUnavailableItemsModalCTAClick.apply(this, arguments);
      }

      return handleUnavailableItemsModalCTAClick;
    }()
  }, {
    key: "handleUnavailableItemsModalCancelClick",
    value: function () {
      var _handleUnavailableItemsModalCancelClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72() {
        var _this$orderSettingsMo44, _this$orderSettingsMo45;

        var activeRestaurant, newPickupTimeDate;
        return _regeneratorRuntime.wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                activeRestaurant = (_this$orderSettingsMo44 = this.orderSettingsModel) === null || _this$orderSettingsMo44 === void 0 ? void 0 : _this$orderSettingsMo44.currentRestaurant;
                (_this$orderSettingsMo45 = this.orderSettingsModel) === null || _this$orderSettingsMo45 === void 0 ? void 0 : _this$orderSettingsMo45.setResturantSelectedForChangeId(null);
                this.timeModel.resetTimeModel();
                newPickupTimeDate = new Date(this.timeModel.currentAPIPickupTime) || moment().toDate();
                _context72.next = 6;
                return this.fetchTimes(null, newPickupTimeDate);

              case 6:
                if (!activeRestaurant) {
                  this.openLocationSearchModal();
                }

              case 7:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72, this);
      }));

      function handleUnavailableItemsModalCancelClick() {
        return _handleUnavailableItemsModalCancelClick.apply(this, arguments);
      }

      return handleUnavailableItemsModalCancelClick;
    }()
  }, {
    key: "parseOrderError",
    value: function () {
      var _parseOrderError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee84(e) {
        var _faults$faults2,
            _this14 = this;

        var isReorder,
            faults,
            firstFault,
            faultCode,
            faultDescription,
            itemNotAvailableDescription,
            unavailableItems,
            reconcileItems,
            errorDescriptionJson,
            _this$_restaurantDeta11,
            _this$_restaurantDeta12,
            _this$_restaurantDeta13,
            htmlText,
            removalCommerceIds,
            _this$timeModel17,
            _this$timeModel18,
            _this$timeModel19,
            _htmlText,
            _removalCommerceIds,
            currentAPIPickupTime,
            productAvailableStartDate,
            title,
            _args84 = arguments;

        return _regeneratorRuntime.wrap(function _callee84$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                isReorder = _args84.length > 1 && _args84[1] !== undefined ? _args84[1] : false;
                faults = DPServices.Cart.parseErrors(e);
                firstFault = (faults === null || faults === void 0 ? void 0 : (_faults$faults2 = faults.faults) === null || _faults$faults2 === void 0 ? void 0 : _faults$faults2.length) > 0 ? faults === null || faults === void 0 ? void 0 : faults.faults[0] : {};
                faultCode = firstFault === null || firstFault === void 0 ? void 0 : firstFault.faultCode;
                faultDescription = firstFault === null || firstFault === void 0 ? void 0 : firstFault.faultDescription;
                itemNotAvailableDescription = faults === null || faults === void 0 ? void 0 : faults.localizedMessage;
                unavailableItems = faults === null || faults === void 0 ? void 0 : faults.unAvailableItems;
                reconcileItems = faults === null || faults === void 0 ? void 0 : faults.reconcileItems;
                errorDescriptionJson = faults !== null && faults !== void 0 && faults.errorDescriptionJson ? JSON.parse(faults === null || faults === void 0 ? void 0 : faults.errorDescriptionJson) : null;

                if (faultCode) {
                  _context84.next = 11;
                  break;
                }

                return _context84.abrupt("return", null);

              case 11:
                this.analyticsModel.dispatchOrderErrorEvent(faultCode, faultDescription);
                _context84.t0 = faultCode;
                _context84.next = _context84.t0 === "sessionExpired" ? 15 : _context84.t0 === "cart_TimeConflicts" ? 16 : _context84.t0 === "itemNotAvailable" ? 17 : _context84.t0 === "itemMenuPeriodSwitch" ? 18 : _context84.t0 === "cart_qtyThreshold" ? 19 : _context84.t0 === "cart_AmtThreshold" ? 20 : _context84.t0 === "subtext-choose-items-cart-qualify-exceeds" ? 20 : _context84.t0 === "forgotToSelectProperty" ? 21 : _context84.t0 === "atg.droplet.DropletException" ? 22 : _context84.t0 === "asap_not_available" ? 31 : _context84.t0 === "asap_not_available_pickup" ? 36 : _context84.t0 === "OrderService-601" ? 42 : _context84.t0 === "asap_not_available_add_item" ? 46 : _context84.t0 === "advanceOrderingProduct" ? 51 : _context84.t0 === "restNtAllowingAlcoholSep" ? 57 : 58;
                break;

              case 15:
                return _context84.abrupt("return", {
                  title: "Your session has expired",
                  message: "Your session has expired due to inactivity. Kindly create a new order.",
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    okBtnText: "Ok",
                    okBtnOnClick: function okBtnOnClick() {
                      if (_this14.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
                        var _this14$rootStore, _this14$rootStore$pla;

                        (_this14$rootStore = _this14.rootStore) === null || _this14$rootStore === void 0 ? void 0 : (_this14$rootStore$pla = _this14$rootStore.platformUtil) === null || _this14$rootStore$pla === void 0 ? void 0 : _this14$rootStore$pla.navReload();
                      } else {
                        _this14.rootStore.reloadApp();
                      }
                    }
                  }
                });

              case 16:
                return _context84.abrupt("return", {
                  title: i18next.t("change_pickup_title", {
                    defaultValue: "Change in pickup time"
                  }),
                  message: errorDescriptionJson ? "".concat(errorDescriptionJson.message, " ").concat(errorDescriptionJson.currentPickupTime, " to \n ").concat(errorDescriptionJson.newPickupTime) : "",
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    cancelBtnText: "Cancel",
                    okBtnText: errorDescriptionJson !== null && errorDescriptionJson !== void 0 && errorDescriptionJson.newPickupTime ? "Continue" : "Ok",
                    isRichText: true,
                    normalHtml: errorDescriptionJson ? null : faultDescription,
                    okBtnOnClick: function () {
                      var _okBtnOnClick4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73() {
                        var _this14$cartModel, _this14$menuListModel;

                        var newPickupTime, newPickupTimeDate, _this14$rootStore2, _this14$rootStore2$pl, _allSpans$, newPickupTimeElement, allSpans;

                        return _regeneratorRuntime.wrap(function _callee73$(_context73) {
                          while (1) {
                            switch (_context73.prev = _context73.next) {
                              case 0:
                                // Close overlays
                                (_this14$cartModel = _this14.cartModel) === null || _this14$cartModel === void 0 ? void 0 : _this14$cartModel.toggleEditMenuCustomizationModal(false);
                                (_this14$menuListModel = _this14.menuListModel) === null || _this14$menuListModel === void 0 ? void 0 : _this14$menuListModel.toggleShowQuickAddMenuCustomizationModal(false); // get updated time

                                if (errorDescriptionJson !== null && errorDescriptionJson !== void 0 && errorDescriptionJson.newPickupTime) {
                                  newPickupTime = errorDescriptionJson.newPickupTime;
                                  newPickupTimeDate = newPickupTime ? moment(newPickupTime, "MMM DD HH:mm A").toDate() : moment().toDate();
                                } else {
                                  if (((_this14$rootStore2 = _this14.rootStore) === null || _this14$rootStore2 === void 0 ? void 0 : (_this14$rootStore2$pl = _this14$rootStore2.platformUtil) === null || _this14$rootStore2$pl === void 0 ? void 0 : _this14$rootStore2$pl.PLATFORM_TYPE) === "APP") {
                                    newPickupTime = faultDescription.split("caluclatedPickupTime")[1].split(">")[1].split("<")[0];
                                  } else {
                                    newPickupTimeElement = document.createElement("html");
                                    newPickupTimeElement.innerHTML = faultDescription;
                                    allSpans = newPickupTimeElement === null || newPickupTimeElement === void 0 ? void 0 : newPickupTimeElement.getElementsByTagName("span");
                                    newPickupTime = (_allSpans$ = allSpans[2]) === null || _allSpans$ === void 0 ? void 0 : _allSpans$.innerHTML;
                                  }

                                  newPickupTimeDate = newPickupTime ? moment(newPickupTime, "MM/DD/YY HH:mm A").toDate() : moment().toDate();
                                } // clear previous time selection


                                _this14.timeModel.resetTimeModel(); // invoke /setpickuptime API
                                // const newPickupTimeDate = newPickupTime
                                //   ? moment(newPickupTime, "MMM DD HH:mm A").toDate()
                                //   : moment().toDate();
                                // const newPickupTimeDate = newPickupTime
                                //   ? moment(newPickupTime, "MM/DD/YY HH:mm A").toDate()
                                //   : moment().toDate();


                                _context73.next = 6;
                                return _this14.setOrderPickupTime(newPickupTimeDate);

                              case 6:
                                _context73.next = 8;
                                return _this14._doReAddToCart(isReorder);

                              case 8:
                                _context73.next = 10;
                                return _this14.fetchTimes(null, newPickupTimeDate);

                              case 10:
                              case "end":
                                return _context73.stop();
                            }
                          }
                        }, _callee73);
                      }));

                      function okBtnOnClick() {
                        return _okBtnOnClick4.apply(this, arguments);
                      }

                      return okBtnOnClick;
                    }()
                  }
                });

              case 17:
                return _context84.abrupt("return", {
                  title: "Something went wrong",
                  message: itemNotAvailableDescription || faultDescription || "Item not available",
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    okBtnText: "OK",
                    okBtnOnClick: function () {
                      var _okBtnOnClick5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74() {
                        return _regeneratorRuntime.wrap(function _callee74$(_context74) {
                          while (1) {
                            switch (_context74.prev = _context74.next) {
                              case 0:
                                _context74.next = 2;
                                return _this14._loadAvailability();

                              case 2:
                              case "end":
                                return _context74.stop();
                            }
                          }
                        }, _callee74);
                      }));

                      function okBtnOnClick() {
                        return _okBtnOnClick5.apply(this, arguments);
                      }

                      return okBtnOnClick;
                    }()
                  }
                });

              case 18:
                return _context84.abrupt("return", {
                  title: "This item cannot be added to cart",
                  message: null,
                  additionalMessages: null,
                  options: {
                    isRichText: true,
                    i18ResourceString: "error.lunchOnlyItemText"
                  }
                });

              case 19:
                return _context84.abrupt("return", {
                  title: "Max Quantity Exceeded Error",
                  message: null,
                  additionalMessages: null,
                  options: {
                    isRichText: true,
                    i18ResourceString: "error.items_cart_quantity_exceeds_threshold",
                    params: {
                      "0": this.orderSettingsModel.formatPhoneNumber((_this$_restaurantDeta11 = this._restaurantDetail) === null || _this$_restaurantDeta11 === void 0 ? void 0 : _this$_restaurantDeta11.restPhoneNumber[0].Phone)
                    }
                  }
                });

              case 20:
                return _context84.abrupt("return", {
                  title: i18next.t("error.title.items_cart_amount_exceeds_threshold", {
                    defaultValue: "Max Amount Exceeded"
                  }),
                  message: null,
                  additionalMessages: null,
                  options: {
                    isRichText: true,
                    i18ResourceString: "error.items_cart_amount_exceeds_threshold",
                    params: {
                      "0": "$".concat(this.cartModel._maxThresholdOrderAmount),
                      "1": this.orderSettingsModel.formatPhoneNumber((_this$_restaurantDeta12 = this._restaurantDetail) === null || _this$_restaurantDeta12 === void 0 ? void 0 : (_this$_restaurantDeta13 = _this$_restaurantDeta12.restPhoneNumber[0]) === null || _this$_restaurantDeta13 === void 0 ? void 0 : _this$_restaurantDeta13.Phone)
                    }
                  }
                });

              case 21:
                return _context84.abrupt("return", {
                  title: "Missing Selection",
                  message: faultDescription
                });

              case 22:
                htmlText = "";
                removalCommerceIds = [];

                if (!(faultDescription === "Invalid_restaurantId")) {
                  _context84.next = 27;
                  break;
                }

                if (!this.restaurantId) {
                  this.openLocationSearchModal();
                }

                return _context84.abrupt("return", null);

              case 27:
                if (unavailableItems) {
                  _context84.next = 29;
                  break;
                }

                return _context84.abrupt("return", {
                  title: "Something went wrong",
                  message: faultDescription
                });

              case 29:
                if (unavailableItems && Array.isArray(unavailableItems) && unavailableItems.length > 0) {
                  unavailableItems.forEach(function (_i) {
                    var itemText = "<p><b>-".concat(_i.displayName, "</b></p>");
                    htmlText = htmlText + itemText;
                    removalCommerceIds.push(_i.id);
                  });
                }

                return _context84.abrupt("return", {
                  title: "Item(s) Not Available.",
                  message: null,
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    cancelBtnText: "Cancel",
                    okBtnText: "Continue",
                    cancelBtnOnClick: function () {
                      var _cancelBtnOnClick2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75() {
                        return _regeneratorRuntime.wrap(function _callee75$(_context75) {
                          while (1) {
                            switch (_context75.prev = _context75.next) {
                              case 0:
                                _context75.next = 2;
                                return _this14.handleUnavailableItemsModalCancelClick();

                              case 2:
                              case "end":
                                return _context75.stop();
                            }
                          }
                        }, _callee75);
                      }));

                      function cancelBtnOnClick() {
                        return _cancelBtnOnClick2.apply(this, arguments);
                      }

                      return cancelBtnOnClick;
                    }(),
                    isRichText: true,
                    i18ResourceString: "error.items_not_available_info",
                    normalHtml: htmlText,
                    okBtnOnClick: function () {
                      var _okBtnOnClick6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76() {
                        return _regeneratorRuntime.wrap(function _callee76$(_context76) {
                          while (1) {
                            switch (_context76.prev = _context76.next) {
                              case 0:
                                _context76.next = 2;
                                return _this14.handleUnavailableItemsModalCTAClick(removalCommerceIds);

                              case 2:
                              case "end":
                                return _context76.stop();
                            }
                          }
                        }, _callee76);
                      }));

                      function okBtnOnClick() {
                        return _okBtnOnClick6.apply(this, arguments);
                      }

                      return okBtnOnClick;
                    }()
                  }
                });

              case 31:
                this.timeModel.selectedCalendarDate = moment().add("day", 1).toDate();
                this.timeModel.selectedTimeSlotFromDD = null;
                _context84.next = 35;
                return this.fetchTimes();

              case 35:
                return _context84.abrupt("return", {
                  title: "Item(s) Not Available.",
                  message: null,
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    cancelBtnText: "Cancel",
                    okBtnText: "Continue",
                    isRichText: true,
                    normalHtml: "<p>Our Apologies, You will need to select a new date and time</p>",
                    okBtnOnClick: function () {
                      var _okBtnOnClick7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77() {
                        return _regeneratorRuntime.wrap(function _callee77$(_context77) {
                          while (1) {
                            switch (_context77.prev = _context77.next) {
                              case 0:
                                _context77.next = 2;
                                return _this14.setOrderPickupTime();

                              case 2:
                                _this14.tryCheckout();

                              case 3:
                              case "end":
                                return _context77.stop();
                            }
                          }
                        }, _callee77);
                      }));

                      function okBtnOnClick() {
                        return _okBtnOnClick7.apply(this, arguments);
                      }

                      return okBtnOnClick;
                    }()
                  },
                  showDateTimeSelection: true
                });

              case 36:
                (_this$timeModel17 = this.timeModel) === null || _this$timeModel17 === void 0 ? void 0 : _this$timeModel17.resetTimeModel();
                this.timeModel.selectedCalendarDate = moment().add("day", 1).toDate();
                _context84.next = 40;
                return this.fetchTimes();

              case 40:
                if ((_this$timeModel18 = this.timeModel) !== null && _this$timeModel18 !== void 0 && _this$timeModel18.firstAvailableSlot) {
                  this.timeModel.selectedTimeSlotFromDD = (_this$timeModel19 = this.timeModel) === null || _this$timeModel19 === void 0 ? void 0 : _this$timeModel19.firstAvailableSlot;
                }

                return _context84.abrupt("return", {
                  title: "",
                  message: null,
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    cancelBtnText: "Cancel",
                    okBtnText: "Continue",
                    cancelBtnOnClick: function () {
                      var _cancelBtnOnClick3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78() {
                        var _this14$orderSettings, _this14$timeModel;

                        return _regeneratorRuntime.wrap(function _callee78$(_context78) {
                          while (1) {
                            switch (_context78.prev = _context78.next) {
                              case 0:
                                (_this14$orderSettings = _this14.orderSettingsModel) === null || _this14$orderSettings === void 0 ? void 0 : _this14$orderSettings.setResturantSelectedForChangeId(null);
                                (_this14$timeModel = _this14.timeModel) === null || _this14$timeModel === void 0 ? void 0 : _this14$timeModel.resetTimeModel();
                                _context78.next = 4;
                                return _this14.fetchTimes();

                              case 4:
                              case "end":
                                return _context78.stop();
                            }
                          }
                        }, _callee78);
                      }));

                      function cancelBtnOnClick() {
                        return _cancelBtnOnClick3.apply(this, arguments);
                      }

                      return cancelBtnOnClick;
                    }(),
                    isRichText: true,
                    normalHtml: "<p>Our Apologies, You will need to select a new date and time</p>",
                    okBtnOnClick: function () {
                      var _okBtnOnClick8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79() {
                        return _regeneratorRuntime.wrap(function _callee79$(_context79) {
                          while (1) {
                            switch (_context79.prev = _context79.next) {
                              case 0:
                                _this14.timeModel.isAsapOptionSelected = false;
                                _context79.next = 3;
                                return _this14.setOrderPickupTime();

                              case 3:
                                if (!(_this14.orderSettingsModel.resturantSelectedForChangeId && _this14.orderSettingsModel.resturantSelectedForChangeId !== _this14.restaurantId)) {
                                  _context79.next = 6;
                                  break;
                                }

                                _context79.next = 6;
                                return _this14.selectRestaurant(_this14.orderSettingsModel.resturantSelectedForChangeId, "", false, true);

                              case 6:
                              case "end":
                                return _context79.stop();
                            }
                          }
                        }, _callee79);
                      }));

                      function okBtnOnClick() {
                        return _okBtnOnClick8.apply(this, arguments);
                      }

                      return okBtnOnClick;
                    }()
                  },
                  showDateTimeSelection: true
                });

              case 42:
                _htmlText = "<p>".concat(faultDescription, "</p>");
                _removalCommerceIds = [];

                if (reconcileItems && Array.isArray(reconcileItems) && reconcileItems.length > 0) {
                  // htmlText =
                  //   htmlText +
                  //   `<p>If you continue, following items will be removed from the cart</p>`;
                  reconcileItems.forEach(function (_i) {
                    var itemText = "<p><b>-".concat(_i.displayName, "</b></p>");
                    _htmlText = _htmlText + itemText;

                    _removalCommerceIds.push(_i.id);
                  });
                }

                return _context84.abrupt("return", {
                  title: "Item(s) Not Available.",
                  message: null,
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    cancelBtnText: "Cancel",
                    okBtnText: "Continue",
                    isRichText: true,
                    normalHtml: _htmlText,
                    okBtnOnClick: function () {
                      var _okBtnOnClick9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee80() {
                        var _this14$cartModel2;

                        return _regeneratorRuntime.wrap(function _callee80$(_context80) {
                          while (1) {
                            switch (_context80.prev = _context80.next) {
                              case 0:
                                _context80.next = 2;
                                return _this14.setOrderPickupTime(null, _removalCommerceIds, false);

                              case 2:
                                _context80.next = 4;
                                return _this14._loadCart();

                              case 4:
                                if ((_this14$cartModel2 = _this14.cartModel) !== null && _this14$cartModel2 !== void 0 && _this14$cartModel2.noOfCartItems) _this14.tryCheckout();

                              case 5:
                              case "end":
                                return _context80.stop();
                            }
                          }
                        }, _callee80);
                      }));

                      function okBtnOnClick() {
                        return _okBtnOnClick9.apply(this, arguments);
                      }

                      return okBtnOnClick;
                    }()
                  }
                });

              case 46:
                this.timeModel.selectedCalendarDate = moment().add("day", 1).toDate();
                this.timeModel.selectedTimeSlotFromDD = null;
                _context84.next = 50;
                return this.fetchTimes();

              case 50:
                return _context84.abrupt("return", {
                  title: "Item(s) Not Available.",
                  message: null,
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    cancelBtnText: "Cancel",
                    okBtnText: "Continue",
                    isRichText: true,
                    normalHtml: "<p>".concat(faultDescription, "</p>"),
                    okBtnOnClick: function () {
                      var _okBtnOnClick10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee81(radio) {
                        var _this14$cartModel3, _this14$menuListModel2;

                        return _regeneratorRuntime.wrap(function _callee81$(_context81) {
                          while (1) {
                            switch (_context81.prev = _context81.next) {
                              case 0:
                                if (!(radio !== "1")) {
                                  _context81.next = 10;
                                  break;
                                } // Close overlays


                                (_this14$cartModel3 = _this14.cartModel) === null || _this14$cartModel3 === void 0 ? void 0 : _this14$cartModel3.toggleEditMenuCustomizationModal(false);
                                (_this14$menuListModel2 = _this14.menuListModel) === null || _this14$menuListModel2 === void 0 ? void 0 : _this14$menuListModel2.toggleShowQuickAddMenuCustomizationModal(false); // invoke /setpickuptime API

                                _this14.timeModel.isAsapOptionSelected = false;
                                _context81.next = 6;
                                return _this14.setOrderPickupTime();

                              case 6:
                                _context81.next = 8;
                                return _this14._doReAddToCart(isReorder);

                              case 8:
                                _context81.next = 10;
                                return _this14.fetchTimes();

                              case 10:
                              case "end":
                                return _context81.stop();
                            }
                          }
                        }, _callee81);
                      }));

                      function okBtnOnClick(_x60) {
                        return _okBtnOnClick10.apply(this, arguments);
                      }

                      return okBtnOnClick;
                    }()
                  },
                  showDateTimeSelection: false,
                  showLeadTimeRadioSelection: true
                });

              case 51:
                currentAPIPickupTime = new Date(this.timeModel.currentAPIPickupTime) || moment().toDate();
                productAvailableStartDate = moment(this._productAvailableStartDate).toDate();
                this.timeModel.selectedCalendarDate = productAvailableStartDate;
                this.fetchTimes(null, productAvailableStartDate, FETCH_TIME_TYPE.USER_ACTION);
                title = i18next.t("label.advance_ordering_error_title", {
                  defaultValue: "Item(s) Not Available."
                });
                return _context84.abrupt("return", {
                  title: title,
                  message: null,
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    cancelBtnText: "Cancel",
                    okBtnText: "Continue",
                    isRichText: true,
                    normalHtml: "<p>".concat(this._unAvailableMessage || faultDescription, "</p>"),
                    okBtnOnClick: function () {
                      var _okBtnOnClick11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee82() {
                        return _regeneratorRuntime.wrap(function _callee82$(_context82) {
                          while (1) {
                            switch (_context82.prev = _context82.next) {
                              case 0:
                                _context82.next = 2;
                                return _this14.setOrderPickupTime();

                              case 2:
                                _context82.next = 4;
                                return _this14._doReAddToCart(isReorder);

                              case 4:
                              case "end":
                                return _context82.stop();
                            }
                          }
                        }, _callee82);
                      }));

                      function okBtnOnClick() {
                        return _okBtnOnClick11.apply(this, arguments);
                      }

                      return okBtnOnClick;
                    }(),
                    cancelBtnOnClick: function () {
                      var _cancelBtnOnClick4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee83() {
                        return _regeneratorRuntime.wrap(function _callee83$(_context83) {
                          while (1) {
                            switch (_context83.prev = _context83.next) {
                              case 0:
                                _this14.timeModel.selectedCalendarDate = currentAPIPickupTime;

                                _this14.fetchTimes(null, currentAPIPickupTime, FETCH_TIME_TYPE.USER_ACTION);

                              case 2:
                              case "end":
                                return _context83.stop();
                            }
                          }
                        }, _callee83);
                      }));

                      function cancelBtnOnClick() {
                        return _cancelBtnOnClick4.apply(this, arguments);
                      }

                      return cancelBtnOnClick;
                    }()
                  },
                  showDateTimeSelection: true,
                  showLeadTimeRadioSelection: false
                });

              case 57:
                return _context84.abrupt("return", {
                  title: "",
                  message: faultDescription
                });

              case 58:
                return _context84.abrupt("return", {
                  title: "Something went wrong",
                  message: faultDescription
                });

              case 59:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee84, this);
      }));

      function parseOrderError(_x59) {
        return _parseOrderError.apply(this, arguments);
      }

      return parseOrderError;
    }()
  }, {
    key: "_setOrderTypeValue",
    value: function _setOrderTypeValue(order) {
      this.menuListModel.setOrderTypeValue(order.orderType);
      this.menuDetailModel.setOrderTypeValue(order);
      this.orderSettingsModel.setOrderTypeValue(order);
      this.cartModel.setOrderTypeValue(order);
    }
  }, {
    key: "getTimeSlotsBasedOnLeadTime",
    value: function () {
      var _getTimeSlotsBasedOnLeadTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee85(leadTime) {
        var currentTime, abosoluteLeadTime;
        return _regeneratorRuntime.wrap(function _callee85$(_context85) {
          while (1) {
            switch (_context85.prev = _context85.next) {
              case 0:
                currentTime = this.timeModel.currentAPIPickupTime;
                abosoluteLeadTime = currentTime + leadTime * 60 * 1000; // Checking for current time and absolute lead time falling on the same day

                if (moment(currentTime).isSame(moment(abosoluteLeadTime), "day")) {
                  _context85.next = 10;
                  break;
                }

                _context85.next = 5;
                return this.fetchTimes(false, moment(abosoluteLeadTime).toDate());

              case 5:
                _context85.next = 7;
                return this.setOrderPickupTime(moment(abosoluteLeadTime).toDate());

              case 7:
                // open the modal if set times is made infroming the user
                this.appMessages.showError(i18next.t("pickuptime_update_title"), i18next.t("pickuptime_update_copy"));
                _context85.next = 14;
                break;

              case 10:
                if (!(leadTime > this.timeModel.asapCutoffTime)) {
                  _context85.next = 14;
                  break;
                }

                _context85.next = 13;
                return this.fetchTimes();

              case 13:
                this.appMessages.showError(i18next.t("pickuptime_update_title"), i18next.t("pickuptime_update_copy"));

              case 14:
              case "end":
                return _context85.stop();
            }
          }
        }, _callee85, this);
      }));

      function getTimeSlotsBasedOnLeadTime(_x61) {
        return _getTimeSlotsBasedOnLeadTime.apply(this, arguments);
      }

      return getTimeSlotsBasedOnLeadTime;
    }()
  }, {
    key: "_doAddToCart",
    value: function () {
      var _doAddToCart2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee86(selectedProductId, selectedSkuId, selectedIds, quantity, specialInstructions, label) {
        var _this15 = this;

        var showAddedToCartMessage,
            fromPage,
            doCheckout,
            isReorder,
            isDuplicate,
            isRecommended,
            itemCourse,
            itemAddLocation,
            _cart$order,
            _cart$order$commerceI,
            _cart$order2,
            _this$cartModel12,
            _currentItem$subItem,
            _currentItem$subItem$,
            _ref12,
            _currentItem$priceInf,
            _window,
            _window$location,
            _window$location$path,
            _window2,
            _window2$location,
            _window2$location$pat,
            _window3,
            _window3$location,
            _window3$location$pat,
            _this$menuListModel44,
            _this$cartModel13,
            _this$menuListModel45,
            _this$cartModel14,
            _this$cartModel15,
            cart,
            currentItem,
            cartId,
            serializedCartId,
            addOnsPrice,
            basePrice,
            totalBreadCount,
            _this$rootStore30,
            _this$rootStore30$pla,
            _this$menuListModel46,
            _this$cartModel16,
            _args86 = arguments;

        return _regeneratorRuntime.wrap(function _callee86$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                showAddedToCartMessage = _args86.length > 6 && _args86[6] !== undefined ? _args86[6] : true;
                fromPage = _args86.length > 7 && _args86[7] !== undefined ? _args86[7] : "menu-detail";
                doCheckout = _args86.length > 8 && _args86[8] !== undefined ? _args86[8] : false;
                isReorder = _args86.length > 9 && _args86[9] !== undefined ? _args86[9] : false;
                isDuplicate = _args86.length > 10 && _args86[10] !== undefined ? _args86[10] : false;
                isRecommended = _args86.length > 11 && _args86[11] !== undefined ? _args86[11] : false;
                itemCourse = _args86.length > 12 ? _args86[12] : undefined;
                itemAddLocation = _args86.length > 13 ? _args86[13] : undefined;
                _context86.prev = 8;
                _context86.next = 11;
                return DPServices.Cart.addItem(this.orderSettingsModel.currentRestaurantId, selectedProductId, [selectedSkuId], selectedIds, quantity, quantity, fromPage, false, //smart recommended TODO
                specialInstructions, label, itemCourse);

              case 11:
                cart = _context86.sent;
                currentItem = cart === null || cart === void 0 ? void 0 : (_cart$order = cart.order) === null || _cart$order === void 0 ? void 0 : (_cart$order$commerceI = _cart$order.commerceItems) === null || _cart$order$commerceI === void 0 ? void 0 : _cart$order$commerceI[(cart === null || cart === void 0 ? void 0 : cart.order.commerceItems.length) - 1];
                this.cartModel.setCartData(cart === null || cart === void 0 ? void 0 : cart.order);
                this.breadSticksModel.cartItems = cart === null || cart === void 0 ? void 0 : (_cart$order2 = cart.order) === null || _cart$order2 === void 0 ? void 0 : _cart$order2.commerceItems;
                this.analyticsModel.setCartData(cart === null || cart === void 0 ? void 0 : cart.order);
                this.cartModel.setCurrentItemAddedToCart([currentItem]);
                cartId = (_this$cartModel12 = this.cartModel) === null || _this$cartModel12 === void 0 ? void 0 : _this$cartModel12.orderId;
                serializedCartId = {
                  "&&events": "event158:".concat(cartId)
                };
                addOnsPrice = currentItem === null || currentItem === void 0 ? void 0 : (_currentItem$subItem = currentItem.subItem) === null || _currentItem$subItem === void 0 ? void 0 : (_currentItem$subItem$ = _currentItem$subItem.map(function (item) {
                  return item.unitPrice;
                })) === null || _currentItem$subItem$ === void 0 ? void 0 : _currentItem$subItem$.reduce(function (prev, curr) {
                  return prev + curr;
                }, 0);
                basePrice = parseFloat((_ref12 = (currentItem === null || currentItem === void 0 ? void 0 : (_currentItem$priceInf = currentItem.priceInfo) === null || _currentItem$priceInf === void 0 ? void 0 : _currentItem$priceInf.listPrice) - addOnsPrice) === null || _ref12 === void 0 ? void 0 : _ref12.toFixed(2));
                totalBreadCount = this.breadSticksModel.totalBreadCount;
                this.analyticsModel.dispatchAddToCartEvent(fromPage, "Menu", (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : (_window$location$path = _window$location.pathname) === null || _window$location$path === void 0 ? void 0 : _window$location$path.split("/")[1], (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : (_window2$location$pat = _window2$location.pathname) === null || _window2$location$pat === void 0 ? void 0 : _window2$location$pat.split("/")[2], (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$location = _window3.location) === null || _window3$location === void 0 ? void 0 : (_window3$location$pat = _window3$location.pathname) === null || _window3$location$pat === void 0 ? void 0 : _window3$location$pat.split("/")[3], null, basePrice, currentItem.priceInfo.listPrice, "USD", currentItem.subItem, selectedProductId, currentItem.displayName, currentItem.productRef.description, currentItem.catalogRefId, isRecommended, false, isDuplicate, currentItem === null || currentItem === void 0 ? void 0 : currentItem.breadCount, totalBreadCount, serializedCartId, itemAddLocation);

                if (isRecommended) {
                  this.analyticsModel.dispatchFromSmartRecommendationEvent();
                }

                this.cartModel.setIsAddToCartLoading(false);
                (_this$menuListModel44 = this.menuListModel) === null || _this$menuListModel44 === void 0 ? void 0 : _this$menuListModel44.setCurrentAddToCartLoadingItemID(false);
                (_this$cartModel13 = this.cartModel) === null || _this$cartModel13 === void 0 ? void 0 : _this$cartModel13.toggleEditMenuCustomizationModal(false);
                (_this$menuListModel45 = this.menuListModel) === null || _this$menuListModel45 === void 0 ? void 0 : _this$menuListModel45.toggleShowQuickAddMenuCustomizationModal(false);
                (_this$cartModel14 = this.cartModel) === null || _this$cartModel14 === void 0 ? void 0 : _this$cartModel14.toggleSmartRecommendationMenuListModal(false);
                (_this$cartModel15 = this.cartModel) === null || _this$cartModel15 === void 0 ? void 0 : _this$cartModel15.toggleCartContainerLoader(false); // Added this to check if lead time is taking to next day
                // Go to the function only if ASAP selected is true

                if (!(cart !== null && cart !== void 0 && cart.isAsapSelected)) {
                  _context86.next = 33;
                  break;
                }

                _context86.next = 33;
                return this.getTimeSlotsBasedOnLeadTime(Number(cart === null || cart === void 0 ? void 0 : cart.leadTime));

              case 33:
                this.timeModel.setCartLeadTime(cart === null || cart === void 0 ? void 0 : cart.leadTime, cart === null || cart === void 0 ? void 0 : cart.isAsapSelected);

                this._setOrderTypeValue(cart === null || cart === void 0 ? void 0 : cart.order); // if (cart?.leadTime && Number(cart?.leadTime) > 60) {
                //   await this.fetchTimes();
                // }


                this.menuDetailModel.specialInstructions = "";
                this.menuDetailModel.setIsItemCourseSwitched(false);
                this.menuDetailModel.label = "";

                if (doCheckout) {
                  this.tryCheckout();
                }

                if (showAddedToCartMessage) {
                  this.cartModel.setItemAddedToCartMessageVisibility(true);
                  setTimeout(function () {
                    _this15.cartModel.setItemAddedToCartMessageVisibility(false);
                  }, 10000);
                }

                if (fromPage === "menu-detail") {
                  (_this$rootStore30 = this.rootStore) === null || _this$rootStore30 === void 0 ? void 0 : (_this$rootStore30$pla = _this$rootStore30.platformUtil) === null || _this$rootStore30$pla === void 0 ? void 0 : _this$rootStore30$pla.navigateToRoute("/menu");
                }

                this.updateQuantity(1, fromPage);
                _context86.next = 51;
                break;

              case 44:
                _context86.prev = 44;
                _context86.t0 = _context86["catch"](8);
                console.log(_context86.t0);
                this.cartModel.setIsAddToCartLoading(false);
                (_this$menuListModel46 = this.menuListModel) === null || _this$menuListModel46 === void 0 ? void 0 : _this$menuListModel46.setCurrentAddToCartLoadingItemID(false);
                (_this$cartModel16 = this.cartModel) === null || _this$cartModel16 === void 0 ? void 0 : _this$cartModel16.toggleCartContainerLoader(false);
                this.handleOrderError(_context86.t0, isReorder);

              case 51:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee86, this, [[8, 44]]);
      }));

      function _doAddToCart(_x62, _x63, _x64, _x65, _x66, _x67) {
        return _doAddToCart2.apply(this, arguments);
      }

      return _doAddToCart;
    }()
  }, {
    key: "updateCart",
    value: function () {
      var _updateCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee87() {
        var _this$menuEditModel2, quantity, specialInstructions, selectedProductId, selectedSkuId, selectedIds, editMenuId, label, isValid, itemCourse;

        return _regeneratorRuntime.wrap(function _callee87$(_context87) {
          while (1) {
            switch (_context87.prev = _context87.next) {
              case 0:
                _this$menuEditModel2 = this.menuEditModel, quantity = _this$menuEditModel2.quantity, specialInstructions = _this$menuEditModel2.specialInstructions, selectedProductId = _this$menuEditModel2.selectedProductId, selectedSkuId = _this$menuEditModel2.selectedSkuId, selectedIds = _this$menuEditModel2.selectedIds, editMenuId = _this$menuEditModel2.editMenuId, label = _this$menuEditModel2.label, isValid = _this$menuEditModel2.isValid, itemCourse = _this$menuEditModel2.itemCourse;
                _context87.next = 3;
                return this._doUpdateCart(quantity, specialInstructions, selectedProductId, selectedSkuId, selectedIds, editMenuId, label, isValid, itemCourse);

              case 3:
              case "end":
                return _context87.stop();
            }
          }
        }, _callee87, this);
      }));

      function updateCart() {
        return _updateCart.apply(this, arguments);
      }

      return updateCart;
    }()
  }, {
    key: "toggleItemCourse",
    value: function () {
      var _toggleItemCourse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee88(cartItem) {
        var _this$cartModel17, _this$cartModel18;

        var quantity, specialInstructions, productId, skuId, id, label, itemCourse, selectedIds;
        return _regeneratorRuntime.wrap(function _callee88$(_context88) {
          while (1) {
            switch (_context88.prev = _context88.next) {
              case 0:
                (_this$cartModel17 = this.cartModel) === null || _this$cartModel17 === void 0 ? void 0 : _this$cartModel17.toggleCartContainerLoader(true);
                quantity = cartItem.quantity, specialInstructions = cartItem.specialInstructions, productId = cartItem.productId, skuId = cartItem.skuId, id = cartItem.id, label = cartItem.label;
                itemCourse = cartItem.itemCourse === cartItem.defaultCourse ? cartItem.alternateCourse : cartItem.defaultCourse;
                selectedIds = cartItem.selectedProperties.map(function (property) {
                  return property.selectedId;
                });
                _context88.next = 6;
                return this._doUpdateCart(quantity, specialInstructions, productId, skuId, selectedIds, id, label, true, itemCourse);

              case 6:
                (_this$cartModel18 = this.cartModel) === null || _this$cartModel18 === void 0 ? void 0 : _this$cartModel18.toggleCartContainerLoader(false);

              case 7:
              case "end":
                return _context88.stop();
            }
          }
        }, _callee88, this);
      }));

      function toggleItemCourse(_x68) {
        return _toggleItemCourse.apply(this, arguments);
      }

      return toggleItemCourse;
    }()
  }, {
    key: "_doUpdateCart",
    value: function () {
      var _doUpdateCart2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee89(quantity, specialInstructions, selectedProductId, selectedSkuId, selectedIds, editMenuId, label, isValid, itemCourse) {
        var _cart$order3, _cart$order4, _cart$order5, _cart$order5$commerce, cart;

        return _regeneratorRuntime.wrap(function _callee89$(_context89) {
          while (1) {
            switch (_context89.prev = _context89.next) {
              case 0:
                _context89.prev = 0;

                if (isValid) {
                  _context89.next = 4;
                  break;
                }

                this.appMessages.showError("Error", "You forgot to add customizations");
                return _context89.abrupt("return");

              case 4:
                this.cartModel.setIsAddToCartLoading(true);
                _context89.next = 7;
                return DPServices.Cart.updateItem(selectedProductId, [selectedSkuId], quantity, specialInstructions, selectedIds, 1, editMenuId, label, itemCourse);

              case 7:
                cart = _context89.sent;
                _context89.next = 10;
                return this.fetchTimes();

              case 10:
                this.analyticsModel.dispatchUpdateCartEvent(selectedProductId, [selectedSkuId], quantity);
                this.cartModel.setCartData(cart === null || cart === void 0 ? void 0 : cart.order);
                this.breadSticksModel.cartItems = cart === null || cart === void 0 ? void 0 : (_cart$order3 = cart.order) === null || _cart$order3 === void 0 ? void 0 : _cart$order3.commerceItems;
                this.analyticsModel.setCartData(cart === null || cart === void 0 ? void 0 : cart.order);
                this.cartModel.setCurrentItemAddedToCart([cart === null || cart === void 0 ? void 0 : (_cart$order4 = cart.order) === null || _cart$order4 === void 0 ? void 0 : _cart$order4.commerceItems[(cart === null || cart === void 0 ? void 0 : (_cart$order5 = cart.order) === null || _cart$order5 === void 0 ? void 0 : (_cart$order5$commerce = _cart$order5.commerceItems) === null || _cart$order5$commerce === void 0 ? void 0 : _cart$order5$commerce.length) - 1]]);
                this.cartModel.setIsAddToCartLoading(false);
                this.cartModel.toggleEditMenuCustomizationModal(false);
                _context89.next = 23;
                break;

              case 19:
                _context89.prev = 19;
                _context89.t0 = _context89["catch"](0);
                this.cartModel.setIsAddToCartLoading(false);
                this.handleOrderError(_context89.t0);

              case 23:
              case "end":
                return _context89.stop();
            }
          }
        }, _callee89, this, [[0, 19]]);
      }));

      function _doUpdateCart(_x69, _x70, _x71, _x72, _x73, _x74, _x75, _x76, _x77) {
        return _doUpdateCart2.apply(this, arguments);
      }

      return _doUpdateCart;
    }()
  }, {
    key: "updateQuantity",
    value: function updateQuantity(quantity, type) {
      if (quantity < 1) {
        return;
      }

      if (type === "quick-add") {
        this.menuQuickAddModel.quantity = quantity;
      } else if (type === "edit-cart") {
        this.menuEditModel.quantity = quantity;
      } else {
        this.menuDetailModel.quantity = quantity;
      }
    }
  }, {
    key: "deleteCartItem",
    value: function () {
      var _deleteCartItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee90(cartItem) {
        var _this$cartModel19, _resp$order, _this$cartModel20, _this$_restaurantDeta14, resp, totalBreadCount, _this$cartModel22, _this$rootStore31, _this$rootStore31$pla, _this$cartModel21, _this$appMessages2;

        return _regeneratorRuntime.wrap(function _callee90$(_context90) {
          while (1) {
            switch (_context90.prev = _context90.next) {
              case 0:
                _context90.prev = 0;
                (_this$cartModel19 = this.cartModel) === null || _this$cartModel19 === void 0 ? void 0 : _this$cartModel19.toggleCartContainerLoader(true);
                _context90.next = 4;
                return DPServices.Cart.deleteItem(cartItem.id, cartItem.skuId, cartItem.productId);

              case 4:
                resp = _context90.sent;
                _context90.next = 7;
                return this.fetchTimes();

              case 7:
                this.cartModel.setCartData(resp.order);
                this.breadSticksModel.cartItems = resp === null || resp === void 0 ? void 0 : (_resp$order = resp.order) === null || _resp$order === void 0 ? void 0 : _resp$order.commerceItems;
                this.analyticsModel.setCartData(resp.order);
                (_this$cartModel20 = this.cartModel) === null || _this$cartModel20 === void 0 ? void 0 : _this$cartModel20.toggleCartContainerLoader(false);
                this.timeModel.setCartLeadTime(resp === null || resp === void 0 ? void 0 : resp.leadTime, resp === null || resp === void 0 ? void 0 : resp.isAsapSelected);
                totalBreadCount = this.breadSticksModel.totalBreadCount;
                this.analyticsModel.dispatchDeleteCartItemEvent(this.restaurantId, (_this$_restaurantDeta14 = this._restaurantDetail) === null || _this$_restaurantDeta14 === void 0 ? void 0 : _this$_restaurantDeta14.restaurantNum.toString(), cartItem.price, cartItem.productId, cartItem.skuId, cartItem.menuTitle, cartItem.breadCount, totalBreadCount);
                _context90.next = 26;
                break;

              case 16:
                _context90.prev = 16;
                _context90.t0 = _context90["catch"](0);

                if (!((_context90.t0 === null || _context90.t0 === void 0 ? void 0 : _context90.t0.errorCode) === "errorRemovingItemFromOrder")) {
                  _context90.next = 23;
                  break;
                }

                _context90.next = 21;
                return this._loadCart();

              case 21:
                (_this$cartModel21 = this.cartModel) === null || _this$cartModel21 === void 0 ? void 0 : _this$cartModel21.toggleCartContainerLoader(false);
                return _context90.abrupt("return");

              case 23:
                (_this$cartModel22 = this.cartModel) === null || _this$cartModel22 === void 0 ? void 0 : _this$cartModel22.toggleCartContainerLoader(false);
                this.handleOrderError(_context90.t0);

                if (((_this$rootStore31 = this.rootStore) === null || _this$rootStore31 === void 0 ? void 0 : (_this$rootStore31$pla = _this$rootStore31.platformUtil) === null || _this$rootStore31$pla === void 0 ? void 0 : _this$rootStore31$pla.PLATFORM_TYPE) === "APP") {
                  (_this$appMessages2 = this.appMessages) === null || _this$appMessages2 === void 0 ? void 0 : _this$appMessages2.showError("Sorry, something went wrong", "Unable to remove the Item from the Cart");
                }

              case 26:
              case "end":
                return _context90.stop();
            }
          }
        }, _callee90, this, [[0, 16]]);
      }));

      function deleteCartItem(_x78) {
        return _deleteCartItem.apply(this, arguments);
      }

      return deleteCartItem;
    }()
  }, {
    key: "editCartItem",
    value: function () {
      var _editCartItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee91(cartItem) {
        return _regeneratorRuntime.wrap(function _callee91$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                _context91.next = 2;
                return this.prepareForCartItemEdit(cartItem);

              case 2:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee91, this);
      }));

      function editCartItem(_x79) {
        return _editCartItem.apply(this, arguments);
      }

      return editCartItem;
    }()
  }, {
    key: "prepareForCartItemEdit",
    value: function () {
      var _prepareForCartItemEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee92(cartItem) {
        var _this$cartModel23, _this$timeModel20, _this$rootStore32, _this$rootStore32$com, _this$menuDetailModel11, _this$menuDetailModel12, _this$menuDetailModel13, _this$cartModel24, rawResponse, isItemCourseSwitched, _this$menuEditModel3, _this$cartModel25;

        return _regeneratorRuntime.wrap(function _callee92$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                _context92.prev = 0; // Model Setup

                (_this$cartModel23 = this.cartModel) === null || _this$cartModel23 === void 0 ? void 0 : _this$cartModel23.toggleCartContainerLoader(true);
                this.menuEditModel = new MenuDetailModel(this.rootStore.platformUtil, true);
                this.menuEditModel.setPickupTimeData((_this$timeModel20 = this.timeModel) === null || _this$timeModel20 === void 0 ? void 0 : _this$timeModel20.currentTimeSlot);
                this.menuEditModel.setAppAttributesData((_this$rootStore32 = this.rootStore) === null || _this$rootStore32 === void 0 ? void 0 : (_this$rootStore32$com = _this$rootStore32.common) === null || _this$rootStore32$com === void 0 ? void 0 : _this$rootStore32$com.appAttributes);
                this.menuEditModel.setSessionDetails((_this$menuDetailModel11 = this.menuDetailModel) === null || _this$menuDetailModel11 === void 0 ? void 0 : _this$menuDetailModel11.sessionDetails);
                this.menuEditModel.setUnavailableItemsData((_this$menuDetailModel12 = this.menuDetailModel) === null || _this$menuDetailModel12 === void 0 ? void 0 : _this$menuDetailModel12.unavailableItemsList);
                this.menuEditModel.setDayPartInfoData((_this$menuDetailModel13 = this.menuDetailModel) === null || _this$menuDetailModel13 === void 0 ? void 0 : _this$menuDetailModel13.dayPartInfo);
                this.menuEditModel.setReturantId(this.restaurantId); //-- END

                _context92.next = 11;
                return DPServices.Menu.getMenuItemDetail(this.restaurantId, cartItem.productId, this.isDipo ? 5 : undefined);

              case 11:
                rawResponse = _context92.sent;
                this.menuEditModel.setReturantId(this.restaurantId);
                this.menuEditModel.setMenuItemDetailData(new MenuItemDetail(rawResponse));
                this.menuEditModel.setEditMenuId(cartItem === null || cartItem === void 0 ? void 0 : cartItem.id);
                this.menuEditModel.label = cartItem.label;
                this.menuEditModel.specialInstructions = cartItem.specialInstructions;
                this.menuEditModel.quantity = cartItem.quantity;
                isItemCourseSwitched = cartItem.defaultCourse !== cartItem.itemCourse;
                this.menuEditModel.setIsItemCourseSwitched(isItemCourseSwitched);

                if (cartItem !== null && cartItem !== void 0 && cartItem.skuId) {
                  (_this$menuEditModel3 = this.menuEditModel) === null || _this$menuEditModel3 === void 0 ? void 0 : _this$menuEditModel3.selectSKU(cartItem === null || cartItem === void 0 ? void 0 : cartItem.skuId);
                }

                if (cartItem !== null && cartItem !== void 0 && cartItem.selectedProperties) {
                  this.selecPropertiesForEditRecursive(cartItem === null || cartItem === void 0 ? void 0 : cartItem.selectedProperties);
                }

                this.cartModel.toggleEditMenuCustomizationModal(true);
                (_this$cartModel24 = this.cartModel) === null || _this$cartModel24 === void 0 ? void 0 : _this$cartModel24.toggleCartContainerLoader(false);
                _context92.next = 31;
                break;

              case 26:
                _context92.prev = 26;
                _context92.t0 = _context92["catch"](0);
                console.log(_context92.t0);
                (_this$cartModel25 = this.cartModel) === null || _this$cartModel25 === void 0 ? void 0 : _this$cartModel25.toggleCartContainerLoader(false);
                this.appMessages.showError("Error Loading Menu", "We couldnot load menu detail at this time. Please try again");

              case 31:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee92, this, [[0, 26]]);
      }));

      function prepareForCartItemEdit(_x80) {
        return _prepareForCartItemEdit.apply(this, arguments);
      }

      return prepareForCartItemEdit;
    }()
  }, {
    key: "selecPropertiesForEditRecursive",
    value: function selecPropertiesForEditRecursive(items) {
      var _this16 = this;

      if (items && Array.isArray(items)) {
        items.forEach(function (_i) {
          if (_i.options && _i.options.length > 1) {
            _this16.selecPropertiesForEditRecursive(_i.options);
          } else {
            var id = _i.selectedId || _i.id;

            _this16.menuEditModel.selectOptionBySelectedId(id, true, true);
          }
        });
      }
    }
  }, {
    key: "timeLocationConfirmation",
    value: function () {
      var _timeLocationConfirmation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee93(menuId) {
        var _this$orderSettingsMo46, _this$menuListModel47;

        var type,
            isFrom,
            isLocationConfirmed,
            _this$timeModel21,
            _this$menuListModel48,
            _this$menuListModel49,
            _args93 = arguments;

        return _regeneratorRuntime.wrap(function _callee93$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                type = _args93.length > 1 && _args93[1] !== undefined ? _args93[1] : "quick-add";
                isFrom = _args93.length > 2 && _args93[2] !== undefined ? _args93[2] : "menu-list"; // FOR COMPLEX ITEM

                isLocationConfirmed = (_this$orderSettingsMo46 = this.orderSettingsModel) === null || _this$orderSettingsMo46 === void 0 ? void 0 : _this$orderSettingsMo46.locationTimeConfirmed;
                (_this$menuListModel47 = this.menuListModel) === null || _this$menuListModel47 === void 0 ? void 0 : _this$menuListModel47.setQuickAddItemData({
                  productId: menuId,
                  type: type,
                  isSimpleProduct: false,
                  isFrom: isFrom
                });

                if (isLocationConfirmed) {
                  _context93.next = 13;
                  break;
                }

                (_this$timeModel21 = this.timeModel) === null || _this$timeModel21 === void 0 ? void 0 : _this$timeModel21.resetTimeModel();
                _context93.next = 8;
                return this.fetchTimes();

              case 8:
                this.orderSettingsModel.showOrderSettingsConfirmationModal = true;
                (_this$menuListModel48 = this.menuListModel) === null || _this$menuListModel48 === void 0 ? void 0 : _this$menuListModel48.setCurrentAddToCartLoadingItemID(null);
                this.analyticsModel.dispatchDisplayModalEvent("Show pickup details", "Display the pickup details", "ConfirmPickupDetails", null);
                _context93.next = 14;
                break;

              case 13:
                (_this$menuListModel49 = this.menuListModel) === null || _this$menuListModel49 === void 0 ? void 0 : _this$menuListModel49.toggleShowQuickAddMenuCustomizationModal(true);

              case 14:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee93, this);
      }));

      function timeLocationConfirmation(_x81) {
        return _timeLocationConfirmation.apply(this, arguments);
      }

      return timeLocationConfirmation;
    }()
  }, {
    key: "addRecommendedItemToCart",
    value: function () {
      var _addRecommendedItemToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee94(id, simpleProduct, from) {
        var _this$menuListModel50;

        return _regeneratorRuntime.wrap(function _callee94$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
                if (!(this.menuListModel.isDefaultMenuSupported && !this.restaurantId)) {
                  _context94.next = 3;
                  break;
                }

                this.openLocationSearchModal();
                return _context94.abrupt("return");

              case 3:
                (_this$menuListModel50 = this.menuListModel) === null || _this$menuListModel50 === void 0 ? void 0 : _this$menuListModel50.setCurrentAddToCartLoadingItemID(id);
                _context94.next = 6;
                return this.prePareMenuItemForQuickAdd(id, simpleProduct, from, true);

              case 6:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee94, this);
      }));

      function addRecommendedItemToCart(_x82, _x83, _x84) {
        return _addRecommendedItemToCart.apply(this, arguments);
      }

      return addRecommendedItemToCart;
    }()
  }, {
    key: "prePareMenuItemForQuickAdd",
    value: function () {
      var _prePareMenuItemForQuickAdd = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee95(menuId, simpleProduct) {
        var isFrom,
            isRecommended,
            _this$rootStore33,
            _this$timeModel22,
            _this$rootStore34,
            _this$rootStore34$com,
            _this$menuDetailModel14,
            _this$menuDetailModel15,
            _this$menuDetailModel16,
            _this$cartModel26,
            _this$cartModel27,
            rawResponse,
            menuItem,
            cartId,
            serializedCartId,
            _this$menuListModel51,
            _args95 = arguments;

        return _regeneratorRuntime.wrap(function _callee95$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                isFrom = _args95.length > 2 && _args95[2] !== undefined ? _args95[2] : "menu-list";
                isRecommended = _args95.length > 3 ? _args95[3] : undefined;
                _context95.prev = 2; // Model Setup

                this.menuQuickAddModel = new MenuDetailModel((_this$rootStore33 = this.rootStore) === null || _this$rootStore33 === void 0 ? void 0 : _this$rootStore33.platformUtil, false);
                this.menuQuickAddModel.setIsFromRecommended(isRecommended);
                this.menuQuickAddModel.setPickupTimeData((_this$timeModel22 = this.timeModel) === null || _this$timeModel22 === void 0 ? void 0 : _this$timeModel22.currentTimeSlot);
                this.menuQuickAddModel.setAppAttributesData((_this$rootStore34 = this.rootStore) === null || _this$rootStore34 === void 0 ? void 0 : (_this$rootStore34$com = _this$rootStore34.common) === null || _this$rootStore34$com === void 0 ? void 0 : _this$rootStore34$com.appAttributes);
                this.menuQuickAddModel.setSessionDetails((_this$menuDetailModel14 = this.menuDetailModel) === null || _this$menuDetailModel14 === void 0 ? void 0 : _this$menuDetailModel14.sessionDetails);
                this.menuQuickAddModel.setUnavailableItemsData((_this$menuDetailModel15 = this.menuDetailModel) === null || _this$menuDetailModel15 === void 0 ? void 0 : _this$menuDetailModel15.unavailableItemsList);
                this.menuQuickAddModel.setDayPartInfoData((_this$menuDetailModel16 = this.menuDetailModel) === null || _this$menuDetailModel16 === void 0 ? void 0 : _this$menuDetailModel16.dayPartInfo);
                this.menuQuickAddModel.setReturantId(this.restaurantId); //Menu Detail Call

                _context95.next = 13;
                return DPServices.Menu.getMenuItemDetail(this.restaurantId, menuId, this.isDipo ? 5 : undefined);

              case 13:
                rawResponse = _context95.sent;
                menuItem = new MenuItemDetail(rawResponse);
                cartId = (_this$cartModel26 = this.cartModel) === null || _this$cartModel26 === void 0 ? void 0 : _this$cartModel26.orderId;
                serializedCartId = {
                  "&&events": "event158:".concat((_this$cartModel27 = this.cartModel) === null || _this$cartModel27 === void 0 ? void 0 : _this$cartModel27.orderId)
                };
                this.menuQuickAddModel.setMenuItemDetailData(menuItem);
                this.analyticsModel.dispatchQuickAddEvent("quick-add", "Menu Grid", "menu", this.menuDetailModel.category, null, null, menuItem.id, menuItem.name, menuItem.price[0].skuId, menuItem.price[0].price, "USD", isRecommended, false, serializedCartId);

                if (!simpleProduct) {
                  this.timeLocationConfirmation(menuId, "quick-add", isFrom);
                  this.analyticsModel.dispatchDisplayModalEvent("Show quick add", "Display the menu item options", "ProductDetailsModal", menuItem.id);
                } else this.addToCart(menuId, "quick-add", simpleProduct, isFrom, isRecommended);

                _context95.next = 27;
                break;

              case 22:
                _context95.prev = 22;
                _context95.t0 = _context95["catch"](2);
                console.log(_context95.t0);
                this === null || this === void 0 ? void 0 : (_this$menuListModel51 = this.menuListModel) === null || _this$menuListModel51 === void 0 ? void 0 : _this$menuListModel51.setCurrentAddToCartLoadingItemID(null);
                this.appMessages.showError("Error Loading Menu", "We could not load menu detail at this time. Please try again");

              case 27:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee95, this, [[2, 22]]);
      }));

      function prePareMenuItemForQuickAdd(_x85, _x86) {
        return _prePareMenuItemForQuickAdd.apply(this, arguments);
      }

      return prePareMenuItemForQuickAdd;
    }()
  }, {
    key: "duplicateCartItem",
    value: function () {
      var _duplicateCartItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee96(cartItem) {
        var _this$cartModel28, _this$rootStore35, _this$rootStore35$use, _this$rootStore35$use2, _this$rootStore35$use3, _this$rootStore35$use4;

        var selectedIds, isDineIn, itemCourse;
        return _regeneratorRuntime.wrap(function _callee96$(_context96) {
          while (1) {
            switch (_context96.prev = _context96.next) {
              case 0:
                (_this$cartModel28 = this.cartModel) === null || _this$cartModel28 === void 0 ? void 0 : _this$cartModel28.toggleCartContainerLoader(true);
                selectedIds = cartItem === null || cartItem === void 0 ? void 0 : cartItem.selectedProperties.map(function (prop) {
                  return prop.selectedId;
                });
                isDineIn = ((_this$rootStore35 = this.rootStore) === null || _this$rootStore35 === void 0 ? void 0 : (_this$rootStore35$use = _this$rootStore35.user) === null || _this$rootStore35$use === void 0 ? void 0 : (_this$rootStore35$use2 = _this$rootStore35$use.sessionDetails) === null || _this$rootStore35$use2 === void 0 ? void 0 : (_this$rootStore35$use3 = _this$rootStore35$use2.successResponse) === null || _this$rootStore35$use3 === void 0 ? void 0 : (_this$rootStore35$use4 = _this$rootStore35$use3.sessionContext) === null || _this$rootStore35$use4 === void 0 ? void 0 : _this$rootStore35$use4.orderTypeValue) === 5;
                itemCourse = isDineIn ? cartItem.itemCourse : undefined;
                _context96.next = 6;
                return this._doAddToCart(cartItem.productId, cartItem.skuId, selectedIds, cartItem.quantity, cartItem.specialInstructions, cartItem.label, false, "cart", false, false, true, false, itemCourse, "cart-item-duplicate");

              case 6:
              case "end":
                return _context96.stop();
            }
          }
        }, _callee96, this);
      }));

      function duplicateCartItem(_x87) {
        return _duplicateCartItem.apply(this, arguments);
      }

      return duplicateCartItem;
    }()
  }, {
    key: "saveToCart",
    value: function () {
      var _saveToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee97() {
        return _regeneratorRuntime.wrap(function _callee97$(_context97) {
          while (1) {
            switch (_context97.prev = _context97.next) {
              case 0:
              case "end":
                return _context97.stop();
            }
          }
        }, _callee97);
      }));

      function saveToCart() {
        return _saveToCart.apply(this, arguments);
      }

      return saveToCart;
    }()
  }, {
    key: "clearCart",
    value: function () {
      var _clearCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee98() {
        var _DPServices$Cart;

        var orderFlow,
            response,
            _this$cartModel29,
            _args98 = arguments;

        return _regeneratorRuntime.wrap(function _callee98$(_context98) {
          while (1) {
            switch (_context98.prev = _context98.next) {
              case 0:
                orderFlow = _args98.length > 0 && _args98[0] !== undefined ? _args98[0] : "togo-pickup-order";
                _context98.next = 3;
                return DPServices === null || DPServices === void 0 ? void 0 : (_DPServices$Cart = DPServices.Cart) === null || _DPServices$Cart === void 0 ? void 0 : _DPServices$Cart.clearCart(orderFlow);

              case 3:
                response = _context98.sent;

                if (response) {
                  (_this$cartModel29 = this.cartModel) === null || _this$cartModel29 === void 0 ? void 0 : _this$cartModel29.setCartData(null);
                  this.breadSticksModel.cartItems = null;
                }

              case 5:
              case "end":
                return _context98.stop();
            }
          }
        }, _callee98, this);
      }));

      function clearCart() {
        return _clearCart.apply(this, arguments);
      }

      return clearCart;
    }()
  }, {
    key: "tryCheckout",
    value: function () {
      var _tryCheckout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee99() {
        return _regeneratorRuntime.wrap(function _callee99$(_context99) {
          while (1) {
            switch (_context99.prev = _context99.next) {
              case 0:
                //validate or show cross sell
                // set checkout loading
                this.cartModel.setIsCheckoutLoading(true);
                _context99.next = 3;
                return this.doCheckout();

              case 3:
              case "end":
                return _context99.stop();
            }
          }
        }, _callee99, this);
      }));

      function tryCheckout() {
        return _tryCheckout.apply(this, arguments);
      }

      return tryCheckout;
    }()
  }, {
    key: "doCheckout",
    value: function () {
      var _doCheckout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee100() {
        var _this$rootStore36, _this$rootStore36$pla, _this$rootStore37, _this$rootStore37$use, _this$rootStore37$use2, _this$rootStore37$use3, _this$rootStore37$use4, isDineIn, _this$rootStore38, _this$rootStore38$pla, _this$rootStore39, _this$rootStore39$pla, _this$rootStore40, _this$rootStore40$use, _this$rootStore40$use2, _this$rootStore40$use3, _this$rootStore40$use4, _isDineIn, checkoutURL, _this$rootStore41, _this$rootStore41$pla, _this$rootStore42, _this$rootStore42$pla, _this$rootStore42$pla2, _this$rootStore43, _this$rootStore43$pla;

        return _regeneratorRuntime.wrap(function _callee100$(_context100) {
          while (1) {
            switch (_context100.prev = _context100.next) {
              case 0:
                _context100.prev = 0; //TODO: Show cross sell popup

                this.cartModel.setIsCheckoutLoading(true);
                _context100.next = 4;
                return DPServices.Cart.moveToPurchaseFlow();

              case 4:
                // Cross Sell Popup session reset
                // await this.saveSmartRecommendationCheckOutSession("false");
                //TODO: Use next router instead
                if (((_this$rootStore36 = this.rootStore) === null || _this$rootStore36 === void 0 ? void 0 : (_this$rootStore36$pla = _this$rootStore36.platformUtil) === null || _this$rootStore36$pla === void 0 ? void 0 : _this$rootStore36$pla.PLATFORM_TYPE) === "APP") {
                  isDineIn = ((_this$rootStore37 = this.rootStore) === null || _this$rootStore37 === void 0 ? void 0 : (_this$rootStore37$use = _this$rootStore37.user) === null || _this$rootStore37$use === void 0 ? void 0 : (_this$rootStore37$use2 = _this$rootStore37$use.sessionDetails) === null || _this$rootStore37$use2 === void 0 ? void 0 : (_this$rootStore37$use3 = _this$rootStore37$use2.successResponse) === null || _this$rootStore37$use3 === void 0 ? void 0 : (_this$rootStore37$use4 = _this$rootStore37$use3.sessionContext) === null || _this$rootStore37$use4 === void 0 ? void 0 : _this$rootStore37$use4.orderTypeValue) === 5;

                  if (isDineIn) {
                    (_this$rootStore38 = this.rootStore) === null || _this$rootStore38 === void 0 ? void 0 : (_this$rootStore38$pla = _this$rootStore38.platformUtil) === null || _this$rootStore38$pla === void 0 ? void 0 : _this$rootStore38$pla.navigateToRoute("/order-ahead/checkout");
                  } else {
                    (_this$rootStore39 = this.rootStore) === null || _this$rootStore39 === void 0 ? void 0 : (_this$rootStore39$pla = _this$rootStore39.platformUtil) === null || _this$rootStore39$pla === void 0 ? void 0 : _this$rootStore39$pla.navigateToRoute("/commerce/checkout");
                  }
                } else {
                  _isDineIn = ((_this$rootStore40 = this.rootStore) === null || _this$rootStore40 === void 0 ? void 0 : (_this$rootStore40$use = _this$rootStore40.user) === null || _this$rootStore40$use === void 0 ? void 0 : (_this$rootStore40$use2 = _this$rootStore40$use.sessionDetails) === null || _this$rootStore40$use2 === void 0 ? void 0 : (_this$rootStore40$use3 = _this$rootStore40$use2.successResponse) === null || _this$rootStore40$use3 === void 0 ? void 0 : (_this$rootStore40$use4 = _this$rootStore40$use3.sessionContext) === null || _this$rootStore40$use4 === void 0 ? void 0 : _this$rootStore40$use4.orderTypeValue) === 5;
                  checkoutURL = _isDineIn ? "/order-ahead/checkout" : "/commerce/checkout";
                  this.rootStore.platformUtil.redirectToURL(checkoutURL);
                }

                this.cartModel.setIsCheckoutLoading(false);
                _context100.next = 13;
                break;

              case 8:
                _context100.prev = 8;
                _context100.t0 = _context100["catch"](0);
                if (((_this$rootStore41 = this.rootStore) === null || _this$rootStore41 === void 0 ? void 0 : (_this$rootStore41$pla = _this$rootStore41.platformUtil) === null || _this$rootStore41$pla === void 0 ? void 0 : _this$rootStore41$pla.PLATFORM_TYPE) === "APP" && ((_this$rootStore42 = this.rootStore) === null || _this$rootStore42 === void 0 ? void 0 : (_this$rootStore42$pla = _this$rootStore42.platformUtil) === null || _this$rootStore42$pla === void 0 ? void 0 : (_this$rootStore42$pla2 = _this$rootStore42$pla.navHistory()) === null || _this$rootStore42$pla2 === void 0 ? void 0 : _this$rootStore42$pla2.name) === "CheckoutStack") (_this$rootStore43 = this.rootStore) === null || _this$rootStore43 === void 0 ? void 0 : (_this$rootStore43$pla = _this$rootStore43.platformUtil) === null || _this$rootStore43$pla === void 0 ? void 0 : _this$rootStore43$pla.goBack();
                this.handleOrderError(_context100.t0);
                this.cartModel.setIsCheckoutLoading(false);

              case 13:
              case "end":
                return _context100.stop();
            }
          }
        }, _callee100, this, [[0, 8]]);
      }));

      function doCheckout() {
        return _doCheckout.apply(this, arguments);
      }

      return doCheckout;
    }()
  }, {
    key: "getPDFMenuURL",
    value: function () {
      var _getPDFMenuURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee101() {
        var _DPServices$Restauran, _this$_restaurantDeta15;

        var pdfMenuConfig;
        return _regeneratorRuntime.wrap(function _callee101$(_context101) {
          while (1) {
            switch (_context101.prev = _context101.next) {
              case 0:
                _context101.next = 2;
                return DPServices === null || DPServices === void 0 ? void 0 : (_DPServices$Restauran = DPServices.Restaurant) === null || _DPServices$Restauran === void 0 ? void 0 : _DPServices$Restauran.getRestaurantPDFMenuURL((_this$_restaurantDeta15 = this._restaurantDetail) === null || _this$_restaurantDeta15 === void 0 ? void 0 : _this$_restaurantDeta15.restaurantNum);

              case 2:
                pdfMenuConfig = _context101.sent;
                this.menuListModel.setPdfMenuUrl(pdfMenuConfig);

              case 4:
              case "end":
                return _context101.stop();
            }
          }
        }, _callee101, this);
      }));

      function getPDFMenuURL() {
        return _getPDFMenuURL.apply(this, arguments);
      }

      return getPDFMenuURL;
    }()
  }, {
    key: "setCateringDeliveryPartySize",
    value: function () {
      var _setCateringDeliveryPartySize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee102(partySize) {
        var _this$cartModel30, _this$orderSettingsMo47, _this$cartModel31, _this$cartModel32;

        return _regeneratorRuntime.wrap(function _callee102$(_context102) {
          while (1) {
            switch (_context102.prev = _context102.next) {
              case 0:
                _context102.prev = 0;
                (_this$cartModel30 = this.cartModel) === null || _this$cartModel30 === void 0 ? void 0 : _this$cartModel30.toggleCartContainerLoader(true);
                _context102.next = 4;
                return DPServices.Cart.setCateringDeliveryPartySize({
                  partySize: partySize
                });

              case 4:
                _context102.next = 6;
                return this._loadCart();

              case 6:
                (_this$orderSettingsMo47 = this.orderSettingsModel) === null || _this$orderSettingsMo47 === void 0 ? void 0 : _this$orderSettingsMo47.setDeliveryOrderPartySize(partySize);
                (_this$cartModel31 = this.cartModel) === null || _this$cartModel31 === void 0 ? void 0 : _this$cartModel31.toggleCartContainerLoader(false);
                _context102.next = 14;
                break;

              case 10:
                _context102.prev = 10;
                _context102.t0 = _context102["catch"](0);
                this.handleOrderError(_context102.t0);
                (_this$cartModel32 = this.cartModel) === null || _this$cartModel32 === void 0 ? void 0 : _this$cartModel32.toggleCartContainerLoader(false);

              case 14:
              case "end":
                return _context102.stop();
            }
          }
        }, _callee102, this, [[0, 10]]);
      }));

      function setCateringDeliveryPartySize(_x88) {
        return _setCateringDeliveryPartySize.apply(this, arguments);
      }

      return setCateringDeliveryPartySize;
    }()
  }, {
    key: "fetchRecentOrdersFromLocalStorage",
    value: function () {
      var _fetchRecentOrdersFromLocalStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee103() {
        var data, _this$orderHistoryMod, recentOrdersDataFromAPIInOrder;

        return _regeneratorRuntime.wrap(function _callee103$(_context103) {
          while (1) {
            switch (_context103.prev = _context103.next) {
              case 0:
                _context103.next = 2;
                return this.rootStore.platformUtil.getFromLocalStorage("RECENT_ORDER_DETAILS").then(JSON.parse);

              case 2:
                data = _context103.sent;

                if (data) {
                  recentOrdersDataFromAPIInOrder = orderBy(data, function (order) {
                    var _order$submittedDate;

                    return order === null || order === void 0 ? void 0 : (_order$submittedDate = order.submittedDate) === null || _order$submittedDate === void 0 ? void 0 : _order$submittedDate.time;
                  }, "desc");
                  (_this$orderHistoryMod = this.orderHistoryModel) === null || _this$orderHistoryMod === void 0 ? void 0 : _this$orderHistoryMod.setOrderHistoryData(recentOrdersDataFromAPIInOrder);
                }

              case 4:
              case "end":
                return _context103.stop();
            }
          }
        }, _callee103, this);
      }));

      function fetchRecentOrdersFromLocalStorage() {
        return _fetchRecentOrdersFromLocalStorage.apply(this, arguments);
      }

      return fetchRecentOrdersFromLocalStorage;
    }()
  }, {
    key: "notifyGuestArrival",
    value: function () {
      var _notifyGuestArrival = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee104(resp) {
        var _this$_restaurantDeta16, _this$_restaurantDeta17, _resp$orderSummary, _resp$orderSummary2, _this$rootStore$user$3, _this$rootStore$user$4, _this$rootStore$user$5, _this$rootStore$user$6;

        var ipAddress, deviceId, channel, notifyGeoVicinityEnabled, notifyGeoVicinityThreshold, isTimeinThreshold, userLatitude, userLongitude, _this$_restaurantDeta18, _this$_restaurantDeta19, _this$_restaurantDeta20, _resp$orderSummary3, _resp$orderSummary4, _resp$orderSummary4$g, _resp$orderSummary5, _resp$orderSummary5$g;

        return _regeneratorRuntime.wrap(function _callee104$(_context104) {
          while (1) {
            switch (_context104.prev = _context104.next) {
              case 0:
                _context104.next = 2;
                return this.rootStore.platformUtil.getIpAddress();

              case 2:
                ipAddress = _context104.sent;
                _context104.next = 5;
                return this.rootStore.platformUtil.getDeviceId();

              case 5:
                deviceId = _context104.sent;
                channel = this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP ? "MOBILE_APP" : this.rootStore.isMobile ? "MOBILE_WEB" : "DESKTOP";
                notifyGeoVicinityEnabled = (_this$_restaurantDeta16 = this._restaurantDetail) === null || _this$_restaurantDeta16 === void 0 ? void 0 : _this$_restaurantDeta16.notifyGeoVicinityEnabled;
                notifyGeoVicinityThreshold = (_this$_restaurantDeta17 = this._restaurantDetail) === null || _this$_restaurantDeta17 === void 0 ? void 0 : _this$_restaurantDeta17.notifyGeoVicinityThreshold; // Checking if user time is in b/w pickup-threshold and pickup time, only then making the call

                isTimeinThreshold = notifyGeoVicinityThreshold ? moment().isBetween(moment(resp === null || resp === void 0 ? void 0 : (_resp$orderSummary = resp.orderSummary) === null || _resp$orderSummary === void 0 ? void 0 : _resp$orderSummary.pickUpDateTime).subtract(notifyGeoVicinityThreshold, "m"), moment(resp === null || resp === void 0 ? void 0 : (_resp$orderSummary2 = resp.orderSummary) === null || _resp$orderSummary2 === void 0 ? void 0 : _resp$orderSummary2.pickUpDateTime).add(notifyGeoVicinityThreshold, "m"), undefined, "[]") : false;
                userLatitude = (_this$rootStore$user$3 = this.rootStore.user.currentUserLocation) === null || _this$rootStore$user$3 === void 0 ? void 0 : (_this$rootStore$user$4 = _this$rootStore$user$3.coords) === null || _this$rootStore$user$4 === void 0 ? void 0 : _this$rootStore$user$4.latitude;
                userLongitude = (_this$rootStore$user$5 = this.rootStore.user.currentUserLocation) === null || _this$rootStore$user$5 === void 0 ? void 0 : (_this$rootStore$user$6 = _this$rootStore$user$5.coords) === null || _this$rootStore$user$6 === void 0 ? void 0 : _this$rootStore$user$6.longitude; // To send api only if flag is true and threshold time is less than the rem time

                if (!(notifyGeoVicinityEnabled && isTimeinThreshold && userLatitude && userLongitude)) {
                  _context104.next = 15;
                  break;
                }

                _context104.next = 15;
                return handle(DPServices.Curbside.notifyGuestAtRestaurantVicinity({
                  action: "In",
                  channel: channel,
                  corporationID: (_this$_restaurantDeta18 = this._restaurantDetail) === null || _this$_restaurantDeta18 === void 0 ? void 0 : (_this$_restaurantDeta19 = _this$_restaurantDeta18.corporationNumber) === null || _this$_restaurantDeta19 === void 0 ? void 0 : _this$_restaurantDeta19.corporationNumber,
                  locationNumber: (_this$_restaurantDeta20 = this._restaurantDetail) === null || _this$_restaurantDeta20 === void 0 ? void 0 : _this$_restaurantDeta20.restaurantNum,
                  orderIDs: resp === null || resp === void 0 ? void 0 : (_resp$orderSummary3 = resp.orderSummary) === null || _resp$orderSummary3 === void 0 ? void 0 : _resp$orderSummary3.orderIDs,
                  userLocation: {
                    latitude: userLatitude,
                    longitude: userLongitude
                  },
                  ipAddress: ipAddress,
                  deviceId: deviceId,
                  user: (resp === null || resp === void 0 ? void 0 : (_resp$orderSummary4 = resp.orderSummary) === null || _resp$orderSummary4 === void 0 ? void 0 : (_resp$orderSummary4$g = _resp$orderSummary4.guestName) === null || _resp$orderSummary4$g === void 0 ? void 0 : _resp$orderSummary4$g.firstName) + " " + (resp === null || resp === void 0 ? void 0 : (_resp$orderSummary5 = resp.orderSummary) === null || _resp$orderSummary5 === void 0 ? void 0 : (_resp$orderSummary5$g = _resp$orderSummary5.guestName) === null || _resp$orderSummary5$g === void 0 ? void 0 : _resp$orderSummary5$g.lastName),
                  concept: this._currentConceptCode
                }));

              case 15:
              case "end":
                return _context104.stop();
            }
          }
        }, _callee104, this);
      }));

      function notifyGuestArrival(_x89) {
        return _notifyGuestArrival.apply(this, arguments);
      }

      return notifyGuestArrival;
    }()
  }, {
    key: "validateGeoFence",
    value: function () {
      var _validateGeoFence = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee105(taskId, geofenceNotification, hideNotification) {
        var _tokenDetails, _resp$orderSummary6, _resp$orderSummary7, thresholdTime, timeFromAppInit, tokenDetailsStr, isGeoFenceAlreadyStarted, tokenDetails, token, _tokenDetails2, _tokenDetails3, _tokenDetails4, checkReference, orderId, email, envProps, NEXT_PUBLIC_REACT_APP_CHECK_SUMMARY_API_RETRY_COUNT, NOTIFY_GUEST_ARRIVAL, _yield$handle5, _yield$handle6, _err, resp, pickUpDate, isPickUpTimeSameDay, body, notification, enableGeoFencePushNotification, _resp$orderSummary8, _resp$orderSummary9, _resp$orderSummary10, isCurbsideOrder, _resp$orderSummary11, _resp$orderSummary12, _resp$orderSummary13, _resp$orderSummary14, _resp$orderSummary15, time, isTimeBeforeThreshold, timeSubtractingThreshold, ifCheckInDateTime, showLocalNotification, _this$rootStore44, notificationId, _this$rootStore45, _this$rootStore45$cur, _this$rootStore45$cur2, _notificationId, _time, _this$rootStore46, _this$rootStore46$pla;

        return _regeneratorRuntime.wrap(function _callee105$(_context105) {
          while (1) {
            switch (_context105.prev = _context105.next) {
              case 0:
                _context105.prev = 0;
                timeFromAppInit = this.rootStore.common.appAttributes.configs.estimatedGeoFenceAlertThreshold;
                if (timeFromAppInit) thresholdTime = Number(timeFromAppInit);else thresholdTime = 10;
                _context105.next = 5;
                return this.rootStore.platformUtil.getFromLocalStorage("POS_TOKEN");

              case 5:
                tokenDetailsStr = _context105.sent;
                _context105.next = 8;
                return this.rootStore.platformUtil.isGeoFenceStarted();

              case 8:
                isGeoFenceAlreadyStarted = _context105.sent;
                tokenDetails = null;

                try {
                  if (tokenDetailsStr) {
                    tokenDetails = JSON.parse(tokenDetailsStr);
                  }
                } catch (e) {}

                token = ((_tokenDetails = tokenDetails) === null || _tokenDetails === void 0 ? void 0 : _tokenDetails.checkReference) || null;

                if (!(!tokenDetails || !token)) {
                  _context105.next = 19;
                  break;
                }

                _context105.next = 15;
                return this.removePOSTokenFromLocalStorage();

              case 15:
                if (!isGeoFenceAlreadyStarted) {
                  _context105.next = 18;
                  break;
                }

                _context105.next = 18;
                return this.rootStore.platformUtil.stopGeoFence();

              case 18:
                return _context105.abrupt("return");

              case 19:
                if (!(tokenDetails && !isGeoFenceAlreadyStarted)) {
                  _context105.next = 25;
                  break;
                }

                checkReference = (_tokenDetails2 = tokenDetails) === null || _tokenDetails2 === void 0 ? void 0 : _tokenDetails2.checkReference;
                orderId = (_tokenDetails3 = tokenDetails) === null || _tokenDetails3 === void 0 ? void 0 : _tokenDetails3.orderId;
                email = (_tokenDetails4 = tokenDetails) === null || _tokenDetails4 === void 0 ? void 0 : _tokenDetails4.email;
                _context105.next = 25;
                return handle(this.rootStore.checkout.createGeoFence(checkReference, orderId, email));

              case 25:
                envProps = getEnvProps();
                NEXT_PUBLIC_REACT_APP_CHECK_SUMMARY_API_RETRY_COUNT = envProps === null || envProps === void 0 ? void 0 : envProps.NEXT_PUBLIC_REACT_APP_CHECK_SUMMARY_API_RETRY_COUNT;
                NOTIFY_GUEST_ARRIVAL = envProps === null || envProps === void 0 ? void 0 : envProps.NOTIFY_GUEST_ARRIVAL;
                _context105.next = 30;
                return handle(DPServices.Curbside.getCheckSummary(token, toInteger(NEXT_PUBLIC_REACT_APP_CHECK_SUMMARY_API_RETRY_COUNT, 2)));

              case 30:
                _yield$handle5 = _context105.sent;
                _yield$handle6 = _slicedToArray(_yield$handle5, 2);
                _err = _yield$handle6[0];
                resp = _yield$handle6[1];

                if (!(_err || !resp)) {
                  _context105.next = 41;
                  break;
                }

                _context105.next = 37;
                return this.removePOSTokenFromLocalStorage();

              case 37:
                if (!isGeoFenceAlreadyStarted) {
                  _context105.next = 40;
                  break;
                }

                _context105.next = 40;
                return this.rootStore.platformUtil.stopGeoFence();

              case 40:
                return _context105.abrupt("return");

              case 41:
                pickUpDate = resp !== null && resp !== void 0 && (_resp$orderSummary6 = resp.orderSummary) !== null && _resp$orderSummary6 !== void 0 && _resp$orderSummary6.pickUpDateTime ? moment(resp === null || resp === void 0 ? void 0 : (_resp$orderSummary7 = resp.orderSummary) === null || _resp$orderSummary7 === void 0 ? void 0 : _resp$orderSummary7.pickUpDateTime).format("YYYY-MM-DD") : null;
                console.log("*** geofenceNotification.state", geofenceNotification.state);
                isPickUpTimeSameDay = pickUpDate ? moment().isSame(pickUpDate, "day") : false;

                if (!(geofenceNotification.state === GeoFenceNotificationRegionState.Inside)) {
                  _context105.next = 86;
                  break;
                }

                this.rootStore.curbside.curbsideModel.setGeoFenceEntryTimestamp = moment().format();
                body = i18next.t("notification.curbside_checkin.body", {
                  defaultValue: "Please confirm your parking spot to let us know you are here and your order will be out when it’s ready"
                });
                notification = {
                  title: i18next.t("notification.curbside_checkin.title", {
                    defaultValue: "Check in for your order!"
                  }),
                  body: body
                };
                enableGeoFencePushNotification = this.enableGeoFencePushNotification;
                console.log("*** enableGeoFencePushNotification", enableGeoFencePushNotification);
                console.log("*** resp.orderSummary.orderStatus", resp.orderSummary.orderStatus);

                if (!(resp.orderSummary.orderStatus !== "CLOSED" && resp.orderSummary.orderStatus !== "CANCEL" && resp.orderSummary.orderStatus !== "CHECK_CLOSED" && resp.orderSummary.orderStatus !== "CHECK_CANCELLED" || this.byPassGeofenceOrderStatus)) {
                  _context105.next = 79;
                  break;
                }

                isCurbsideOrder = resp !== null && resp !== void 0 && (_resp$orderSummary8 = resp.orderSummary) !== null && _resp$orderSummary8 !== void 0 && _resp$orderSummary8.fulfillmentMethod ? (resp === null || resp === void 0 ? void 0 : (_resp$orderSummary9 = resp.orderSummary) === null || _resp$orderSummary9 === void 0 ? void 0 : _resp$orderSummary9.fulfillmentMethod) === "CURBSIDE" : true;

                if (!(!(resp !== null && resp !== void 0 && (_resp$orderSummary10 = resp.orderSummary) !== null && _resp$orderSummary10 !== void 0 && _resp$orderSummary10.guestCheckedIn) && isCurbsideOrder)) {
                  _context105.next = 77;
                  break;
                }

                time = moment().isSameOrAfter(moment(resp === null || resp === void 0 ? void 0 : (_resp$orderSummary11 = resp.orderSummary) === null || _resp$orderSummary11 === void 0 ? void 0 : _resp$orderSummary11.pickUpDateTime).subtract(thresholdTime, "m")) && moment().isSameOrBefore(moment(resp === null || resp === void 0 ? void 0 : (_resp$orderSummary12 = resp.orderSummary) === null || _resp$orderSummary12 === void 0 ? void 0 : _resp$orderSummary12.pickUpDateTime).add(thresholdTime, "m"));
                console.log("*** time", time);
                isTimeBeforeThreshold = moment().isSameOrBefore(moment(resp === null || resp === void 0 ? void 0 : (_resp$orderSummary13 = resp.orderSummary) === null || _resp$orderSummary13 === void 0 ? void 0 : _resp$orderSummary13.pickUpDateTime).subtract(thresholdTime, "m"));
                console.log("*** isTimeBeforeThreshold", isTimeBeforeThreshold);
                timeSubtractingThreshold = moment(resp === null || resp === void 0 ? void 0 : (_resp$orderSummary14 = resp.orderSummary) === null || _resp$orderSummary14 === void 0 ? void 0 : _resp$orderSummary14.pickUpDateTime).subtract(thresholdTime, "m").valueOf();
                console.log("*** timeSubtractingThreshold", timeSubtractingThreshold);
                ifCheckInDateTime = resp === null || resp === void 0 ? void 0 : (_resp$orderSummary15 = resp.orderSummary) === null || _resp$orderSummary15 === void 0 ? void 0 : _resp$orderSummary15.checkInDateTime;
                console.log("*** ifCheckInDateTime", ifCheckInDateTime);
                console.log("*** isPickUpTimeSameDay", isPickUpTimeSameDay);
                console.log("*** hideNotification", hideNotification);
                showLocalNotification = enableGeoFencePushNotification && !hideNotification && !ifCheckInDateTime && isPickUpTimeSameDay;
                console.log("*** showLocalNotification", showLocalNotification);

                if (!showLocalNotification) {
                  _context105.next = 76;
                  break;
                }

                if (!isTimeBeforeThreshold) {
                  _context105.next = 75;
                  break;
                }

                _context105.next = 70;
                return this.rootStore.platformUtil.scheduleLocalNotification(notification, timeSubtractingThreshold);

              case 70:
                notificationId = _context105.sent;
                _context105.next = 73;
                return (_this$rootStore44 = this.rootStore) === null || _this$rootStore44 === void 0 ? void 0 : _this$rootStore44.platformUtil.saveInLocalStorage("GEOFENCE_NOTIFICATION_ID", notificationId);

              case 73:
                _context105.next = 76;
                break;

              case 75:
                if (time) {
                  this.rootStore.platformUtil.showLocalNotification(notification);
                }

              case 76:
                if (NOTIFY_GUEST_ARRIVAL === "true" && !hideNotification) {
                  // Send API to SOA for notifying guest arrival
                  handle(this.notifyGuestArrival(resp));
                }

              case 77:
                _context105.next = 84;
                break;

              case 79:
                if ((_this$rootStore45 = this.rootStore) !== null && _this$rootStore45 !== void 0 && (_this$rootStore45$cur = _this$rootStore45.curbside) !== null && _this$rootStore45$cur !== void 0 && (_this$rootStore45$cur2 = _this$rootStore45$cur.curbsideModel) !== null && _this$rootStore45$cur2 !== void 0 && _this$rootStore45$cur2.isCheckInAvailable) {
                  _context105.next = 82;
                  break;
                }

                _context105.next = 82;
                return this.removePOSTokenFromLocalStorage();

              case 82:
                _context105.next = 84;
                return this.rootStore.platformUtil.stopGeoFence();

              case 84:
                _context105.next = 95;
                break;

              case 86:
                if (!(geofenceNotification.state === GeoFenceNotificationRegionState.Outside)) {
                  _context105.next = 95;
                  break;
                }

                this.rootStore.curbside.curbsideModel.setGeoFenceEntryTimestamp = null;
                _context105.next = 90;
                return this.rootStore.platformUtil.getFromLocalStorage("GEOFENCE_NOTIFICATION_ID");

              case 90:
                _notificationId = _context105.sent;
                _time = moment().isSameOrBefore(moment(resp.orderSummary.pickUpDateTime).subtract(thresholdTime, "m"));

                if (!(_time && _notificationId && isPickUpTimeSameDay)) {
                  _context105.next = 95;
                  break;
                }

                _context105.next = 95;
                return (_this$rootStore46 = this.rootStore) === null || _this$rootStore46 === void 0 ? void 0 : (_this$rootStore46$pla = _this$rootStore46.platformUtil) === null || _this$rootStore46$pla === void 0 ? void 0 : _this$rootStore46$pla.cancelScheduledNotification(_notificationId);

              case 95:
                _context105.next = 102;
                break;

              case 97:
                _context105.prev = 97;
                _context105.t0 = _context105["catch"](0);
                console.log("*** 4260 err", _context105.t0);
                _context105.next = 102;
                return this.removePOSTokenFromLocalStorage();

              case 102:
              case "end":
                return _context105.stop();
            }
          }
        }, _callee105, this, [[0, 97]]);
      }));

      function validateGeoFence(_x90, _x91, _x92) {
        return _validateGeoFence.apply(this, arguments);
      }

      return validateGeoFence;
    }()
  }, {
    key: "removePOSTokenFromLocalStorage",
    value: function () {
      var _removePOSTokenFromLocalStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee106() {
        return _regeneratorRuntime.wrap(function _callee106$(_context106) {
          while (1) {
            switch (_context106.prev = _context106.next) {
              case 0:
                _context106.next = 2;
                return this.rootStore.platformUtil.removeFromLocalStorage("POS_TOKEN");

              case 2:
              case "end":
                return _context106.stop();
            }
          }
        }, _callee106, this);
      }));

      function removePOSTokenFromLocalStorage() {
        return _removePOSTokenFromLocalStorage.apply(this, arguments);
      }

      return removePOSTokenFromLocalStorage;
    }()
  }, {
    key: "whenAppActive",
    value: function () {
      var _whenAppActive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee107() {
        var currentUserLocation, geoFenceObj;
        return _regeneratorRuntime.wrap(function _callee107$(_context107) {
          while (1) {
            switch (_context107.prev = _context107.next) {
              case 0:
                this.rootStore.common.timeAtAppActive = Date.now();
                currentUserLocation = this.rootStore.user.currentUserLocation;

                if (!currentUserLocation) {
                  _context107.next = 7;
                  break;
                }

                geoFenceObj = {
                  latitude: currentUserLocation.coords.latitude,
                  longitude: currentUserLocation.coords.longitude,
                  radius: this.geoFenceLocationRadius,
                  state: GeoFenceNotificationRegionState.Inside
                };
                console.log("*** whenAppActive validateGeoFence");
                _context107.next = 7;
                return this.validateGeoFence(null, geoFenceObj, true);

              case 7:
              case "end":
                return _context107.stop();
            }
          }
        }, _callee107, this);
      }));

      function whenAppActive() {
        return _whenAppActive.apply(this, arguments);
      }

      return whenAppActive;
    }()
  }, {
    key: "handleOnDeviceNotification",
    value: function () {
      var _handleOnDeviceNotification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee108() {
        var _this$rootStore47, _this$rootStore47$use, _this$rootStore47$use2, _this$rootStore47$use3, _this$rootStore48, _this$rootStore48$use, _this$rootStore48$use2, _this$rootStore48$use3;

        var geoFenceObj, envProps, CURBSIDE_FLOW_DISABLED, tokenDetailsStr, tokenDetails, checkReference, defaultAPIPrefix, curbsideStore;
        return _regeneratorRuntime.wrap(function _callee108$(_context108) {
          while (1) {
            switch (_context108.prev = _context108.next) {
              case 0:
                geoFenceObj = {
                  latitude: (_this$rootStore47 = this.rootStore) === null || _this$rootStore47 === void 0 ? void 0 : (_this$rootStore47$use = _this$rootStore47.user) === null || _this$rootStore47$use === void 0 ? void 0 : (_this$rootStore47$use2 = _this$rootStore47$use.currentUserLocation) === null || _this$rootStore47$use2 === void 0 ? void 0 : (_this$rootStore47$use3 = _this$rootStore47$use2.coords) === null || _this$rootStore47$use3 === void 0 ? void 0 : _this$rootStore47$use3.latitude,
                  longitude: (_this$rootStore48 = this.rootStore) === null || _this$rootStore48 === void 0 ? void 0 : (_this$rootStore48$use = _this$rootStore48.user) === null || _this$rootStore48$use === void 0 ? void 0 : (_this$rootStore48$use2 = _this$rootStore48$use.currentUserLocation) === null || _this$rootStore48$use2 === void 0 ? void 0 : (_this$rootStore48$use3 = _this$rootStore48$use2.coords) === null || _this$rootStore48$use3 === void 0 ? void 0 : _this$rootStore48$use3.longitude,
                  radius: this.geoFenceLocationRadius,
                  state: GeoFenceNotificationRegionState.Inside
                };
                envProps = getEnvProps();
                CURBSIDE_FLOW_DISABLED = envProps === null || envProps === void 0 ? void 0 : envProps.CURBSIDE_FLOW_DISABLED; // not in initial release
                // const TOKEN_IDENTIFIER =
                //   this.rootStore?.common?.getCurbsideTokenIdentifier();

                _context108.next = 5;
                return this.rootStore.platformUtil.getFromLocalStorage("POS_TOKEN");

              case 5:
                tokenDetailsStr = _context108.sent;
                tokenDetails = null;

                try {
                  if (tokenDetailsStr) {
                    tokenDetails = JSON.parse(tokenDetailsStr);
                  }
                } catch (e) {}

                if (!tokenDetails) {
                  _context108.next = 21;
                  break;
                }

                checkReference = tokenDetails.checkReference;
                defaultAPIPrefix = DPServices.Config.getDefaultAPIPrefix();

                if (!(CURBSIDE_FLOW_DISABLED === "true")) {
                  _context108.next = 20;
                  break;
                }

                curbsideStore = this.rootStore.curbside;
                _context108.next = 15;
                return curbsideStore.loadCheck(checkReference);

              case 15:
                curbsideStore.curbsideModel.checkInSource = CurbsideCheckinSource.DP_GEO_FENCE_PUSH;
                curbsideStore.dispatchCurbsideInitialAnalyticsOnMount();
                this.rootStore.platformUtil.redirectToURL("".concat(defaultAPIPrefix, "/customer-service/curbside-checkin/?source=").concat(CurbsideCheckinSource.DP_GEO_FENCE_PUSH, "&tkn=").concat(checkReference));
                _context108.next = 21;
                break;

              case 20:
                this.rootStore.platformUtil.navigateToRoute("/CurbsideCheckin", [{
                  name: "checkInSource",
                  value: CurbsideCheckinSource.DP_GEO_FENCE_PUSH
                }]);

              case 21:
              case "end":
                return _context108.stop();
            }
          }
        }, _callee108, this);
      }));

      function handleOnDeviceNotification() {
        return _handleOnDeviceNotification.apply(this, arguments);
      }

      return handleOnDeviceNotification;
    }()
  }, {
    key: "waitlistWhenRestaurantClosed",
    value: function () {
      var _waitlistWhenRestaurantClosed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee109() {
        var _this$menuListModel52;

        var _this$rootStore49, _this$rootStore49$pla, _this$rootStore50, _this$rootStore50$pla;

        return _regeneratorRuntime.wrap(function _callee109$(_context109) {
          while (1) {
            switch (_context109.prev = _context109.next) {
              case 0:
                if ((_this$menuListModel52 = this.menuListModel) !== null && _this$menuListModel52 !== void 0 && _this$menuListModel52.showRestStatusFlag) {
                  _context109.next = 7;
                  break;
                }

                _context109.next = 3;
                return this === null || this === void 0 ? void 0 : this.fetchRestaurantsForSearchString();

              case 3:
                this.menuListModel.showRestStatusFlag = true;

                if (((_this$rootStore49 = this.rootStore) === null || _this$rootStore49 === void 0 ? void 0 : (_this$rootStore49$pla = _this$rootStore49.platformUtil) === null || _this$rootStore49$pla === void 0 ? void 0 : _this$rootStore49$pla.PLATFORM_TYPE) === PlatformType.APP) {
                  (_this$rootStore50 = this.rootStore) === null || _this$rootStore50 === void 0 ? void 0 : (_this$rootStore50$pla = _this$rootStore50.platformUtil) === null || _this$rootStore50$pla === void 0 ? void 0 : _this$rootStore50$pla.navigateToRoute("/LocationChangeOverlay");
                }

                _context109.next = 9;
                break;

              case 7:
                _context109.next = 9;
                return this === null || this === void 0 ? void 0 : this.restaurantsAndShowErrWaitlist();

              case 9:
              case "end":
                return _context109.stop();
            }
          }
        }, _callee109, this);
      }));

      function waitlistWhenRestaurantClosed() {
        return _waitlistWhenRestaurantClosed.apply(this, arguments);
      }

      return waitlistWhenRestaurantClosed;
    }()
  }, {
    key: "fetchRestaurantsForSearchString",
    value: function () {
      var _fetchRestaurantsForSearchString = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee110() {
        var _this$locationData, _this$locationData$co, _this$locationData2, _this$locationData2$c;

        var lat, _long, _this$rootStore51, _this$rootStore51$use, locationPermissionsGranted, _this$rootStore52, _this$rootStore52$use, _currentLocation$coor5, _currentLocation$coor6, currentLocation;

        return _regeneratorRuntime.wrap(function _callee110$(_context110) {
          while (1) {
            switch (_context110.prev = _context110.next) {
              case 0:
                // const menuList = this.rootStore?.menuList;
                // const orderSettingsModel = menuList?.orderSettingsModel;
                lat = (_this$locationData = this.locationData) === null || _this$locationData === void 0 ? void 0 : (_this$locationData$co = _this$locationData.coords) === null || _this$locationData$co === void 0 ? void 0 : _this$locationData$co.latitude;
                _long = (_this$locationData2 = this.locationData) === null || _this$locationData2 === void 0 ? void 0 : (_this$locationData2$c = _this$locationData2.coords) === null || _this$locationData2$c === void 0 ? void 0 : _this$locationData2$c.longitude;

                if (this.orderSettingsModel.locationSearchString) {
                  _context110.next = 13;
                  break;
                }

                locationPermissionsGranted = (_this$rootStore51 = this.rootStore) === null || _this$rootStore51 === void 0 ? void 0 : (_this$rootStore51$use = _this$rootStore51.user) === null || _this$rootStore51$use === void 0 ? void 0 : _this$rootStore51$use.foregroundLocationPermissionGranted;

                if (!locationPermissionsGranted) {
                  _context110.next = 11;
                  break;
                }

                currentLocation = (_this$rootStore52 = this.rootStore) === null || _this$rootStore52 === void 0 ? void 0 : (_this$rootStore52$use = _this$rootStore52.user) === null || _this$rootStore52$use === void 0 ? void 0 : _this$rootStore52$use.currentUserLocation;
                this.setLocationData(currentLocation);
                this.orderSettingsModel.locationSearchLabel = "";
                this.orderSettingsModel.locationSearchString = "";
                _context110.next = 11;
                return this.searchRestaurants([currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor5 = currentLocation.coords) === null || _currentLocation$coor5 === void 0 ? void 0 : _currentLocation$coor5.latitude, currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor6 = currentLocation.coords) === null || _currentLocation$coor6 === void 0 ? void 0 : _currentLocation$coor6.longitude]);

              case 11:
                _context110.next = 16;
                break;

              case 13:
                if (!this.orderSettingsModel.locationSearchString) {
                  _context110.next = 16;
                  break;
                }

                _context110.next = 16;
                return this === null || this === void 0 ? void 0 : this.searchRestaurants([lat, _long]);

              case 16:
              case "end":
                return _context110.stop();
            }
          }
        }, _callee110, this);
      }));

      function fetchRestaurantsForSearchString() {
        return _fetchRestaurantsForSearchString.apply(this, arguments);
      }

      return fetchRestaurantsForSearchString;
    }()
  }, {
    key: "restSearchResultsWithIsfavorite",
    value: function restSearchResultsWithIsfavorite(restaurantSearchResults) {
      var _this$rootStore53, _this$rootStore53$use;

      if (!!((_this$rootStore53 = this.rootStore) !== null && _this$rootStore53 !== void 0 && (_this$rootStore53$use = _this$rootStore53.user) !== null && _this$rootStore53$use !== void 0 && _this$rootStore53$use.isLoggedIn)) {
        var _this$rootStore54, _this$rootStore54$use, _this$rootStore54$use2, _this$rootStore54$use3, _this$orderSettingsMo48;

        var favouriteLocations = (_this$rootStore54 = this.rootStore) === null || _this$rootStore54 === void 0 ? void 0 : (_this$rootStore54$use = _this$rootStore54.user) === null || _this$rootStore54$use === void 0 ? void 0 : (_this$rootStore54$use2 = _this$rootStore54$use.userProfile) === null || _this$rootStore54$use2 === void 0 ? void 0 : (_this$rootStore54$use3 = _this$rootStore54$use2.favoriteLocation) === null || _this$rootStore54$use3 === void 0 ? void 0 : _this$rootStore54$use3.map(function (favLocation) {
          return favLocation === null || favLocation === void 0 ? void 0 : favLocation.restaurantInfo;
        });
        var updatedRestaurantSearchResults = restaurantSearchResults === null || restaurantSearchResults === void 0 ? void 0 : restaurantSearchResults.map(function (restaurant) {
          return _objectSpread(_objectSpread({}, restaurant), {}, {
            isFavourite: favouriteLocations === null || favouriteLocations === void 0 ? void 0 : favouriteLocations.includes(restaurant === null || restaurant === void 0 ? void 0 : restaurant.restaurantId)
          });
        });
        (_this$orderSettingsMo48 = this.orderSettingsModel) === null || _this$orderSettingsMo48 === void 0 ? void 0 : _this$orderSettingsMo48.setRestaurantSearchResultsData(updatedRestaurantSearchResults);
        return updatedRestaurantSearchResults;
      }

      return restaurantSearchResults;
    }
  }, {
    key: "reCalculateRestaurantsLocalTime",
    value: function reCalculateRestaurantsLocalTime() {
      var _this$restaurantSearc3, _this$restaurantSearc4;

      var currTime = moment(Date.now());
      var timeAtRestsResponse = moment((_this$restaurantSearc3 = this.restaurantSearchResults) === null || _this$restaurantSearc3 === void 0 ? void 0 : (_this$restaurantSearc4 = _this$restaurantSearc3[0]) === null || _this$restaurantSearc4 === void 0 ? void 0 : _this$restaurantSearc4.timeAtResponse);
      var differnceInTime = currTime === null || currTime === void 0 ? void 0 : currTime.diff(timeAtRestsResponse, "minutes");

      if (differnceInTime < 5) {
        var _DPServices$Common;

        return DPServices === null || DPServices === void 0 ? void 0 : (_DPServices$Common = DPServices.Common) === null || _DPServices$Common === void 0 ? void 0 : _DPServices$Common.processRestaurantDetails(this.restSearchResultsWithIsfavorite(this.restaurantSearchResults));
      } else {
        var _this$locationData3, _this$locationData3$c, _this$locationData4, _this$locationData4$c, _this$orderSettingsMo49, _this$rootStore55, _this$rootStore55$use;

        var lat = (_this$locationData3 = this.locationData) === null || _this$locationData3 === void 0 ? void 0 : (_this$locationData3$c = _this$locationData3.coords) === null || _this$locationData3$c === void 0 ? void 0 : _this$locationData3$c.latitude;

        var _long2 = (_this$locationData4 = this.locationData) === null || _this$locationData4 === void 0 ? void 0 : (_this$locationData4$c = _this$locationData4.coords) === null || _this$locationData4$c === void 0 ? void 0 : _this$locationData4$c.longitude;

        var showUserCoordinates = (_this$orderSettingsMo49 = this.orderSettingsModel) === null || _this$orderSettingsMo49 === void 0 ? void 0 : _this$orderSettingsMo49.showUserCurrentLocation;

        if (showUserCoordinates) {
          this.searchRestaurants([lat, _long2]);
        } else {
          this.searchRestaurantsWithoutDistanceCalculations([lat, _long2]);
        }

        if (!!((_this$rootStore55 = this.rootStore) !== null && _this$rootStore55 !== void 0 && (_this$rootStore55$use = _this$rootStore55.user) !== null && _this$rootStore55$use !== void 0 && _this$rootStore55$use.isLoggedIn)) {
          var _this$rootStore56, _this$rootStore56$use, _this$rootStore56$use2, _this$rootStore56$use3, _this$restaurantSearc5, _this$orderSettingsMo50;

          var favouriteLocations = (_this$rootStore56 = this.rootStore) === null || _this$rootStore56 === void 0 ? void 0 : (_this$rootStore56$use = _this$rootStore56.user) === null || _this$rootStore56$use === void 0 ? void 0 : (_this$rootStore56$use2 = _this$rootStore56$use.userProfile) === null || _this$rootStore56$use2 === void 0 ? void 0 : (_this$rootStore56$use3 = _this$rootStore56$use2.favoriteLocation) === null || _this$rootStore56$use3 === void 0 ? void 0 : _this$rootStore56$use3.map(function (favLocation) {
            return favLocation === null || favLocation === void 0 ? void 0 : favLocation.restaurantInfo;
          });
          var updatedRestaurantSearchResults = (_this$restaurantSearc5 = this.restaurantSearchResults) === null || _this$restaurantSearc5 === void 0 ? void 0 : _this$restaurantSearc5.map(function (restaurant) {
            return _objectSpread(_objectSpread({}, restaurant), {}, {
              isFavourite: favouriteLocations === null || favouriteLocations === void 0 ? void 0 : favouriteLocations.includes(restaurant === null || restaurant === void 0 ? void 0 : restaurant.restaurantId)
            });
          });
          (_this$orderSettingsMo50 = this.orderSettingsModel) === null || _this$orderSettingsMo50 === void 0 ? void 0 : _this$orderSettingsMo50.setRestaurantSearchResultsData(updatedRestaurantSearchResults);
        }

        return this.restaurantSearchResults;
      }
    }
  }, {
    key: "restaurantsAndShowErrWaitlist",
    value: function () {
      var _restaurantsAndShowErrWaitlist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee111() {
        var _this17 = this;

        var errorDescription;
        return _regeneratorRuntime.wrap(function _callee111$(_context111) {
          while (1) {
            switch (_context111.prev = _context111.next) {
              case 0:
                _context111.next = 2;
                return this.fetchRestaurantsForSearchString();

              case 2:
                // Showing err msg for the selected Restaurant as is not available.
                errorDescription = Errors.CREATE_WAITLIST;
                this.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, "Waitlist currently unavailable, please try again later.", [], {
                  okBtnOnClick: function okBtnOnClick() {
                    var _this17$rootStore, _this17$rootStore$pla;

                    return (_this17$rootStore = _this17.rootStore) === null || _this17$rootStore === void 0 ? void 0 : (_this17$rootStore$pla = _this17$rootStore.platformUtil) === null || _this17$rootStore$pla === void 0 ? void 0 : _this17$rootStore$pla.goBack();
                  }
                });
                throw errorDescription;

              case 5:
              case "end":
                return _context111.stop();
            }
          }
        }, _callee111, this);
      }));

      function restaurantsAndShowErrWaitlist() {
        return _restaurantsAndShowErrWaitlist.apply(this, arguments);
      }

      return restaurantsAndShowErrWaitlist;
    }()
  }, {
    key: "menuSearchDebounceHandler",
    value: function menuSearchDebounceHandler(text) {///API Call
    }
  }, {
    key: "searchRestaurantsWithUserLocation",
    value: function () {
      var _searchRestaurantsWithUserLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee112() {
        var _this$rootStore57, _this$rootStore57$use, _this$rootStore58, _this$rootStore58$use, _locationData$coords3, _locationData$coords4, _this$orderSettingsMo51;

        var locationData;
        return _regeneratorRuntime.wrap(function _callee112$(_context112) {
          while (1) {
            switch (_context112.prev = _context112.next) {
              case 0:
                this.orderSettingsModel.locationSearchString = "";
                this.orderSettingsModel.searchedLocationDetail = null;

                if (this.fromLocationSearch) {
                  this.orderSettingsModel.showYouAreHere = true;
                }

                this.showSearchThisArea = false;
                _context112.next = 6;
                return (_this$rootStore57 = this.rootStore) === null || _this$rootStore57 === void 0 ? void 0 : (_this$rootStore57$use = _this$rootStore57.user) === null || _this$rootStore57$use === void 0 ? void 0 : _this$rootStore57$use.obtainUserGeoCoordinates();

              case 6:
                _context112.next = 8;
                return (_this$rootStore58 = this.rootStore) === null || _this$rootStore58 === void 0 ? void 0 : (_this$rootStore58$use = _this$rootStore58.user) === null || _this$rootStore58$use === void 0 ? void 0 : _this$rootStore58$use.currentUserLocation;

              case 8:
                locationData = _context112.sent;
                this.setLocationData(locationData);
                this.searchRestaurants([locationData === null || locationData === void 0 ? void 0 : (_locationData$coords3 = locationData.coords) === null || _locationData$coords3 === void 0 ? void 0 : _locationData$coords3.latitude, locationData === null || locationData === void 0 ? void 0 : (_locationData$coords4 = locationData.coords) === null || _locationData$coords4 === void 0 ? void 0 : _locationData$coords4.longitude]);
                (_this$orderSettingsMo51 = this.orderSettingsModel) === null || _this$orderSettingsMo51 === void 0 ? void 0 : _this$orderSettingsMo51.setLocationSearchTab(WEB_LOCATION_SEARCH_THREE_TAB_NAMES.NEARBY);

              case 12:
              case "end":
                return _context112.stop();
            }
          }
        }, _callee112, this);
      }));

      function searchRestaurantsWithUserLocation() {
        return _searchRestaurantsWithUserLocation.apply(this, arguments);
      }

      return searchRestaurantsWithUserLocation;
    }()
  }, {
    key: "dispatchUserChangeLocationEvent",
    value: function dispatchUserChangeLocationEvent() {
      this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "USER_CHANGE_LOCATION", {});
    }
  }, {
    key: "dispatchInitialUserLocationModal",
    value: function dispatchInitialUserLocationModal() {
      this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "LOCATION_MODAL_SHOWN", {});
    }
  }, {
    key: "dispatchCartViewEvent",
    value: function dispatchCartViewEvent() {
      var _this$cartModel33;

      var cartId = (_this$cartModel33 = this.cartModel) === null || _this$cartModel33 === void 0 ? void 0 : _this$cartModel33.orderId;
      var breadStickItems = this.breadSticksModel.breadStickItems;
      var totalBreadCount = this.breadSticksModel.totalBreadCount;
      var payload = [breadStickItems, {
        totalBreadCount: totalBreadCount,
        "&&events": "event165:".concat(cartId)
      }];
      this.analyticsModel.dispatchCartViewEvent(payload);
    }
  }, {
    key: "dispatchMenuBrowseEvent",
    value: function dispatchMenuBrowseEvent() {
      var _this$cartModel34;

      var cartId = (_this$cartModel34 = this.cartModel) === null || _this$cartModel34 === void 0 ? void 0 : _this$cartModel34.orderId;
      var payload = {
        "&&events": "event163:".concat(cartId)
      };
      this.analyticsModel.dispatchMenuBrowseEvent(payload);
    }
  }, {
    key: "getWaitlistId",
    value: function () {
      var _getWaitlistId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee113() {
        var _this$rootStore59, _this$rootStore59$pla;

        return _regeneratorRuntime.wrap(function _callee113$(_context113) {
          while (1) {
            switch (_context113.prev = _context113.next) {
              case 0:
                _context113.next = 2;
                return (_this$rootStore59 = this.rootStore) === null || _this$rootStore59 === void 0 ? void 0 : (_this$rootStore59$pla = _this$rootStore59.platformUtil) === null || _this$rootStore59$pla === void 0 ? void 0 : _this$rootStore59$pla.getFromLocalStorage("WAITLIST_ID");

              case 2:
                return _context113.abrupt("return", _context113.sent);

              case 3:
              case "end":
                return _context113.stop();
            }
          }
        }, _callee113, this);
      }));

      function getWaitlistId() {
        return _getWaitlistId.apply(this, arguments);
      }

      return getWaitlistId;
    }()
  }, {
    key: "restaurantSearchResults",
    get: function get() {
      return this._restaurantSearchResults;
    },
    set: function set(_restaurantSearchResults) {
      var _this18 = this;

      runInAction(function () {
        _this18._restaurantSearchResults = _restaurantSearchResults;
      });
    }
  }, {
    key: "mapStyle",
    get: function get() {
      var _this$appAttributes, _this$appAttributes$c, _this$appAttributes2, _this$appAttributes2$, _this$appAttributes3, _this$appAttributes3$;

      var mapBoxAccessToken = (_this$appAttributes = this.appAttributes) === null || _this$appAttributes === void 0 ? void 0 : (_this$appAttributes$c = _this$appAttributes.configs) === null || _this$appAttributes$c === void 0 ? void 0 : _this$appAttributes$c.mapBoxAccessToken;
      var mapStyle = (_this$appAttributes2 = this.appAttributes) !== null && _this$appAttributes2 !== void 0 && (_this$appAttributes2$ = _this$appAttributes2.configs) !== null && _this$appAttributes2$ !== void 0 && _this$appAttributes2$.mapBoxStaticAPI ? (_this$appAttributes3 = this.appAttributes) === null || _this$appAttributes3 === void 0 ? void 0 : (_this$appAttributes3$ = _this$appAttributes3.configs) === null || _this$appAttributes3$ === void 0 ? void 0 : _this$appAttributes3$.mapBoxStaticAPI.split("/static")[0] : "";
      return mapStyle ? "".concat(mapStyle, "?access_token=").concat(mapBoxAccessToken) : undefined;
    }
  }, {
    key: "isLocationSelectionMandatory",
    get: function get() {
      var _this$cartModel35, _this$appAttributes4, _this$appAttributes4$;

      return !this.restaurantId && (!!((_this$cartModel35 = this.cartModel) !== null && _this$cartModel35 !== void 0 && _this$cartModel35.noOfCartItems) || ((_this$appAttributes4 = this.appAttributes) === null || _this$appAttributes4 === void 0 ? void 0 : (_this$appAttributes4$ = _this$appAttributes4.configs) === null || _this$appAttributes4$ === void 0 ? void 0 : _this$appAttributes4$.enableDefaultMenu) !== "true");
    }
  }, {
    key: "menuList",
    get: function get() {
      return this._menuList;
    },
    set: function set(val) {
      var _this19 = this;

      runInAction(function () {
        _this19._menuList = val;
      });
    }
  }, {
    key: "showHeaderHamburgerMenu",
    get: function get() {
      return this._showHeaderHamburgerMenu;
    },
    set: function set(flag) {
      var _this20 = this;

      runInAction(function () {
        _this20._showHeaderHamburgerMenu = flag;
      });
    }
  }, {
    key: "isCartShown",
    get: function get() {
      return this._isCartShown;
    },
    set: function set(flag) {
      var _this21 = this;

      runInAction(function () {
        _this21._isCartShown = flag;
      });
    }
  }, {
    key: "restaurantId",
    get: function get() {
      var _this$orderSettingsMo52;

      return (_this$orderSettingsMo52 = this.orderSettingsModel) === null || _this$orderSettingsMo52 === void 0 ? void 0 : _this$orderSettingsMo52.currentRestaurantId;
    }
  }, {
    key: "showDateAndTime",
    get: function get() {
      var _this$orderSettingsMo53, _this$orderSettingsMo54;

      return ((_this$orderSettingsMo53 = this.orderSettingsModel) === null || _this$orderSettingsMo53 === void 0 ? void 0 : _this$orderSettingsMo53.locationTimeConfirmed) || !!((_this$orderSettingsMo54 = this.orderSettingsModel) !== null && _this$orderSettingsMo54 !== void 0 && _this$orderSettingsMo54.pickupDateTimeSelected);
    }
  }, {
    key: "locationData",
    get: function get() {
      return this._locationData;
    }
  }, {
    key: "menuDetailsRecommendationsThreshold",
    get: function get() {
      var _this$appAttributes5, _this$appAttributes5$;

      return +((_this$appAttributes5 = this.appAttributes) === null || _this$appAttributes5 === void 0 ? void 0 : (_this$appAttributes5$ = _this$appAttributes5.configs) === null || _this$appAttributes5$ === void 0 ? void 0 : _this$appAttributes5$.productDetailsSmartRecThreshold);
    }
  }, {
    key: "menuDetailsRecommendationsMboxName",
    get: function get() {
      var _this$appAttributes6, _this$appAttributes6$;

      return (_this$appAttributes6 = this.appAttributes) === null || _this$appAttributes6 === void 0 ? void 0 : (_this$appAttributes6$ = _this$appAttributes6.configs) === null || _this$appAttributes6$ === void 0 ? void 0 : _this$appAttributes6$.productDetailsSmartRecMboxName;
    }
  }, {
    key: "upsellRecommendationsThreshold",
    get: function get() {
      var _this$appAttributes7, _this$appAttributes7$;

      return +((_this$appAttributes7 = this.appAttributes) === null || _this$appAttributes7 === void 0 ? void 0 : (_this$appAttributes7$ = _this$appAttributes7.configs) === null || _this$appAttributes7$ === void 0 ? void 0 : _this$appAttributes7$.shoppingCartSmartRecThreshold);
    }
  }, {
    key: "upsellRecommendationsMboxName",
    get: function get() {
      var _this$appAttributes8, _this$appAttributes8$;

      return (_this$appAttributes8 = this.appAttributes) === null || _this$appAttributes8 === void 0 ? void 0 : (_this$appAttributes8$ = _this$appAttributes8.configs) === null || _this$appAttributes8$ === void 0 ? void 0 : _this$appAttributes8$.shoppingCartSmartRecMboxName;
    }
  }, {
    key: "frequentlyOrderedRecommendationsThreshold",
    get: function get() {
      var _this$appAttributes9, _this$appAttributes9$;

      return +((_this$appAttributes9 = this.appAttributes) === null || _this$appAttributes9 === void 0 ? void 0 : (_this$appAttributes9$ = _this$appAttributes9.configs) === null || _this$appAttributes9$ === void 0 ? void 0 : _this$appAttributes9$.menuGridSmartRecThreshold);
    }
  }, {
    key: "frequentlyOrderedRecommendationsMboxName",
    get: function get() {
      var _this$appAttributes10, _this$appAttributes11;

      return (_this$appAttributes10 = this.appAttributes) === null || _this$appAttributes10 === void 0 ? void 0 : (_this$appAttributes11 = _this$appAttributes10.configs) === null || _this$appAttributes11 === void 0 ? void 0 : _this$appAttributes11.menuBrowseSmartRecMboxName;
    }
  }, {
    key: "guestPicksRecommendationsMboxName",
    get: function get() {
      var _this$appAttributes12, _this$appAttributes13;

      return (_this$appAttributes12 = this.appAttributes) === null || _this$appAttributes12 === void 0 ? void 0 : (_this$appAttributes13 = _this$appAttributes12.configs) === null || _this$appAttributes13 === void 0 ? void 0 : _this$appAttributes13.menuGridSmartRecMboxName;
    }
  }, {
    key: "escapeLocationSelectionForDIPO",
    get: function get() {
      if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
        var _this$rootStore60, _this$rootStore60$pla, _this$rootStore60$pla2, _this$rootStore60$pla3;

        var url = (_this$rootStore60 = this.rootStore) === null || _this$rootStore60 === void 0 ? void 0 : (_this$rootStore60$pla = _this$rootStore60.platformUtil) === null || _this$rootStore60$pla === void 0 ? void 0 : (_this$rootStore60$pla2 = _this$rootStore60$pla.navHistory()) === null || _this$rootStore60$pla2 === void 0 ? void 0 : (_this$rootStore60$pla3 = _this$rootStore60$pla2.state) === null || _this$rootStore60$pla3 === void 0 ? void 0 : _this$rootStore60$pla3.url;
        var isDIPOEnabled = url.includes("orderType=dinein") && this.rootStore.user.sessionDetails.successResponse.sessionContext.orderTypeValue !== 5;

        if (isDIPOEnabled) {
          return true;
        }

        return false;
      }

      return false;
    }
  }, {
    key: "breadCrumbLinks",
    get: function get() {
      var _this$menuListModel53, _this$menuListModel54, _this$menuDetailModel17, _this$menuDetailModel18;

      var categories = (_this$menuListModel53 = this.menuListModel) === null || _this$menuListModel53 === void 0 ? void 0 : (_this$menuListModel54 = _this$menuListModel53.menuListData) === null || _this$menuListModel54 === void 0 ? void 0 : _this$menuListModel54.categories;
      var breadCrumb = (_this$menuDetailModel17 = this.menuDetailModel) === null || _this$menuDetailModel17 === void 0 ? void 0 : (_this$menuDetailModel18 = _this$menuDetailModel17.menuItem) === null || _this$menuDetailModel18 === void 0 ? void 0 : _this$menuDetailModel18.breadCrumbSlug;
      var slugs = breadCrumb === null || breadCrumb === void 0 ? void 0 : breadCrumb.split("/");
      var links = {
        categoryName: {
          name: "",
          link: ""
        },
        subCategoryName: {
          name: "",
          link: ""
        },
        subSubCategoryName: {
          name: "",
          link: ""
        }
      };
      categories === null || categories === void 0 ? void 0 : categories.filter(function (currentCategory) {
        if ((currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.code) === (slugs === null || slugs === void 0 ? void 0 : slugs[0])) {
          links.categoryName = {
            name: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name,
            link: slugs === null || slugs === void 0 ? void 0 : slugs[0]
          }; // sub category

          currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.subCategories.filter(function (currentSubCategory) {
            if ((currentSubCategory === null || currentSubCategory === void 0 ? void 0 : currentSubCategory.code) === (slugs === null || slugs === void 0 ? void 0 : slugs[1])) {
              var _currentSubCategory$s;

              links.subCategoryName = {
                name: currentSubCategory === null || currentSubCategory === void 0 ? void 0 : currentSubCategory.name,
                link: slugs === null || slugs === void 0 ? void 0 : slugs[1]
              }; // sub sub category

              currentSubCategory === null || currentSubCategory === void 0 ? void 0 : (_currentSubCategory$s = currentSubCategory.subSubCategories) === null || _currentSubCategory$s === void 0 ? void 0 : _currentSubCategory$s.filter(function (currentSubSubCategory) {
                if ((currentSubSubCategory === null || currentSubSubCategory === void 0 ? void 0 : currentSubSubCategory.code) === (slugs === null || slugs === void 0 ? void 0 : slugs[2])) {
                  links.subSubCategoryName = {
                    name: currentSubSubCategory === null || currentSubSubCategory === void 0 ? void 0 : currentSubSubCategory.name,
                    link: slugs === null || slugs === void 0 ? void 0 : slugs[2]
                  };
                }
              });
            }
          });
        }
      });
      return links;
    }
  }, {
    key: "customMapMarker",
    get: function get() {
      var _this$appAttributes14, _this$appAttributes15;

      return (_this$appAttributes14 = this.appAttributes) === null || _this$appAttributes14 === void 0 ? void 0 : (_this$appAttributes15 = _this$appAttributes14.configs) === null || _this$appAttributes15 === void 0 ? void 0 : _this$appAttributes15.mapMarkerUrl;
    }
  }, {
    key: "isDipo",
    get: function get() {
      var _this$rootStore61, _this$rootStore61$use, _this$rootStore61$use2, _this$rootStore61$use3, _this$rootStore61$use4;

      return ((_this$rootStore61 = this.rootStore) === null || _this$rootStore61 === void 0 ? void 0 : (_this$rootStore61$use = _this$rootStore61.user) === null || _this$rootStore61$use === void 0 ? void 0 : (_this$rootStore61$use2 = _this$rootStore61$use.sessionDetails) === null || _this$rootStore61$use2 === void 0 ? void 0 : (_this$rootStore61$use3 = _this$rootStore61$use2.successResponse) === null || _this$rootStore61$use3 === void 0 ? void 0 : (_this$rootStore61$use4 = _this$rootStore61$use3.sessionContext) === null || _this$rootStore61$use4 === void 0 ? void 0 : _this$rootStore61$use4.orderTypeValue) === 5;
    }
  }, {
    key: "enableGeoFence",
    get: function get() {
      var _this$rootStore$resta;

      var restDetail = (_this$rootStore$resta = this.rootStore.restaurant) === null || _this$rootStore$resta === void 0 ? void 0 : _this$rootStore$resta.detail;
      var appConfigs = this.rootStore.common.appAttributes.configs;

      if (appConfigs.enableGeoFence) {
        return restDetail.enableGeoFence;
      } else return false;
    }
  }, {
    key: "geoFenceLocationRadius",
    get: function get() {
      var _this$rootStore$resta2;

      var restDetail = (_this$rootStore$resta2 = this.rootStore.restaurant) === null || _this$rootStore$resta2 === void 0 ? void 0 : _this$rootStore$resta2.detail;
      var appAttr = this.rootStore.common.appAttributes.configs;

      if (restDetail && restDetail.geoFenceLocationRadius) {
        return restDetail.geoFenceLocationRadius;
      } else {
        return Number(appAttr.geoFenceLocationRadius) || 0;
      }
    }
  }, {
    key: "enableGeoFencePushNotification",
    get: function get() {
      var _this$rootStore62, _this$rootStore62$res;

      var restDetail = (_this$rootStore62 = this.rootStore) === null || _this$rootStore62 === void 0 ? void 0 : (_this$rootStore62$res = _this$rootStore62.restaurant) === null || _this$rootStore62$res === void 0 ? void 0 : _this$rootStore62$res.detail;
      var appAttr = this.rootStore.common.appAttributes;

      if (restDetail.enableGeoFencePushNotification || appAttr.enableGeoFencePushNotification) {
        return restDetail.enableGeoFencePushNotification ? restDetail.enableGeoFencePushNotification : appAttr.enableGeoFencePushNotification;
      } else return false;
    }
  }, {
    key: "showGeoFenceAlert",
    get: function get() {
      return this._showGeoFenceAlert;
    },
    set: function set(val) {
      var _this22 = this;

      runInAction(function () {
        _this22._showGeoFenceAlert = val;
      });
    }
  }, {
    key: "locationTimeExplicitlySelected",
    get: function get() {
      return this._locationTimeExplicitlySelected;
    },
    set: function set(locationTimeExplicitlySelected) {
      var _this23 = this;

      runInAction(function () {
        _this23._locationTimeExplicitlySelected = locationTimeExplicitlySelected;
      });
    }
  }, {
    key: "hidePickupTime",
    get: function get() {
      try {
        var _this$_restaurantDeta21, _this$_restaurantDeta22, _this$rootStore63, _this$rootStore63$res, _this$_restaurantDeta23, _this$timeModel$capac, _this$timeModel$capac2;

        var timezone = (_this$_restaurantDeta21 = this._restaurantDetail) === null || _this$_restaurantDeta21 === void 0 ? void 0 : (_this$_restaurantDeta22 = _this$_restaurantDeta21.address) === null || _this$_restaurantDeta22 === void 0 ? void 0 : _this$_restaurantDeta22.timeZone;
        var restDetailModel = (_this$rootStore63 = this.rootStore) === null || _this$rootStore63 === void 0 ? void 0 : (_this$rootStore63$res = _this$rootStore63.restaurant) === null || _this$rootStore63$res === void 0 ? void 0 : _this$rootStore63$res.restaurantDetailModel;
        var isCurrentDayInClosedDays;
        var closedDays = ((_this$_restaurantDeta23 = this._restaurantDetail) === null || _this$_restaurantDeta23 === void 0 ? void 0 : _this$_restaurantDeta23.closedDays) || [];

        if (closedDays.length > 0) {
          isCurrentDayInClosedDays = restDetailModel === null || restDetailModel === void 0 ? void 0 : restDetailModel.isRestaurantClosed(timezone, closedDays, 0);
        }

        var closedToday = (_this$timeModel$capac = this.timeModel.capacitySlotsResponse) === null || _this$timeModel$capac === void 0 ? void 0 : _this$timeModel$capac.closedToday;
        var restaurantClosed = (_this$timeModel$capac2 = this.timeModel.capacitySlotsResponse) === null || _this$timeModel$capac2 === void 0 ? void 0 : _this$timeModel$capac2.restaurantClosed;
        var locationTimeExplicitlySelected = this._locationTimeExplicitlySelected;
        var isRestClosedToday = isCurrentDayInClosedDays || closedToday || restaurantClosed;
        return isRestClosedToday && !locationTimeExplicitlySelected;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "showSearchThisArea",
    get: function get() {
      return this._showSearchThisArea;
    },
    set: function set(val) {
      var _this24 = this;

      runInAction(function () {
        _this24._showSearchThisArea = val;
      });
    }
  }, {
    key: "locationCoordsArrayForMap",
    get: function get() {
      var _this$rootStore64, _this$rootStore64$use, _this$orderSettingsMo55, _this$orderSettingsMo56, _this$orderSettingsMo57, _this$orderSettingsMo58, _this$orderSettingsMo59, _this$rootStore65, _this$rootStore65$res, _this$rootStore66, _this$rootStore66$res, _this$orderSettingsMo60;

      var isLoggedIn = (_this$rootStore64 = this.rootStore) === null || _this$rootStore64 === void 0 ? void 0 : (_this$rootStore64$use = _this$rootStore64.user) === null || _this$rootStore64$use === void 0 ? void 0 : _this$rootStore64$use.isLoggedIn;
      var isNearbyLocationsTab = ((_this$orderSettingsMo55 = this.orderSettingsModel) === null || _this$orderSettingsMo55 === void 0 ? void 0 : _this$orderSettingsMo55.locationSearchTab) === WEB_LOCATION_SEARCH_TAB_NAMES.NEARBY;
      var isNearbyThreeTabLocationsTab = ((_this$orderSettingsMo56 = this.orderSettingsModel) === null || _this$orderSettingsMo56 === void 0 ? void 0 : _this$orderSettingsMo56.locationSearchTab) === WEB_LOCATION_SEARCH_THREE_TAB_NAMES.NEARBY;
      var isFavoriteLocationsTab = ((_this$orderSettingsMo57 = this.orderSettingsModel) === null || _this$orderSettingsMo57 === void 0 ? void 0 : _this$orderSettingsMo57.locationSearchTab) === WEB_LOCATION_SEARCH_THREE_TAB_NAMES.FAVORITES;
      var isRecentLocationsTab = ((_this$orderSettingsMo58 = this.orderSettingsModel) === null || _this$orderSettingsMo58 === void 0 ? void 0 : _this$orderSettingsMo58.locationSearchTab) === WEB_LOCATION_SEARCH_THREE_TAB_NAMES.RECENT;
      var restaurantSearchResults = ((_this$orderSettingsMo59 = this.orderSettingsModel) === null || _this$orderSettingsMo59 === void 0 ? void 0 : _this$orderSettingsMo59.restaurantSearchResults) || [];
      var recentRestaurants = ((_this$rootStore65 = this.rootStore) === null || _this$rootStore65 === void 0 ? void 0 : (_this$rootStore65$res = _this$rootStore65.restaurant) === null || _this$rootStore65$res === void 0 ? void 0 : _this$rootStore65$res.recentRestaurants) || [];
      var favRestaurants = ((_this$rootStore66 = this.rootStore) === null || _this$rootStore66 === void 0 ? void 0 : (_this$rootStore66$res = _this$rootStore66.restaurant) === null || _this$rootStore66$res === void 0 ? void 0 : _this$rootStore66$res.favoriteRestaurants) || [];

      if (this.fromLocationSearch) {
        if (isNearbyThreeTabLocationsTab) {
          return restaurantSearchResults;
        } else if (isFavoriteLocationsTab) {
          return favRestaurants;
        } else if (isRecentLocationsTab) {
          return recentRestaurants;
        }
      }

      if (this.fromLocationSearch) {
        if (isNearbyLocationsTab) {
          return restaurantSearchResults;
        }

        return isLoggedIn ? [].concat(_toConsumableArray(recentRestaurants), _toConsumableArray(favRestaurants)) : [];
      }

      return (_this$orderSettingsMo60 = this.orderSettingsModel) === null || _this$orderSettingsMo60 === void 0 ? void 0 : _this$orderSettingsMo60.restaurantSearchResults;
    }
  }, {
    key: "byPassGeofenceOrderStatus",
    get: function get() {
      return this._byPassGeofenceOrderStatus;
    },
    set: function set(val) {
      var _this25 = this;

      runInAction(function () {
        _this25._byPassGeofenceOrderStatus = val;
      });
    }
  }, {
    key: "orderTypeDescription",
    get: function get() {
      var _this$menuListModel55;

      var orderType = "Pickup";

      switch ((_this$menuListModel55 = this.menuListModel) === null || _this$menuListModel55 === void 0 ? void 0 : _this$menuListModel55.orderType) {
        case ORDER_TYPE.CATERING_DELIVERY:
          orderType = "Delivery";
          break;

        case ORDER_TYPE.TOGO_PICKUP:
          break;

        case ORDER_TYPE.CATERING_PICKUP:
          break;

        case ORDER_TYPE.ORDER_AHEAD:
          orderType = i18next.t("label.dipo.order_type", {
            defaultValue: "Dine-In Pre-Order"
          });
          break;

        default:
          break;
      }

      return orderType;
    }
  }, {
    key: "displayDate",
    get: function get() {
      var displayDate;
      var splitDisplayDate = this.timeModel.displayDate.split(",");
      var date = !!(splitDisplayDate !== null && splitDisplayDate !== void 0 && splitDisplayDate[1]) ? getDateInSuperScriptForm(splitDisplayDate === null || splitDisplayDate === void 0 ? void 0 : splitDisplayDate[0].concat(", ", splitDisplayDate === null || splitDisplayDate === void 0 ? void 0 : splitDisplayDate[1])) : splitDisplayDate === null || splitDisplayDate === void 0 ? void 0 : splitDisplayDate[0];
      var time = splitDisplayDate[2];
      displayDate = [date, time];
      return displayDate;
    }
  }, {
    key: "userUniqueId",
    get: function get() {
      return this._userUniqueId;
    },
    set: function set(val) {
      var _this26 = this;

      runInAction(function () {
        _this26._userUniqueId = val;
      });
    }
  }]);

  return MenuList;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "menu", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_currentConceptCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "loading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {
      menuList: false,
      menuDetails: false
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_locationData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_isReorderAddToCart", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_isReorderAddAllToCart", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_menuList", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_showHeaderHamburgerMenu", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_isCartShown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_showGeoFenceAlert", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_locationTimeExplicitlySelected", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_restaurantSearchResults", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_showSearchThisArea", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_byPassGeofenceOrderStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_userUniqueId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "restaurantSearchResults", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantSearchResults"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mapStyle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapStyle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLocationSelectionMandatory", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLocationSelectionMandatory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menuList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menuList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showHeaderHamburgerMenu", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showHeaderHamburgerMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCartShown", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCartShown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDateAndTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showDateAndTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menuDetailsRecommendationsThreshold", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menuDetailsRecommendationsThreshold"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menuDetailsRecommendationsMboxName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menuDetailsRecommendationsMboxName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "upsellRecommendationsThreshold", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "upsellRecommendationsThreshold"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "upsellRecommendationsMboxName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "upsellRecommendationsMboxName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "frequentlyOrderedRecommendationsThreshold", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "frequentlyOrderedRecommendationsThreshold"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "frequentlyOrderedRecommendationsMboxName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "frequentlyOrderedRecommendationsMboxName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "guestPicksRecommendationsMboxName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "guestPicksRecommendationsMboxName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "processSelectedRestaurant", [action], Object.getOwnPropertyDescriptor(_class.prototype, "processSelectedRestaurant"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "storeReset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "storeReset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_processAppAttributes", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_processAppAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_processSessionDetails", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_processSessionDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "init", [action], Object.getOwnPropertyDescriptor(_class.prototype, "init"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "escapeLocationSelectionForDIPO", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "escapeLocationSelectionForDIPO"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openLocationSearchModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openLocationSearchModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_loadPageData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_loadPageData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_loadRecommendations", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_loadRecommendations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchRestaurants", [action], Object.getOwnPropertyDescriptor(_class.prototype, "searchRestaurants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchRestaurantsWithoutDistanceCalculations", [action], Object.getOwnPropertyDescriptor(_class.prototype, "searchRestaurantsWithoutDistanceCalculations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_searchRestaurants", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_searchRestaurants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetchTimes", [action], Object.getOwnPropertyDescriptor(_class.prototype, "fetchTimes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryToPickupSwitch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryToPickupSwitch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onLocationConfirmChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onLocationConfirmChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTimeConfirmChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTimeConfirmChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onLocationTimeConfirm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onLocationTimeConfirm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reOrderAddAllToCart", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reOrderAddAllToCart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reOrderAddToCart", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reOrderAddToCart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addToCart", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addToCart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "parseOrderError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "parseOrderError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCart", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateCart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleItemCourse", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleItemCourse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateQuantity", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateQuantity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteCartItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteCartItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editCartItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "editCartItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "prepareForCartItemEdit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "prepareForCartItemEdit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeLocationConfirmation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "timeLocationConfirmation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "duplicateCartItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "duplicateCartItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveToCart", [action], Object.getOwnPropertyDescriptor(_class.prototype, "saveToCart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearCart", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearCart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tryCheckout", [action], Object.getOwnPropertyDescriptor(_class.prototype, "tryCheckout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "doCheckout", [action], Object.getOwnPropertyDescriptor(_class.prototype, "doCheckout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "breadCrumbLinks", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "breadCrumbLinks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "customMapMarker", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "customMapMarker"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDipo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDipo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableGeoFence", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "enableGeoFence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "geoFenceLocationRadius", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "geoFenceLocationRadius"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableGeoFencePushNotification", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "enableGeoFencePushNotification"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "whenAppActive", [action], Object.getOwnPropertyDescriptor(_class.prototype, "whenAppActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showGeoFenceAlert", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showGeoFenceAlert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationTimeExplicitlySelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationTimeExplicitlySelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hidePickupTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hidePickupTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSearchThisArea", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSearchThisArea"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationCoordsArrayForMap", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationCoordsArrayForMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "byPassGeofenceOrderStatus", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "byPassGeofenceOrderStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderTypeDescription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderTypeDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userUniqueId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userUniqueId"), _class.prototype)), _class);
export { MenuList as default };